var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _path937, _path938, _path939, _path940, _path941, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _path955, _path956, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _path981, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _path993, _path994, _path995, _path996, _path997, _path998, _path999, _path1000, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _path1070, _path1071, _path1072, _path1073, _path1074, _path1075, _path1076, _path1077, _path1078, _path1079, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _path1086, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _path1122, _path1123, _path1124, _path1125, _path1126, _path1127, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _path1143, _path1144, _path1145, _path1146, _path1147, _path1148, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _path1183, _path1184, _path1185, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _path1199, _path1200, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _path1390, _path1391, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _path1462, _path1463, _path1464, _path1465, _path1466, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _path1522, _path1523, _path1524, _path1525, _path1526, _path1527, _path1528, _path1529, _path1530, _path1531, _path1532, _path1533, _path1534, _path1535, _path1536, _path1537, _path1538, _path1539, _path1540, _path1541, _path1542, _path1543, _path1544, _path1545, _path1546, _path1547, _path1548, _path1549, _path1550, _path1551, _path1552, _path1553, _path1554, _path1555, _path1556, _path1557, _path1558, _path1559, _path1560, _path1561, _path1562, _path1563, _path1564, _path1565, _path1566, _path1567, _path1568, _path1569, _path1570, _path1571, _path1572, _path1573, _path1574, _path1575, _path1576, _path1577, _path1578, _path1579, _path1580, _path1581, _path1582, _path1583, _path1584, _path1585, _path1586, _path1587, _path1588, _path1589, _path1590, _path1591, _path1592, _path1593, _path1594, _path1595, _path1596, _path1597, _path1598, _path1599, _path1600, _path1601, _path1602, _path1603, _path1604, _path1605, _path1606, _path1607, _path1608, _path1609, _path1610, _path1611, _path1612, _path1613, _path1614, _path1615, _path1616, _path1617, _path1618, _path1619, _path1620, _path1621, _path1622, _path1623, _path1624, _path1625, _path1626, _path1627, _path1628, _path1629, _path1630, _path1631, _path1632, _path1633, _path1634, _path1635, _path1636, _path1637, _path1638, _path1639, _path1640, _path1641, _path1642, _path1643, _path1644, _path1645, _path1646, _path1647, _path1648, _path1649, _path1650, _path1651, _path1652, _path1653, _path1654, _path1655, _path1656, _path1657, _path1658, _path1659, _path1660, _path1661, _path1662, _path1663, _path1664, _path1665, _path1666, _path1667, _path1668, _path1669, _path1670, _path1671, _path1672, _path1673, _path1674, _path1675, _path1676, _path1677, _path1678, _path1679, _path1680, _path1681, _path1682, _path1683, _path1684, _path1685, _path1686, _path1687, _path1688, _path1689, _path1690, _path1691, _path1692, _path1693, _path1694, _path1695, _path1696, _path1697, _path1698, _path1699, _path1700, _path1701, _path1702, _path1703, _path1704;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNdgLogoOfficialSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1024,
    height: 1024,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.1328125 -0.37231445 3.1328125 -0.37231445 7.125 -0.36328125 C7.8277002 -0.36377975 8.53040039 -0.36427826 9.25439453 -0.36479187 C10.74058865 -0.36245061 12.22678667 -0.35271888 13.71289062 -0.33618164 C15.99124505 -0.31259065 18.26842953 -0.31561934 20.546875 -0.32226562 C31.72092744 -0.27907256 31.72092744 -0.27907256 34 2 C33.64448474 9.81271419 31.62535047 17.26166215 29.73828125 24.82421875 C29.3958069 26.2130686 29.05375826 27.60202348 28.71209717 28.99107361 C27.78121454 32.76810202 26.84251312 36.54314781 25.90211868 40.31781769 C25.31052398 42.69544165 24.72136109 45.07365487 24.13302612 47.4520874 C19.18126474 67.46828233 14.134594 87.45952437 9.015625 107.43359375 C8.76686804 108.40446867 8.51811108 109.37534359 8.26181602 110.37563896 C5.81120218 119.93760951 3.35529972 129.49818233 0.88426781 139.05489826 C-0.03796476 142.62391858 -0.95719774 146.19370785 -1.87599945 149.76361275 C-2.30132529 151.41272372 -2.72811476 153.0614581 -3.15656281 154.70976067 C-5.18653946 162.51957963 -7.16052255 170.33865338 -8.84204102 178.23193359 C-9.09172134 179.39469818 -9.34140167 180.55746277 -9.59864807 181.75546265 C-10.01334565 185.10788649 -9.72908137 187.71745259 -9 191 C-6.85945818 192.05050452 -6.85945818 192.05050452 -4 192 C-2.02594038 190.63500473 -0.36766416 189.11786332 1.3515625 187.4453125 C3 186 3 186 6 185 C6.66 185.33 7.32 185.66 8 186 C8 186.66 8 187.32 8 188 C8.66 188.33 9.32 188.66 10 189 C8.11027949 200.71626717 2.57807517 208.99441462 -7 216 C-12.93358008 219.55396724 -17.96874101 221.15099757 -24.875 221.1875 C-26.08929687 221.20167969 -27.30359375 221.21585938 -28.5546875 221.23046875 C-31.86368127 221.00911883 -34.00051865 220.31227309 -37 219 C-38.33783393 219.31478446 -39.67203709 219.64587656 -41 220 C-41.99 219.34 -42.98 218.68 -44 218 C-43.34 217.34 -42.68 216.68 -42 216 C-44.21928194 213.09197539 -45.92969143 211.04687238 -49 209 C-49 208.01 -49 207.02 -49 206 C-49.95653635 203.6485148 -50.95281202 201.31254012 -52 199 C-52.42410156 199.50789062 -52.84820313 200.01578125 -53.28515625 200.5390625 C-61.41702098 210.08283341 -71.96327266 219.44800865 -85 221 C-87.96002859 221.1544523 -90.91132584 221.18506677 -93.875 221.1875 C-94.65230469 221.19974609 -95.42960937 221.21199219 -96.23046875 221.22460938 C-99.99411908 221.23409757 -103.2766466 221.05235278 -106.8828125 219.92578125 C-109.99108701 218.6785663 -109.99108701 218.6785663 -113 220 C-113 219.01 -113 218.02 -113 217 C-114.63070764 215.26464825 -114.63070764 215.26464825 -116.75 213.625 C-121.50496677 209.61904569 -125.26264597 206.45184776 -126 200 C-126.99 200 -127.98 200 -129 200 C-128.814375 199.484375 -128.62875 198.96875 -128.4375 198.4375 C-127.97170403 195.84235102 -128.3249428 193.84749551 -128.7265625 191.26953125 C-130.79880478 174.06992035 -126.40961621 156.866427 -120 141 C-126.3039376 141.54184789 -132.74188143 142.20798959 -138 146 C-141.51647036 151.64231274 -142.15603679 158.69305311 -143.36181641 165.12597656 C-147.53304791 183.91087987 -160.67550876 202.47698914 -176.625 212.875 C-184.65209881 217.69580722 -191.54902412 221.07582306 -201 221.625 C-202.13489868 221.69255493 -202.13489868 221.69255493 -203.29272461 221.76147461 C-209.27016902 222.06704914 -215.06535151 221.833158 -221 221 C-221 220.34 -221 219.68 -221 219 C-221.825 218.95875 -222.65 218.9175 -223.5 218.875 C-230.76091243 217.05977189 -236.9183779 211.18598782 -241 205 C-241.26490234 203.93652344 -241.26490234 203.93652344 -241.53515625 202.8515625 C-241.68855469 202.24054688 -241.84195313 201.62953125 -242 201 C-242.66 200.67 -243.32 200.34 -244 200 C-246.07487842 194.17535111 -246.35720091 187.99902424 -246.3125 181.875 C-246.30686035 181.0495166 -246.3012207 180.2240332 -246.29541016 179.37353516 C-246.02335645 165.41798822 -241.88466292 152.915112 -237 140 C-239.475 140.99 -239.475 140.99 -242 142 C-242 142.66 -242 143.32 -242 144 C-246.62 144.33 -251.24 144.66 -256 145 C-256.37125 147.124375 -256.7425 149.24875 -257.125 151.4375 C-261.80961492 175.68837803 -273.14467678 197.9641624 -293.40234375 212.75390625 C-305.80652338 220.77540977 -319.51467102 222.71361782 -334 221 C-343.89389375 218.61872206 -351.56540123 213.1306975 -357 204.5625 C-357.68047606 203.38285894 -358.35268357 202.19815781 -359 201 C-359.886875 201.721875 -360.77375 202.44375 -361.6875 203.1875 C-362.18636719 203.59355469 -362.68523437 203.99960937 -363.19921875 204.41796875 C-365.14280351 206.07932095 -365.14280351 206.07932095 -367.3125 208.41796875 C-370.14204527 211.13647082 -372.96733346 213.08184439 -376.3125 215.125 C-377.38113281 215.78757812 -378.44976562 216.45015625 -379.55078125 217.1328125 C-383 219 -383 219 -385.08862305 219.50708008 C-387.42181447 220.07694036 -389.03599013 220.60337076 -391 222 C-392.78339848 225.65809323 -393.44437198 229.45590143 -394.1875 233.4375 C-394.66977702 235.63153676 -395.15799319 237.82427703 -395.65234375 240.015625 C-395.88163574 241.06041016 -396.11092773 242.10519531 -396.34716797 243.18164062 C-399.40315316 256.37471955 -407.47980824 268.64195935 -418.59375 276.5078125 C-426.76015809 281.57204609 -434.37453378 285.0583783 -444 286 C-444.68578125 286.07089844 -445.3715625 286.14179687 -446.078125 286.21484375 C-456.52630465 286.74574719 -464.328213 282.68432927 -472 276 C-473.08087891 275.29037109 -473.08087891 275.29037109 -474.18359375 274.56640625 C-476.46100684 272.60244356 -476.67085841 271.37009516 -477.125 268.4375 C-477.65457135 264.80054465 -477.65457135 264.80054465 -480 262 C-479.34 262 -478.68 262 -478 262 C-477.92523438 261.31035156 -477.85046875 260.62070312 -477.7734375 259.91015625 C-476.34917534 249.73087082 -472.66132036 243.82506442 -464.625 237.4375 C-458.08112616 232.76681005 -451.05909925 229.25438577 -443.79345703 225.85009766 C-442.06759671 225.0320408 -440.36133926 224.17301234 -438.65625 223.3125 C-436.36086303 222.17830879 -434.4872771 221.49745542 -432 221 C-431.2575 220.814375 -430.515 220.62875 -429.75 220.4375 C-428.88375 220.2209375 -428.88375 220.2209375 -428 220 C-427.7834375 218.1746875 -427.7834375 218.1746875 -427.5625 216.3125 C-427.17219047 213.17329623 -426.67648144 210.0924866 -426 207 C-426.43828125 207.36351562 -426.8765625 207.72703125 -427.328125 208.1015625 C-438.02699681 216.58237552 -448.46802928 220.51089262 -462 221 C-471.26601694 219.90416866 -479.58816912 214.56456109 -485.37890625 207.4375 C-493.74713663 194.85490781 -493.82111707 177.68983337 -491.28125 163.23046875 C-487.64510652 145.91917993 -480.41587013 129.56473981 -469 116 C-468.56558594 115.42121094 -468.13117188 114.84242188 -467.68359375 114.24609375 C-458.93618569 102.99196577 -445.71792198 95.27786136 -432 92 C-429.15934511 91.75845928 -426.34894295 91.76408326 -423.5 91.8125 C-422.41912109 91.8134668 -422.41912109 91.8134668 -421.31640625 91.81445312 C-416.78777558 91.85130455 -412.46829849 92.26508249 -408 93 C-408 93.66 -408 94.32 -408 95 C-406.21034453 96.36277086 -406.21034453 96.36277086 -404 97.625 C-403.2575 98.07101562 -402.515 98.51703125 -401.75 98.9765625 C-401.1725 99.31429687 -400.595 99.65203125 -400 100 C-399.67 98.35 -399.34 96.7 -399 95 C-398.34 95 -397.68 95 -397 95 C-397 94.34 -397 93.68 -397 93 C-373.61499357 90.56134011 -373.61499357 90.56134011 -363 94 C-362.83720373 99.53497707 -363.31049245 104.43509648 -364.65234375 109.82128906 C-364.82790802 110.55730347 -365.00347229 111.29331787 -365.18435669 112.05163574 C-365.76047039 114.45837261 -366.34904933 116.8618779 -366.9375 119.265625 C-367.34198231 120.948327 -367.74553203 122.63125341 -368.14819336 124.31439209 C-369.20585857 128.72708927 -370.27351113 133.13730159 -371.34411621 137.546875 C-373.05973754 144.61754665 -374.76309405 151.69115633 -376.46072388 158.76616669 C-377.05473536 161.2333748 -377.65485752 163.69903897 -378.25561523 166.16461182 C-378.6198356 167.67512107 -378.98385991 169.18567762 -379.34765625 170.69628906 C-379.51596954 171.37999573 -379.68428284 172.06370239 -379.85769653 172.76812744 C-380.62778723 175.98879534 -381 178.65602439 -381 182 C-381.66 182 -382.32 182 -383 182 C-383.103125 183.010625 -383.20625 184.02125 -383.3125 185.0625 C-384.1375918 191.77243773 -385.63030563 198.38411778 -387 205 C-377.09203209 201.88004415 -369.90140552 196.61542675 -364.5625 187.5625 C-364.0388212 185.17685214 -363.97904331 183.3556666 -364.03515625 180.93359375 C-364.15880434 156.80281982 -355.2026411 131.93753192 -339 114 C-338.33613281 113.24332031 -337.67226563 112.48664063 -336.98828125 111.70703125 C-329.64320264 103.81887843 -318.73156941 95.34105665 -308 93 C-306.96746094 92.73509766 -306.96746094 92.73509766 -305.9140625 92.46484375 C-294.88462182 89.92393165 -283.97962171 90.49037218 -273 93 C-273 93.66 -273 94.32 -273 95 C-271.6696875 95.37125 -271.6696875 95.37125 -270.3125 95.75 C-264.11228646 98.08970322 -260.16455183 102.29289446 -257 108 C-254.61712154 113.85873011 -253.62872515 119.68204063 -253.2109375 125.96875 C-253.11372043 128.06625542 -253.11372043 128.06625542 -252 130 C-242.61926035 129.69243477 -234.99825309 126.22194697 -228.25 119.625 C-226.57677808 117.8297313 -224.99473887 115.99356533 -223.44140625 114.09375 C-212.61924111 101.01372306 -198.70590762 93.33444997 -182 91 C-173.41222551 90.35490896 -164.33986874 90.72659555 -156 93 C-154.30859375 94.46484375 -154.30859375 94.46484375 -153 96 C-152.071875 96.5775 -151.14375 97.155 -150.1875 97.75 C-143.32648469 102.59306963 -138.92497463 108.75801092 -137 117 C-136.69744269 121.68963825 -136.7566612 126.30896878 -137 131 C-127.80670381 129.47002078 -119.73365432 127.39103282 -112 122 C-111.67 121.34 -111.34 120.68 -111 120 C-110.34 120 -109.68 120 -109 120 C-108.67 119.01 -108.34 118.02 -108 117 C-106.38712557 115.23104095 -104.74760234 113.63028644 -103 112 C-102.319375 111.32582031 -101.63875 110.65164063 -100.9375 109.95703125 C-86.6868371 96.33921029 -70.69922112 90.37926989 -51.08081055 90.59057617 C-45.01152937 90.78651128 -39.60668345 91.55464887 -34 94 C-33.29230469 94.28617188 -32.58460938 94.57234375 -31.85546875 94.8671875 C-30.2222734 95.54365895 -28.60810112 96.26586688 -27 97 C-26.88793716 96.39572678 -26.77587433 95.79145355 -26.66041565 95.16886902 C-25.47082971 88.96751829 -23.9574011 82.93011508 -22.21484375 76.86328125 C-21.67902153 74.96810318 -21.14321469 73.07292076 -20.60742188 71.17773438 C-19.77037741 68.23491149 -18.93180333 65.29252956 -18.0925293 62.3503418 C-17.27539128 59.48070187 -16.46368642 56.60956413 -15.65234375 53.73828125 C-15.40129379 52.86520828 -15.15024384 51.99213531 -14.8915863 51.09260559 C-13.56564614 46.3946666 -12.56073966 41.8508691 -12 37 C-11.34 37 -10.68 37 -10 37 C-9.90589844 35.95457031 -9.81179688 34.90914063 -9.71484375 33.83203125 C-8.93901394 27.64311819 -7.20158587 21.6930305 -5.5625 15.6875 C-5.24990234 14.50865234 -4.93730469 13.32980469 -4.61523438 12.11523438 C-4.31037109 10.98794922 -4.00550781 9.86066406 -3.69140625 8.69921875 C-3.41498291 7.67658936 -3.13855957 6.65395996 -2.85375977 5.6003418 C-2 3 -2 3 0 0 Z M-68 119 C-70.62794806 122.51315161 -72.83749047 126.18621251 -75 130 C-75.51433594 130.85851562 -76.02867187 131.71703125 -76.55859375 132.6015625 C-84.05381854 146.11243524 -88.14107698 163.03850815 -88.25 178.4375 C-88.270625 179.16259766 -88.29125 179.88769531 -88.3125 180.63476562 C-88.34984951 185.831016 -87.41893131 189.38416489 -85 194 C-81.52646247 197.16704892 -77.95764987 197.65036666 -73.39453125 197.46875 C-65.21171254 195.86689316 -58.63020389 188.52348641 -54 182 C-48.88384604 172.91400017 -44.57798596 162.01264284 -42.55419922 151.73632812 C-41.88260638 148.42037545 -41.02178765 145.17595355 -40.15234375 141.90625 C-39.79073481 140.53262598 -39.42941545 139.1589257 -39.06835938 137.78515625 C-38.50278394 135.63837838 -37.93540419 133.49214582 -37.36303711 131.34716797 C-36.80805192 129.26412515 -36.26085036 127.17916161 -35.71484375 125.09375 C-35.38605225 123.85302734 -35.05726074 122.61230469 -34.71850586 121.33398438 C-34.0842413 118.39089337 -33.70669212 115.98763209 -34 113 C-37.3239063 109.55298606 -41.0640402 109.14653553 -45.68359375 108.796875 C-55.50393186 108.62972031 -61.31814839 111.90296537 -68 119 Z M-433.91796875 120.13671875 C-446.54111721 137.49650829 -454.81724532 164.490204 -451.5546875 185.92578125 C-450.36054351 190.11901102 -449.44894929 192.55105071 -446.3125 195.6875 C-442.17114154 197.32841561 -439.12561428 197.57424755 -435 196 C-418.91177832 185.74829483 -415.34737594 165.52135189 -411.49316406 148.2890625 C-410.97068974 145.86395397 -410.48401969 143.43304801 -410 141 C-409.75121094 139.83726562 -409.50242187 138.67453125 -409.24609375 137.4765625 C-408.97925781 136.20554687 -408.71242188 134.93453125 -408.4375 133.625 C-408.16808594 132.35914063 -407.89867187 131.09328125 -407.62109375 129.7890625 C-406.47876803 122.82015714 -406.74002147 118.15773723 -410 112 C-419.48113301 105.67924466 -427.64365933 112.80669378 -433.91796875 120.13671875 Z M-306.75 119.375 C-307.51167739 120.57600666 -308.26178838 121.78442892 -309 123 C-309.39574219 123.55945313 -309.79148437 124.11890625 -310.19921875 124.6953125 C-321.2364113 140.78106316 -327.74509415 166.15028468 -325.5390625 185.36328125 C-324.56111245 190.14673257 -322.96552521 193.65221129 -318.8125 196.5 C-313.6995139 197.40897531 -309.24351957 197.47329718 -304.78125 194.54296875 C-298.72487079 189.35662909 -294.51719512 183.59840132 -291 176.5 C-290.65187256 175.80092529 -290.30374512 175.10185059 -289.94506836 174.3815918 C-285.12665553 164.44128849 -281.78192992 154.1215739 -282 143 C-282.61875 142.855625 -283.2375 142.71125 -283.875 142.5625 C-286 142 -286 142 -288 141 C-289.0625 139.0625 -289.0625 139.0625 -290 137 C-290.495 136.01 -290.495 136.01 -291 135 C-290.34 135 -289.68 135 -289 135 C-288.34 134.01 -287.68 133.02 -287 132 C-283.375 130.8125 -283.375 130.8125 -280 130 C-279.64219724 122.55240178 -279.44623286 116.94863015 -284.6875 111.125 C-293.37306981 106.89958766 -301.54719285 112.28026298 -306.75 119.375 Z M-190.9375 122.5625 C-202.20967172 138.02560736 -208.16058269 157.94599098 -208.375 176.9375 C-208.38893799 177.73051514 -208.40287598 178.52353027 -208.41723633 179.34057617 C-208.36825248 185.36431755 -207.28643539 189.96401692 -203.58203125 194.8828125 C-200.43446055 197.10554144 -196.75424044 197.10320936 -193 197 C-187.28265173 194.98211238 -182.65559485 191.24306399 -179.0625 186.375 C-177.64764359 183.93028834 -177.64764359 183.93028834 -179 181 C-177.515 181.495 -177.515 181.495 -176 182 C-171.90015941 173.98936047 -168.46498683 166.06537786 -166.0625 157.375 C-165.85149658 156.61783691 -165.64049316 155.86067383 -165.4230957 155.08056641 C-164.43118895 151.31914827 -163.74596583 147.89519059 -164 144 C-164.969375 143.525625 -165.93875 143.05125 -166.9375 142.5625 C-170 141 -170 141 -171 140 C-171.14115161 137.32941149 -171.04247107 134.67567762 -171 132 C-168.03 131.34 -165.06 130.68 -162 130 C-161.250352 120.4226792 -161.250352 120.4226792 -165 112 C-176.99518857 107.11307132 -183.53183136 113.27175207 -190.9375 122.5625 Z M-432 234 C-446.83398337 241.33067868 -446.83398337 241.33067868 -457 254 C-457.35794332 256.43524544 -457.35794332 256.43524544 -457.1875 258.8125 C-457.16042969 259.60269531 -457.13335937 260.39289063 -457.10546875 261.20703125 C-457.07066406 261.79871094 -457.03585937 262.39039063 -457 263 C-456.34 262.67 -455.68 262.34 -455 262 C-455 263.32 -455 264.64 -455 266 C-451.98221063 267.50889469 -450.37677363 267.50026276 -447 267 C-439.41465398 262.66551656 -436.68125862 255.9628322 -434 248 C-433.66871094 247.05769531 -433.33742188 246.11539063 -432.99609375 245.14453125 C-431.10862398 239.62703967 -431.10862398 239.62703967 -432 234 Z ",
    fill: "#1C1E1F",
    transform: "translate(756,451)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 -0.33 1.98 -0.66 3 -1 C3.39058594 -0.09314453 3.39058594 -0.09314453 3.7890625 0.83203125 C5.09304101 3.16657343 6.23444868 4.13116028 8.375 5.6875 C12.54533746 9.07426675 14.21965563 13.0238822 16 18 C17.1446875 16.7934375 17.1446875 16.7934375 18.3125 15.5625 C21 13 21 13 24 12 C24 11.34 24 10.68 24 10 C29.16981688 5.68315089 34.71107694 2.35834615 41 0 C41.66 -0.33 42.32 -0.66 43 -1 C53.39961871 -2.83522683 62.60137366 -2.20562532 71.6328125 3.73046875 C78.48751427 9.39747466 81.79056495 15.31876532 82.68359375 24.15625 C83.12385772 29.72350376 82.60512157 34.72074095 81.5625 40.1875 C81.39073242 41.1458374 81.21896484 42.1041748 81.04199219 43.09155273 C79.89809863 49.16096794 78.49613134 55.1407267 76.94921875 61.1171875 C76.76939957 61.8154213 76.58958038 62.51365509 76.40431213 63.23304749 C75.51154023 66.68274192 74.59633602 70.12397101 73.64282227 73.55737305 C71.41147292 81.80157155 69.41411501 90.46215844 71 99 C73.51094813 101.57422403 74.55214211 101.97365542 78.1875 102.1875 C86.28028795 99.66679556 90.84230526 93.93918515 94.75 86.625 C98.65034135 78.41577269 100.87232879 69.79757729 103 61 C103.33018966 59.65082652 103.66061056 58.30170962 103.99121094 56.95263672 C105.11206384 52.36752812 106.21478013 47.77819469 107.3125 43.1875 C107.49561737 42.42626831 107.67873474 41.66503662 107.86740112 40.8807373 C108.39313448 38.68624342 108.91070305 36.489985 109.42578125 34.29296875 C109.72911377 33.0093042 110.03244629 31.72563965 110.3449707 30.40307617 C110.90747752 27.48068239 111.14243179 24.95925902 111 22 C111.66 22 112.32 22 113 22 C113.1546875 20.4221875 113.1546875 20.4221875 113.3125 18.8125 C115.31378337 2.68621663 115.31378337 2.68621663 118 0 C120.52094076 -0.08847743 123.01430893 -0.11527301 125.53515625 -0.09765625 C126.66503212 -0.09553383 126.66503212 -0.09553383 127.81773376 -0.09336853 C130.2326956 -0.08775376 132.64756601 -0.07519883 135.0625 -0.0625 C136.69596221 -0.0574869 138.32942586 -0.05292366 139.96289062 -0.04882812 C143.97529585 -0.03777954 147.98763241 -0.02050506 152 0 C152.81827927 3.68359814 152.99513062 6.13683814 152.0625 9.8125 C151.77052734 10.99779297 151.77052734 10.99779297 151.47265625 12.20703125 C151.31667969 12.79871094 151.16070313 13.39039063 151 14 C151.45890625 13.44570313 151.9178125 12.89140625 152.390625 12.3203125 C153.31101562 11.23363281 153.31101562 11.23363281 154.25 10.125 C154.85328125 9.40570313 155.4565625 8.68640625 156.078125 7.9453125 C158.00931783 5.99056853 159.50390733 5.08229018 162 4 C162.88945313 3.505 162.88945313 3.505 163.796875 3 C168.85891187 0.40823712 173.72558769 -0.61066465 179.3125 -1.3125 C180.00633789 -1.40080078 180.70017578 -1.48910156 181.41503906 -1.58007812 C189.51630954 -2.46928994 194.50740528 0.2818427 201 5 C207.72032976 11.65047186 210.12194194 19.27316038 210.375 28.5625 C210.08129715 39.24876516 207.74700006 49.23475711 205.0546875 59.5234375 C204.78993622 60.53710136 204.78993622 60.53710136 204.51983643 61.57124329 C203.62336621 64.99283172 202.71357152 68.41002445 201.78125 71.82202148 C197.66432963 85.47663728 197.66432963 85.47663728 200 99 C203.65958361 98.65957362 205.58877085 98.34796313 208.4375 95.9375 C211.7618762 93.42394727 213.9338757 93.68108829 218 94 C218.77371168 101.99502067 216.75633453 106.58878509 212 113 C210.42578125 114.7890625 210.42578125 114.7890625 209 116 C208.34 116 207.68 116 207 116 C207 116.66 207 117.32 207 118 C205.05859375 119.4375 205.05859375 119.4375 202.4375 121 C201.59058594 121.515625 200.74367188 122.03125 199.87109375 122.5625 C193.92836568 125.53790671 188.66411176 126.24184269 182.0625 126.125 C181.37865234 126.11597656 180.69480469 126.10695313 179.99023438 126.09765625 C178.32666713 126.07438958 176.66328369 126.03853167 175 126 C175 125.34 175 124.68 175 124 C173.948125 123.6596875 173.948125 123.6596875 172.875 123.3125 C167.29627809 120.76569217 163.29018265 116.29018265 159 112 C159.33276762 110.33322029 159.66621741 108.66657675 160 107 C160.01580011 105.13794036 159.98992814 103.27521451 159.9296875 101.4140625 C159.88201402 95.16883711 160.803721 89.46140139 162.125 83.375 C162.34510742 82.31394043 162.56521484 81.25288086 162.79199219 80.15966797 C164.7064045 71.0508568 166.81118732 61.9818034 169.03173828 52.94287109 C172.41615179 39.87178119 172.41615179 39.87178119 170 27 C169.01 27 168.02 27 167 27 C166.34 26.34 165.68 25.68 165 25 C161.0691962 25.34940478 157.49785959 26.15390744 154 28 C153.28556638 29.30836036 152.62635588 30.64726184 152 32 C151.58363281 32.70511719 151.16726563 33.41023438 150.73828125 34.13671875 C146.95042558 40.91334821 144.73360687 47.78903001 142.68359375 55.24609375 C142.23074005 56.87890793 142.23074005 56.87890793 141.76873779 58.54470825 C138.03595061 72.22976516 135.01254731 86.07899566 131.96875 99.93017578 C131.21250684 103.35926587 130.4430117 106.78517111 129.671875 110.2109375 C129.44683289 111.25446381 129.22179077 112.29799011 128.9899292 113.37313843 C128.77250061 114.33329865 128.55507202 115.29345886 128.33105469 116.28271484 C128.05294952 117.54527603 128.05294952 117.54527603 127.76922607 118.83334351 C126.89404086 121.298452 126.07705841 122.42366724 124 124 C121.67843403 124.40729228 119.3431213 124.74438677 117 125 C116.01 125.495 116.01 125.495 115 126 C115 125.34 115 124.68 115 124 C107.41 124 99.82 124 92 124 C90.89681323 119.58725292 91.35144164 117.59423342 92.4375 113.25 C92.72496094 112.07953125 93.01242187 110.9090625 93.30859375 109.703125 C93.53675781 108.81109375 93.76492188 107.9190625 94 107 C93.6596875 107.50789063 93.319375 108.01578125 92.96875 108.5390625 C86.68825532 117.45870123 77.90741305 123.93538253 67 126 C56.39923308 126.74498477 49.93245297 125.95496865 41 120 C41 119.34 41 118.68 41 118 C40.34 118 39.68 118 39 118 C32.10066202 105.11784127 32.09931269 94.68691208 35.125 80.5625 C35.34438232 79.49499512 35.56376465 78.42749023 35.78979492 77.32763672 C37.01014045 71.45240453 38.31283491 65.59944302 39.66796875 59.75390625 C39.9417334 58.56273193 40.21549805 57.37155762 40.49755859 56.14428711 C41.0265618 53.85981102 41.56661864 51.57785594 42.11962891 49.29907227 C45.0772471 37.21716739 45.0772471 37.21716739 42.0625 25.6875 C38.77233193 23.87455025 38.04034653 23.77804674 34.5 24.375 C27.02806219 26.60173643 23.6553454 32.5553619 20 39 C18.92450317 41.50217279 17.99913894 43.86581009 17.16796875 46.44140625 C16.92322311 47.18838272 16.67847748 47.93535919 16.42631531 48.70497131 C11.97234929 62.91805829 9.07312043 77.65143216 5.80969238 92.17523193 C4.8275605 96.54466086 3.83688223 100.91196001 2.8337307 105.27661324 C2.37147693 107.3039003 1.92206402 109.33376101 1.47297668 111.36399841 C1.19225815 112.5870015 0.91153961 113.81000458 0.62231445 115.07006836 C0.25974297 116.68406776 0.25974297 116.68406776 -0.1101532 118.33067322 C-1.02852463 121.08556704 -1.65649966 122.32065832 -4 124 C-6.58554867 124.35165768 -8.97103851 124.55635201 -11.5625 124.625 C-16.4298903 124.62630356 -16.4298903 124.62630356 -21 126 C-21 125.34 -21 124.68 -21 124 C-21.91523438 124.02320313 -22.83046875 124.04640625 -23.7734375 124.0703125 C-24.96195312 124.08835937 -26.15046875 124.10640625 -27.375 124.125 C-28.55835938 124.14820313 -29.74171875 124.17140625 -30.9609375 124.1953125 C-34 124 -34 124 -36 122 C-36.58556732 115.75498681 -35.05099996 110.0372863 -33.59375 103.9921875 C-33.22751526 102.42671677 -33.22751526 102.42671677 -32.85388184 100.82962036 C-32.07655399 97.50964554 -31.28920613 94.19216964 -30.5 90.875 C-29.71157325 87.55052334 -28.92548146 84.22556998 -28.14611816 80.8989563 C-27.6619349 78.83310906 -27.1724756 76.76848953 -26.67712402 74.70529175 C-26.45689575 73.76726715 -26.23666748 72.82924255 -26.00976562 71.86279297 C-25.81435181 71.04229462 -25.61893799 70.22179626 -25.41760254 69.37643433 C-24.97751321 66.8720353 -24.92707542 64.53758498 -25 62 C-24.34 62 -23.68 62 -23 62 C-22.814375 60.1128125 -22.814375 60.1128125 -22.625 58.1875 C-22.23928187 54.6154147 -21.65167779 51.14523806 -20.9375 47.625 C-19.90791426 42.13645645 -19.33198376 36.57007663 -20 31 C-22.03268602 28.83656989 -22.03268602 28.83656989 -25 27 C-24.34 27 -23.68 27 -23 27 C-23 26.34 -23 25.68 -23 25 C-28.08558437 25.11055618 -31.92574082 25.33112164 -36.3125 28.0625 C-45.14218108 37.71354676 -48.68234068 50.16714403 -50 63 C-50.66 63 -51.32 63 -52 63 C-52.11102051 64.07523926 -52.22204102 65.15047852 -52.33642578 66.25830078 C-53.04281508 71.87998871 -54.33715018 77.35284059 -55.6171875 82.8671875 C-55.87501007 83.98312286 -56.13283264 85.09905823 -56.39846802 86.24880981 C-56.94252697 88.59414641 -57.48894639 90.93893657 -58.03759766 93.28320312 C-58.87652422 96.88153771 -59.69813571 100.48356639 -60.51953125 104.0859375 C-61.05102096 106.36743525 -61.58353699 108.6486942 -62.1171875 110.9296875 C-62.36105194 112.00983124 -62.60491638 113.08997498 -62.85617065 114.20285034 C-63.09296539 115.1979361 -63.32976013 116.19302185 -63.57373047 117.21826172 C-63.87898148 118.53441971 -63.87898148 118.53441971 -64.19039917 119.87716675 C-65 122 -65 122 -68 124 C-70.54229597 124.1712914 -72.97189481 124.23242934 -75.51171875 124.1953125 C-76.23994339 124.1924826 -76.96816803 124.18965271 -77.71846008 124.18673706 C-80.04164137 124.17555257 -82.36443547 124.15045166 -84.6875 124.125 C-86.2636663 124.11496794 -87.83983865 124.10584248 -89.41601562 124.09765625 C-93.27749267 124.07561896 -97.13868071 124.04110141 -101 124 C-102.74377195 117.87222416 -101.05028437 112.54142158 -99.60546875 106.52734375 C-99.34230362 105.39125168 -99.07913849 104.25515961 -98.80799866 103.0846405 C-97.94464473 99.36648015 -97.06600911 95.65210577 -96.1875 91.9375 C-95.13651896 87.43018429 -94.09075586 82.92166317 -93.04444504 78.41326141 C-92.58828133 76.45030788 -92.13059567 74.48771472 -91.67251587 72.52520752 C-88.54351614 59.10939901 -85.56697206 45.66094813 -82.60824585 32.20675659 C-82.20284028 30.36429459 -81.79686963 28.52195681 -81.39024353 26.67976379 C-81.0272908 25.03522998 -80.66574884 23.39038388 -80.30592346 21.74516296 C-79.65001813 18.77313422 -78.96329358 15.88988074 -78 13 C-78.66 12.67 -79.32 12.34 -80 12 C-79.01 12 -78.02 12 -77 12 C-76.95101563 11.38511719 -76.90203125 10.77023437 -76.8515625 10.13671875 C-76.77679688 9.32847656 -76.70203125 8.52023437 -76.625 7.6875 C-76.55539062 6.88699219 -76.48578125 6.08648437 -76.4140625 5.26171875 C-76 3 -76 3 -74 0 C-71.38710772 -0.27949467 -69.01420564 -0.37228548 -66.40234375 -0.328125 C-65.27814781 -0.32531525 -65.27814781 -0.32531525 -64.13124084 -0.32244873 C-62.54667717 -0.31572368 -60.96213023 -0.3018001 -59.37768555 -0.28125 C-56.94369195 -0.2500793 -54.51034531 -0.24027901 -52.07617188 -0.234375 C-50.53905455 -0.22520589 -49.00194385 -0.21483041 -47.46484375 -0.203125 C-46.3664341 -0.19675018 -46.3664341 -0.19675018 -45.24583435 -0.19024658 C-40.11715873 -0.11715873 -40.11715873 -0.11715873 -39 1 C-39.09000378 2.4836107 -39.24646818 3.96348907 -39.4375 5.4375 C-39.85914317 8.709892 -39.85914317 8.709892 -40 12 C-38.89205078 11.09507812 -38.89205078 11.09507812 -37.76171875 10.171875 C-31.1161352 4.93647246 -25.23080865 1.37182822 -17 -1 C-10.92039012 -3.02653663 -5.98890831 -1.7275697 0 0 Z ",
    fill: "#1C1E1F",
    transform: "translate(521,402)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.01900391 0.05929688 2.03800781 0.11859375 3.08789062 0.1796875 C4.15072266 0.25703125 5.21355469 0.334375 6.30859375 0.4140625 C8.4137696 0.55143953 10.5192348 0.68447374 12.625 0.8125 C13.55900635 0.87872559 14.4930127 0.94495117 15.45532227 1.01318359 C17.77723813 1.2140273 17.77723813 1.2140273 19.74609375 0.0390625 C22.74062272 4.29522401 22.74062272 4.29522401 22.76416016 7.49536133 C22.58546387 8.38247803 22.40676758 9.26959473 22.22265625 10.18359375 C22.01157227 11.2401416 21.80048828 12.29668945 21.58300781 13.38525391 C20.06848351 19.99738071 18.45845462 26.58073022 16.77868652 33.152771 C15.64562124 37.58754267 14.52937686 42.02656201 13.41015625 46.46484375 C13.18408691 47.35941284 12.95801758 48.25398193 12.72509766 49.17565918 C10.77058197 56.91657 8.85840889 64.66723206 6.97784424 72.42642212 C6.52346907 74.30111545 6.06721461 76.175353 5.61083984 78.04956055 C3.69134307 85.9814578 1.84645694 93.92910581 0.01953125 101.8828125 C-3.34615505 116.52382372 -6.82822149 131.13640161 -10.32275391 145.74707031 C-11.20905493 149.45272015 -12.09368522 153.1587665 -12.97783089 156.86493111 C-13.67562283 159.78918418 -14.37424956 162.71323735 -15.0731163 165.63723373 C-15.39939994 167.00274867 -15.72545393 168.36831851 -16.05124283 169.73395157 C-17.11011476 174.17111385 -18.17856301 178.6058642 -19.25390625 183.0390625 C-19.42956871 183.76567833 -19.60523117 184.49229416 -19.78621674 185.24092865 C-20.32729165 187.47264828 -20.87361566 189.70302099 -21.42138672 191.93310547 C-21.58957476 192.62879198 -21.75776279 193.32447849 -21.93104744 194.04124641 C-23.13927989 198.92443614 -23.13927989 198.92443614 -24.25390625 200.0390625 C-26.92016655 200.12761411 -29.56037739 200.15430923 -32.2265625 200.13671875 C-33.02420517 200.1353038 -33.82184784 200.13388885 -34.6436615 200.13243103 C-37.2012806 200.12681566 -39.75881343 200.11426062 -42.31640625 200.1015625 C-44.0462227 200.09654948 -45.77604051 200.09198623 -47.50585938 200.08789062 C-51.75524178 200.07684125 -56.00455937 200.05956636 -60.25390625 200.0390625 C-62.53167113 194.3133387 -64.18282969 188.69414131 -65.515625 182.68359375 C-65.71114456 181.8189299 -65.90666412 180.95426605 -66.10810852 180.06340027 C-66.51668002 178.24968121 -66.92242017 176.4353222 -67.32543945 174.62036133 C-67.94238038 171.84718373 -68.57116109 169.07687477 -69.20117188 166.30664062 C-69.59836518 164.53661727 -69.99487352 162.76644004 -70.390625 160.99609375 C-70.57807785 160.17204544 -70.7655307 159.34799713 -70.95866394 158.49897766 C-71.81443833 154.6110309 -72.49458096 151.04879404 -72.25390625 147.0390625 C-72.91390625 146.7090625 -73.57390625 146.3790625 -74.25390625 146.0390625 C-74.52360194 144.15119267 -74.78188719 142.26075205 -74.97265625 140.36328125 C-75.34852587 137.25713648 -76.04165409 134.25860885 -76.75390625 131.21484375 C-77.08844582 129.75907392 -77.39954897 128.29772792 -77.6875 126.83203125 C-78.1658001 124.47351696 -78.68507666 122.13354846 -79.2265625 119.7890625 C-79.40380859 119.015625 -79.58105469 118.2421875 -79.76367188 117.4453125 C-80.13235823 115.84028922 -80.50476003 114.23611491 -80.88085938 112.6328125 C-81.77590634 108.69854011 -82.50800095 105.10457776 -82.25390625 101.0390625 C-82.91390625 100.7090625 -83.57390625 100.3790625 -84.25390625 100.0390625 C-84.8515625 97.4921875 -84.8515625 97.4921875 -85.31640625 94.2890625 C-85.87892266 90.51415902 -86.49075352 86.77847133 -87.25390625 83.0390625 C-89.97751497 93.67290091 -92.46920967 104.33260798 -94.75 115.0703125 C-95.06838576 116.55941452 -95.38700002 118.04846771 -95.70582581 119.53747559 C-96.53654726 123.42049443 -97.36388897 127.30422575 -98.19055176 131.18811035 C-98.85324359 134.29870796 -99.51842782 137.4087699 -100.18378258 140.51879883 C-100.83745072 143.57483174 -101.49000427 146.63110224 -102.14253616 149.68737793 C-102.46336319 151.18885094 -102.78460691 152.69023498 -103.10627365 154.19152832 C-104.6875178 161.57158696 -106.25066584 168.95194676 -107.69970703 176.359375 C-107.91836929 177.46228882 -108.13703156 178.56520264 -108.36231995 179.70153809 C-108.75556615 181.6982187 -109.13894641 183.69688347 -109.5096283 185.69787598 C-110.60221889 191.21647793 -112.18417073 195.31080645 -115.25390625 200.0390625 C-117.56390625 200.0390625 -119.87390625 200.0390625 -122.25390625 200.0390625 C-122.25390625 199.7090625 -122.25390625 199.3790625 -122.25390625 199.0390625 C-126.21390625 198.7090625 -130.17390625 198.3790625 -134.25390625 198.0390625 C-134.58390625 198.6990625 -134.91390625 199.3590625 -135.25390625 200.0390625 C-138.18215277 199.06298033 -139.86817246 197.93119619 -142.25390625 196.0390625 C-141.62656267 190.46887915 -140.71304454 185.06590884 -139.51074219 179.59350586 C-139.33617146 178.78527374 -139.16160074 177.97704163 -138.98174 177.14431763 C-138.40376256 174.47181486 -137.82096857 171.80038569 -137.23828125 169.12890625 C-136.82588097 167.22530433 -136.41385625 165.32162101 -136.00218201 163.41786194 C-135.12654384 159.3704286 -134.24915214 155.32338119 -133.37045288 151.27661133 C-131.0813641 140.72995885 -128.81050675 130.17937024 -126.5390625 119.62890625 C-126.31268412 118.57766949 -126.08630573 117.52643272 -125.8530674 116.4433403 C-121.95318058 98.32987865 -118.06752365 80.21361664 -114.28503418 62.07522583 C-113.72570545 59.39412952 -113.1616654 56.71409428 -112.59338379 54.03488159 C-111.81835549 50.37151842 -111.05572766 46.70580524 -110.296875 43.0390625 C-109.95782387 41.45352318 -109.95782387 41.45352318 -109.61192322 39.83595276 C-109.41538651 38.87172897 -109.21884979 37.90750519 -109.01635742 36.9140625 C-108.8435173 36.08648437 -108.67067719 35.25890625 -108.49259949 34.40625 C-108.22411741 31.74363824 -108.60907978 29.62390198 -109.25390625 27.0390625 C-116.33133811 27.19291971 -121.02926708 30.4201786 -126.25390625 35.0390625 C-136.26943406 46.4494027 -140.64249655 60.02699899 -140.46875 75.0078125 C-140.2502047 78.09128802 -139.71966222 80.95778956 -139.06640625 83.9765625 C-138.42804804 87.25346795 -138.21290992 88.86824447 -139.00390625 92.1640625 C-142.64785748 95.20068852 -146.62850183 95.17270179 -151.25390625 95.0390625 C-155.34601593 94.03876902 -158.20000681 91.92330086 -161.25390625 89.0390625 C-162.06640625 86.7890625 -162.06640625 86.7890625 -162.25390625 85.0390625 C-163.24390625 85.0390625 -164.23390625 85.0390625 -165.25390625 85.0390625 C-165.58390625 84.0490625 -165.91390625 83.0590625 -166.25390625 82.0390625 C-165.75890625 81.5440625 -165.75890625 81.5440625 -165.25390625 81.0390625 C-165.34604056 78.84864362 -165.50378238 76.66087495 -165.69140625 74.4765625 C-166.10378699 69.30065552 -166.35768476 64.22798823 -166.25390625 59.0390625 C-165.59390625 59.0390625 -164.93390625 59.0390625 -164.25390625 59.0390625 C-164.19203125 58.1109375 -164.13015625 57.1828125 -164.06640625 56.2265625 C-162.78939 47.48254846 -158.21041372 40.31833639 -152.25390625 34.0390625 C-151.73054688 33.40484375 -151.2071875 32.770625 -150.66796875 32.1171875 C-146.69998545 27.31089787 -142.3286961 23.49931442 -137.390625 19.703125 C-135.20115665 18.06858429 -135.20115665 18.06858429 -133.25390625 16.0390625 C-116.09517469 5.90213329 -96.84366774 2.09680224 -77.06640625 1.6640625 C-75.98734009 1.62478638 -75.98734009 1.62478638 -74.88647461 1.5847168 C-71.69644503 1.57446191 -69.7088426 1.69514391 -67.12831116 3.64595032 C-64.74720241 6.68598736 -64.33529751 8.98868315 -63.68139648 12.78979492 C-63.55894876 13.47020906 -63.43650105 14.15062321 -63.31034279 14.85165596 C-63.04338848 16.34312772 -62.78347889 17.8358733 -62.52971077 19.32964516 C-61.81872663 23.50616807 -61.05251175 27.67276697 -60.29638672 31.84130859 C-60.13543172 32.73718972 -59.97447672 33.63307085 -59.80864429 34.55609989 C-57.83746734 45.47432077 -55.6229964 56.34272533 -53.4140625 67.21484375 C-52.99387218 69.28983855 -52.57381839 71.36486101 -52.15390015 73.43991089 C-51.09313904 78.67851043 -50.029676 83.91655776 -48.96557617 89.15447998 C-47.86395258 94.5798415 -46.76512386 100.00576908 -45.66601562 105.43164062 C-43.53128334 115.96798386 -41.39361227 126.50372828 -39.25390625 137.0390625 C-38.92390625 137.0390625 -38.59390625 137.0390625 -38.25390625 137.0390625 C-28.47067338 93.62674207 -28.47067338 93.62674207 -18.87207031 50.1734314 C-18.54714487 48.6848265 -18.2206848 47.19655563 -17.89257812 45.70864868 C-16.30627043 38.50586179 -14.88196646 31.39863986 -14.25390625 24.0390625 C-13.59390625 24.0390625 -12.93390625 24.0390625 -12.25390625 24.0390625 C-12.09921875 22.1828125 -12.09921875 22.1828125 -11.94140625 20.2890625 C-10.31050667 5.81770007 -10.31050667 5.81770007 -7.02514648 1.37890625 C-4.56656511 -0.48087247 -3.04610689 -0.20837502 0 0 Z ",
    fill: "#1C1E1F",
    transform: "translate(518.25390625,175.9609375)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.495 0.99 0.495 0.99 1 2 C2.051875 1.82597656 3.10375 1.65195312 4.1875 1.47265625 C10.13201959 0.7295913 16.03371178 1.14021072 22 1.4375 C23.73443359 1.51581055 23.73443359 1.51581055 25.50390625 1.59570312 C28.33627353 1.72444709 31.16820235 1.85936681 34 2 C35.34218764 7.38367561 34.51651361 11.31854787 33.1640625 16.546875 C32.96525482 17.35811829 32.76644714 18.16936157 32.56161499 19.00518799 C31.92699825 21.58964303 31.27725056 24.16994379 30.625 26.75 C29.77530482 30.13855881 28.93367046 33.52895416 28.1015625 36.921875 C27.90282532 37.72886841 27.70408813 38.53586182 27.49932861 39.36730957 C26.48700996 43.58572334 25.6932388 47.68078899 25.3359375 52.015625 C25 56 25 56 23 59 C22.4137454 61.02731783 21.90003186 63.0759588 21.42773438 65.1328125 C21.13402954 66.39843018 20.84032471 67.66404785 20.53771973 68.96801758 C20.2228598 70.35363219 19.90820857 71.73929425 19.59375 73.125 C19.26556557 74.55178452 18.93690414 75.97845939 18.60778809 77.4050293 C17.91814305 80.40018227 17.23262189 83.39623842 16.55029297 86.39306641 C15.68210305 90.20580734 14.80642547 94.01677497 13.92790985 97.82714844 C13.24798445 100.77805053 12.57083462 103.72958385 11.89460754 106.68133545 C11.57303545 108.08465776 11.25093599 109.48785934 10.92826843 110.89093018 C5.1406636 130.14819706 5.1406636 130.14819706 8 149 C9.45947705 148.93993922 10.91779272 148.8511311 12.375 148.75 C13.18710937 148.70359375 13.99921875 148.6571875 14.8359375 148.609375 C15.55007813 148.40828125 16.26421875 148.2071875 17 148 C17.70798772 146.6881404 18.37530495 145.35350594 19 144 C22.625 142.75 22.625 142.75 26 142 C28.32375501 143.74281626 28.94994282 144.7371998 29.5 147.625 C28.16327613 156.64788614 21.78620765 163.33384604 15 169 C5.98674693 174.97092475 -2.40500441 175.93839892 -13 175 C-18.61839185 173.825374 -22.63129204 172.0106956 -26.125 167.375 C-28 164 -28 164 -28 162 C-28.66 161.67 -29.32 161.34 -30 161 C-30.72693904 159.02111039 -31.39816251 157.02045442 -32 155 C-32.61875 155.99 -33.2375 156.98 -33.875 158 C-34.57625 158.99 -35.2775 159.98 -36 161 C-36.66 161 -37.32 161 -38 161 C-38 161.66 -38 162.32 -38 163 C-47.66454828 171.48863366 -58.271487 176.36867569 -71.125 176.21484375 C-80.34450514 175.52588617 -88.41365529 170.96749482 -94.75 164.375 C-103.84547832 153.43135371 -103.90745797 138.49812829 -103 125 C-100.16814989 100.48953147 -89.58926914 77.14204271 -70.58984375 60.9140625 C-63.33865614 55.55496457 -55.31553494 51.43835732 -47 48 C-47 47.67 -47 47.34 -47 47 C-44.06225537 46.94609643 -41.12549768 46.9063745 -38.1875 46.875 C-37.35412109 46.85824219 -36.52074219 46.84148437 -35.66210938 46.82421875 C-34.45844727 46.81455078 -34.45844727 46.81455078 -33.23046875 46.8046875 C-32.49207764 46.79421387 -31.75368652 46.78374023 -30.99291992 46.77294922 C-29 47 -29 47 -26 49 C-24.48766549 49.88960854 -22.96614532 50.76372043 -21.4375 51.625 C-20.65246094 52.07101562 -19.86742187 52.51703125 -19.05859375 52.9765625 C-17.08467911 54.14839116 -17.08467911 54.14839116 -15 54 C-13.87810954 49.10721575 -12.75712337 44.21422552 -11.63696289 39.32104492 C-11.25602468 37.65757695 -10.87484243 35.99416485 -10.4934082 34.33081055 C-9.94417689 31.93553186 -9.39583277 29.54005152 -8.84765625 27.14453125 C-8.59291283 26.03486748 -8.59291283 26.03486748 -8.33302307 24.90278625 C-7.50424626 21.27713211 -6.72719389 17.64713162 -6 14 C-5.52132652 12.26480864 -5.02129126 10.53536761 -4.5 8.8125 C-4.2421875 7.95269531 -3.984375 7.09289062 -3.71875 6.20703125 C-3 4 -3 4 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z M-47 76 C-59.46539193 93.62025326 -67.18531536 120.05101548 -64.703125 141.57421875 C-63.70136482 146.24622097 -62.69851158 149.71243415 -59 153 C-54.77307752 154.53706272 -51.29005664 154.08169075 -47.1484375 152.3203125 C-38.57730865 147.05296423 -33.89568983 138.35121853 -31 129 C-30.60612212 126.67612053 -30.26513915 124.34206251 -30 122 C-29.57666609 120.64571146 -29.12155809 119.30116499 -28.64453125 117.96484375 C-26.88024228 112.79537205 -25.56685868 107.56302377 -24.3125 102.25 C-24.08755859 101.33089844 -23.86261719 100.41179687 -23.63085938 99.46484375 C-23.41880859 98.57410156 -23.20675781 97.68335938 -22.98828125 96.765625 C-22.79790283 95.96930664 -22.60752441 95.17298828 -22.41137695 94.35253906 C-21.92450096 91.96691827 -21.92450096 91.96691827 -22.00073242 89.37402344 C-22 87 -22 87 -21 84.25 C-19.71180202 80.06335658 -19.24098737 76.33835643 -20 72 C-21.99693375 69.00459937 -23.45112821 67.50886958 -26.90234375 66.375 C-35.33296015 64.82156588 -41.60791185 69.99978161 -47 76 Z ",
    fill: "#1C1E1F",
    transform: "translate(319,353)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C20.03839366 0.39431544 40.11067597 5.57505985 59 12 C59.81823242 12.27650391 60.63646484 12.55300781 61.47949219 12.83789062 C90.76467021 22.92209884 119.0801613 38.27124415 143 58 C143.94617188 58.75667969 144.89234375 59.51335937 145.8671875 60.29296875 C151.24563499 64.62105461 156.44593698 69.11006842 161.54296875 73.765625 C163.15464463 75.23125076 164.78192582 76.67993549 166.42578125 78.109375 C171.43009966 82.48316525 176.09694179 87.07883867 180.625 91.9375 C181.15851074 92.5056543 181.69202148 93.07380859 182.24169922 93.65917969 C186 97.75487478 186 97.75487478 186 100 C186.66 100 187.32 100 188 100 C189.24584961 101.32250977 189.24584961 101.32250977 190.65234375 103.19140625 C191.17578369 103.88081299 191.69922363 104.57021973 192.23852539 105.28051758 C193.07951782 106.41009888 193.07951782 106.41009888 193.9375 107.5625 C194.51943115 108.33682373 195.1013623 109.11114746 195.70092773 109.90893555 C196.89952699 111.50679561 198.09522903 113.1068329 199.28808594 114.70898438 C200.80529815 116.73943494 202.33956305 118.75495425 203.8828125 120.765625 C237.30849561 164.72359721 256.2902938 218.40747032 262 273 C262.09571289 273.83152588 262.19142578 274.66305176 262.29003906 275.51977539 C263.16351717 283.77846463 263.15347273 292.01958808 263.125 300.3125 C263.12411377 301.0552417 263.12322754 301.7979834 263.12231445 302.56323242 C263.10484099 315.06482322 262.71617769 327.51804589 262 340 C262 340.66 262 341.32 262 342 C261.34 342 260.68 342 260 342 C259.97421875 342.71800781 259.9484375 343.43601562 259.921875 344.17578125 C257.16898716 394.41598439 232.46164381 445.66934719 204 486 C203.53577637 486.65838867 203.07155273 487.31677734 202.59326172 487.99511719 C196.86229159 496.04091385 190.47389867 503.54964603 184 511 C182.92492187 512.24523437 182.92492187 512.24523437 181.828125 513.515625 C177.18607705 518.78592004 172.31008024 523.81817946 167.375 528.8125 C166.75334961 529.44720215 166.13169922 530.0819043 165.49121094 530.73583984 C161.58498547 534.64931056 157.68206044 538.03845575 153 541 C149.67088388 541 147.91598818 540.58012585 145.125 538.8125 C143.4001047 536.03350202 143.59705607 534.22742589 144 531 C145.75146361 528.75648641 147.31285163 527.0221765 149.375 525.125 C149.88289062 524.62742187 150.39078125 524.12984375 150.9140625 523.6171875 C154.69024725 520 154.69024725 520 157 520 C157 519.34 157 518.68 157 518 C158.49609375 516.5625 158.49609375 516.5625 160.4375 515 C163.15188238 512.85474956 163.15188238 512.85474956 165 510 C165.66 510 166.32 510 167 510 C167.23976563 509.43796875 167.47953125 508.8759375 167.7265625 508.296875 C169.2711132 505.51099828 171.16834499 503.54949163 173.375 501.25 C182.99548537 490.82549712 191.07076747 479.1872536 198.8203125 467.33203125 C200.59855634 464.61367641 202.41338079 461.92879952 204.25 459.25 C234.29218792 414.02794476 248.27201962 356.82177788 248.1875 303 C248.18659363 301.92217255 248.18659363 301.92217255 248.18566895 300.8225708 C248.11006905 267.48762706 242.65944967 234.40125584 231.25 203 C230.96858154 202.22301758 230.68716309 201.44603516 230.3972168 200.64550781 C229.03964814 197.08952768 227.80186361 194.56170387 225 192 C225.33 191.34 225.66 190.68 226 190 C225.12154088 188.00455975 224.14684073 186.05095788 223.125 184.125 C220.08712928 178.37424008 220.08712928 178.37424008 219.56005859 176.11035156 C218.89275508 173.59589141 217.83411064 171.57592067 216.59375 169.2890625 C216.10124756 168.38003174 215.60874512 167.47100098 215.10131836 166.53442383 C214.30866577 165.09425903 214.30866577 165.09425903 213.5 163.625 C212.96189697 162.64362061 212.42379395 161.66224121 211.86938477 160.65112305 C205.18152897 147.76702828 205.18152897 147.76702828 196.37890625 136.38671875 C195 135 195 135 194.09326172 133.1574707 C192.11319813 129.24996245 189.25135238 125.94140292 186.5625 122.5 C185.94157471 121.70134521 185.32064941 120.90269043 184.6809082 120.07983398 C180.0607237 114.20008299 175.19792783 108.66821414 170.01171875 103.28515625 C168 101 168 101 167 98 C166.34 98 165.68 98 165 98 C165 97.34 165 96.68 165 96 C164.01 95.67 163.02 95.34 162 95 C160.28891311 93.37897032 158.62746694 91.70496537 157 90 C153.72761146 86.63411465 150.33379797 83.42265648 146.875 80.25 C145.60269531 79.08210938 145.60269531 79.08210938 144.3046875 77.890625 C142.06384899 75.82283785 142.06384899 75.82283785 139 75 C137.9063706 73.87219468 136.81381993 72.74332447 135.7265625 71.609375 C128.71588704 64.84239055 128.71588704 64.84239055 120 62 C119.67 61.01 119.34 60.02 119 59 C117.00980253 57.98063057 115.0072458 56.98537521 113 56 C111.67033549 55.02293883 110.35856131 54.02121562 109.0625 53 C105.51293316 50.25436576 102.18557763 48.5905195 98 47 C96 46 96 46 94.24121094 44.61987305 C91.65518041 42.75077582 89.02335646 41.44985791 86.140625 40.08203125 C85.02558594 39.55029297 83.91054688 39.01855469 82.76171875 38.47070312 C81.60285156 37.92349609 80.44398438 37.37628906 79.25 36.8125 C78.07566406 36.25369141 76.90132812 35.69488281 75.69140625 35.11914062 C72.79612962 33.74211881 69.89896415 32.36923722 67 31 C66.67 31.66 66.34 32.32 66 33 C65.34 32.34 64.68 31.68 64 31 C59.61011443 28.07340962 54.79648619 26.72687146 49.8125 25.0625 C48.74 24.70349609 47.6675 24.34449219 46.5625 23.97460938 C38.11257163 21.21699802 29.80008623 19.24236511 21 18 C20.67 18.66 20.34 19.32 20 20 C19.58556641 19.52240234 19.17113281 19.04480469 18.74414062 18.55273438 C15.87733779 16.00054149 12.18441679 15.99822664 8.5 15.5 C-0.26251176 14.31508606 -0.26251176 14.31508606 -3 11 C-3.9375 8.6875 -3.9375 8.6875 -4 6 C-2.0625 2.6875 -2.0625 2.6875 0 0 Z ",
    fill: "#1D1E1E",
    transform: "translate(560,196)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.17949219 0.43699219 1.17949219 0.43699219 2.3828125 0.8828125 C11.36027995 4.28621061 17.6600662 8.12569958 22.125 16.875 C24.8690483 23.23816712 25.31605944 30.16959365 26 37 C34.57160765 35.61748264 41.22872631 32.34271986 47.75 26.5625 C50 25 50 25 53.1875 25 C56 26 56 26 57.5625 27.625 C58.25099273 31.36253194 57.00512027 33.93751727 55 37 C49.16982545 43.86529692 40.98911554 47.27109016 33 51 C31.66409106 51.66149039 30.32936135 52.32544783 29 53 C29 53.33 29 53.66 29 54 C27.35 54 25.7 54 24 54 C23.79955078 54.70382812 23.59910156 55.40765625 23.39257812 56.1328125 C15.75074565 82.67994934 6.49122892 107.89058796 -19 122 C-33.23263621 129.05120147 -48.66950633 131.4013722 -64 126.3125 C-72.57318568 122.72641483 -77.77548446 117.52763038 -83 110 C-84.32481269 108.32655239 -85.65407903 106.65651812 -87 105 C-86.34 105 -85.68 105 -85 105 C-85.309375 104.154375 -85.61875 103.30875 -85.9375 102.4375 C-89.12951065 92.11040671 -88.16517148 81.45600163 -87.12109375 70.84765625 C-87.01136892 68.26735302 -87.20793222 66.43487502 -88 64 C-86.02 63.505 -86.02 63.505 -84 63 C-83.835 61.845 -83.67 60.69 -83.5 59.5 C-80.15429698 44.45620059 -69.7823949 28.65845933 -59 18 C-58.34 17.67 -57.68 17.34 -57 17 C-56.34 16.01 -55.68 15.02 -55 14 C-41.05929594 3.33794301 -17.5574912 -7.02299648 0 0 Z M-23.50366211 22.57275391 C-40.09335227 38.39643292 -47.25076421 66.85591992 -48 89 C-48.02197904 93.90865302 -47.71976013 97.5569773 -44.625 101.5 C-41.56454273 104.41472121 -39.97053656 104.90484936 -35.8125 105.3125 C-29.30019185 104.77870425 -24.87618968 102.26637818 -20.4375 97.5 C-14.54263975 90.24271209 -9.96705929 82.36541862 -7.61328125 73.296875 C-7.02928737 71.10968774 -6.28819363 69.09530452 -5.4375 67 C-3.67158613 62.46438964 -2.83282989 57.78142335 -2 53 C-4.475 53.495 -4.475 53.495 -7 54 C-7 53.01 -7 52.02 -7 51 C-6.34 50.67 -5.68 50.34 -5 50 C-5.639375 49.773125 -6.27875 49.54625 -6.9375 49.3125 C-9 48 -9 48 -9.875 45.625 C-10.02300179 42.5169624 -10.04553849 41.37282465 -8 39 C-5.34109022 38.04149281 -2.79243905 37.54047207 0 37 C0.65861918 27.4958404 0.65861918 27.4958404 -3 19 C-4.81701858 17.59145334 -4.81701858 17.59145334 -7 17 C-7.763125 16.731875 -8.52625 16.46375 -9.3125 16.1875 C-15.09539412 15.78404227 -19.28352678 18.96639664 -23.50366211 22.57275391 Z M-86 64 C-85 68 -85 68 -85 68 Z ",
    fill: "#1C1E1F",
    transform: "translate(608,250)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.375 2.0625 2.375 2.0625 4 4 C1.90042748 10.65817743 -0.93134125 12.7885672 -6.9375 16.0625 C-8.56962826 17.00747765 -10.19841638 17.95824239 -11.82421875 18.9140625 C-13.09724854 19.66091309 -13.09724854 19.66091309 -14.39599609 20.42285156 C-30.34679804 30.08365979 -45.01324108 41.63127758 -58 55 C-59.88541055 56.88541055 -61.83311362 58.59995013 -63.875 60.3125 C-73.53769058 68.65232223 -81.48112478 78.74603568 -89 89 C-89.51401367 89.6899707 -90.02802734 90.37994141 -90.55761719 91.09082031 C-137.37717532 154.22670408 -157.35967912 235.38247713 -146.15234375 313.1015625 C-141.68359511 342.17287986 -133.81600752 370.45900254 -121 397 C-120.53110352 397.99700928 -120.53110352 397.99700928 -120.05273438 399.01416016 C-109.87034441 420.65964441 -96.49831078 440.80099348 -81 459 C-80.40058594 459.73347656 -79.80117188 460.46695312 -79.18359375 461.22265625 C-77.83648527 462.85541665 -76.42560632 464.43531013 -75 466 C-74.34 466 -73.68 466 -73 466 C-73.84169039 469.97890004 -74.52190141 472.48313666 -77.3125 475.5 C-80 477 -80 477 -82.328125 476.94140625 C-85.97398906 475.65682549 -87.97929546 473.2884993 -90.4375 470.4375 C-91.15764282 469.62865356 -91.15764282 469.62865356 -91.89233398 468.8034668 C-95.0989002 465.16198327 -98.10098803 461.40718926 -100.87890625 457.42578125 C-101.95997635 455.84222927 -101.95997635 455.84222927 -104 455 C-104.7378924 453.7790696 -105.41524725 452.52130647 -106.0625 451.25 C-108.19158904 447.29064143 -110.58262293 443.66339602 -113.1875 440 C-123.57384796 425.22569713 -131.43629339 409.36633361 -139 393 C-139.66 393 -140.32 393 -141 393 C-141.08765625 392.05898438 -141.1753125 391.11796875 -141.265625 390.1484375 C-141.99729185 385.04979405 -143.91721839 380.41338223 -145.75 375.625 C-148.67333784 367.83619639 -151.31461128 360.05809954 -153.45214844 352.01611328 C-153.91407938 350.32835293 -154.4498538 348.66110035 -155 347 C-155.66 346.67 -156.32 346.34 -157 346 C-156.70996094 345.23042969 -156.70996094 345.23042969 -156.4140625 344.4453125 C-155.83227142 341.009452 -156.60466757 338.26022232 -157.375 334.875 C-157.65085938 333.63492187 -157.92671875 332.39484375 -158.2109375 331.1171875 C-158.85178291 328.11805642 -158.85178291 328.11805642 -160 326 C-160.36225492 323.51901041 -160.67022356 321.05426761 -160.9375 318.5625 C-161.06390869 317.38941284 -161.06390869 317.38941284 -161.19287109 316.19262695 C-168.73613268 243.54167593 -156.76547923 176.68621267 -122.14819336 112.27050781 C-120.89625322 109.93196449 -120.89625322 109.93196449 -120 107 C-119.0175149 105.98278663 -118.01562631 104.9841256 -117 104 C-116.11251096 102.76457203 -115.25877246 101.50445106 -114.43359375 100.2265625 C-113.95341797 99.49083008 -113.47324219 98.75509766 -112.97851562 97.99707031 C-112.46998047 97.21428711 -111.96144531 96.43150391 -111.4375 95.625 C-106.27918853 87.80020951 -100.8993326 80.28471241 -95 73 C-94.18144531 71.97648437 -93.36289063 70.95296875 -92.51953125 69.8984375 C-85.96072409 61.88454278 -78.73331027 54.52363481 -71.4375 47.1875 C-70.71332382 46.45542328 -70.71332382 46.45542328 -69.97451782 45.70855713 C-61.39603327 37.05780396 -52.33430378 29.20509144 -42.36328125 22.19140625 C-41.91339844 21.79824219 -41.46351563 21.40507812 -41 21 C-41 20.34 -41 19.68 -41 19 C-40.1181604 18.81993408 -40.1181604 18.81993408 -39.21850586 18.63623047 C-36.93629984 17.98173186 -35.45302697 17.15646271 -33.50390625 15.8203125 C-32.86259766 15.38589844 -32.22128906 14.95148438 -31.56054688 14.50390625 C-30.57151367 13.82134766 -30.57151367 13.82134766 -29.5625 13.125 C-28.2520146 12.2307258 -26.94083092 11.33747391 -25.62890625 10.4453125 C-25.00773926 10.0215332 -24.38657227 9.59775391 -23.74658203 9.16113281 C-22.24487349 8.16279261 -20.70182101 7.22714721 -19.15234375 6.3046875 C-16.89349522 5.05225748 -16.89349522 5.05225748 -15 3 C-13.34561387 2.30341637 -11.67745682 1.63903117 -10 1 C-9.0409375 0.4121875 -9.0409375 0.4121875 -8.0625 -0.1875 C-5.02354535 -1.38466395 -3.10054528 -0.90432571 0 0 Z ",
    fill: "#1D1E1E",
    transform: "translate(344,229)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.71631546 0.90543849 5.34771188 1.92474806 8 3 C9.01792772 8.18768261 8.86084514 11.75687083 7.34765625 16.80859375 C6.80141602 18.66967773 6.80141602 18.66967773 6.24414062 20.56835938 C5.85056535 21.858166 5.45668132 23.14787846 5.0625 24.4375 C4.67123976 25.75417575 4.2812535 27.07123078 3.89257812 28.38867188 C2.94083553 31.59639691 1.97632827 34.79968934 1 38 C1.33 37.67 1.66 37.34 2 37 C3.3531791 36.14426967 4.70755946 35.29043856 6.0625 34.4375 C9.55708241 32.15577582 12.30381738 29.75712336 15.125 26.6875 C17.82158847 23.88369131 18.84106825 23.04848765 22.6875 21.875 C26.0249419 22.0009412 28.12458448 22.30857911 31 24 C32.67413706 29.02241117 32.61705021 34.93690591 31 40 C23.04876343 48.40434013 12.76187923 51.74848436 2 55 C2 55.66 2 56.32 2 57 C2.804375 57.20625 3.60875 57.4125 4.4375 57.625 C11.95456058 60.52632163 17.66088688 64.31035226 21.25390625 71.6953125 C22.53299754 75.6464322 22.13692705 77.98731629 21 82 C18.87650125 85.36830836 16.90174618 87.91618162 13 89 C10.18308491 89.09894123 7.69272624 88.85121305 5 88 C1.45874492 84.65548131 -0.66783572 80.24787065 -3 76 C-3.66 76 -4.32 76 -5 76 C-5.18175781 77.16917969 -5.36351562 78.33835937 -5.55078125 79.54296875 C-5.80413415 81.09123648 -6.05807126 82.6394087 -6.3125 84.1875 C-6.43044922 84.95642578 -6.54839844 85.72535156 -6.66992188 86.51757812 C-7.40770238 90.92534371 -8.22689912 94.36415662 -11 98 C-15.35832544 100.90555029 -18.46434198 101.23829176 -23.625 100.4375 C-27.87221321 98.62850178 -29.06840515 97.17224489 -31 93 C-31.62293904 86.77060962 -30.39263321 81.06790186 -29 75 C-29.66 76.32 -30.32 77.64 -31 79 C-32.485 78.01 -32.485 78.01 -34 77 C-34.49628906 77.55429687 -34.99257813 78.10859375 -35.50390625 78.6796875 C-42.76465919 86.42265363 -42.76465919 86.42265363 -49 87 C-52.29601265 85.88059948 -54.26108069 84.97403 -56.375 82.1875 C-57.70522645 77.53170744 -57.41675599 74.24339271 -55.125 70 C-50.29741138 62.87420722 -42.03344333 59.75834704 -34.2265625 56.859375 C-32.07149451 56.02759437 -30.04776475 55.06595973 -28 54 C-28.5775 53.88269531 -29.155 53.76539063 -29.75 53.64453125 C-36.28970776 51.77117746 -41.81187872 47.07957809 -45.6875 41.625 C-47.24236003 38.51527994 -47.93143127 36.49700535 -48 33 C-46.44978427 28.56489083 -44.94968274 25.63312183 -41 23 C-37.66182737 22.48643498 -35.20415331 22.31303184 -32.19921875 24.02734375 C-28.70647852 26.82308482 -26.21929542 29.98439202 -23.78515625 33.72265625 C-23.25929932 34.52582275 -22.73344238 35.32898926 -22.19165039 36.15649414 C-21.79840576 36.76485107 -21.40516113 37.37320801 -21 38 C-20.86424561 37.24904053 -20.72849121 36.49808105 -20.58862305 35.72436523 C-19.96346295 32.29378926 -19.32560072 28.86569153 -18.6875 25.4375 C-18.47416016 24.25607422 -18.26082031 23.07464844 -18.04101562 21.85742188 C-15.82841123 10.06787307 -15.82841123 10.06787307 -13 5 C-12.01 4.67 -11.02 4.34 -10 4 C-9.67 3.01 -9.34 2.02 -9 1 C-8.505 1.495 -8.505 1.495 -8 2 C-3.6590631 1.85841338 -3.6590631 1.85841338 0 0 Z ",
    fill: "#1C1D1F",
    transform: "translate(401,400)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.04094153 -0.00384115 2.08188307 -0.00768229 3.15436828 -0.01163983 C4.87539849 -0.01034011 4.87539849 -0.01034011 6.63119698 -0.00901413 C8.45509805 -0.01347081 8.45509805 -0.01347081 10.31584561 -0.01801753 C13.69709907 -0.02520587 17.07830173 -0.02787747 20.4595592 -0.028615 C24.10381373 -0.03046437 27.74805722 -0.03801106 31.39230537 -0.04475021 C39.36328209 -0.05833826 47.33425378 -0.06435884 55.30524015 -0.06876087 C60.28050245 -0.07152219 65.2557628 -0.07575932 70.23102379 -0.08026505 C84.00111647 -0.09245775 97.77120758 -0.10275744 111.54130554 -0.10614014 C112.42279052 -0.1063597 113.3042755 -0.10657927 114.21247215 -0.10680549 C115.5378915 -0.10713291 115.5378915 -0.10713291 116.89008701 -0.10746694 C118.68067225 -0.10791041 120.47125749 -0.10835697 122.26184273 -0.10880661 C123.15003787 -0.10902804 124.03823302 -0.10924947 124.95334317 -0.10947761 C139.3507524 -0.11342706 153.74811107 -0.13088555 168.14550076 -0.15416613 C182.92053404 -0.17786493 197.69554193 -0.1903413 212.47059453 -0.19150805 C220.76892674 -0.19242558 229.06719304 -0.19819754 237.36550713 -0.21632767 C244.43052136 -0.23170873 251.49544933 -0.23686091 258.56047712 -0.22858956 C262.16615687 -0.2246761 265.77166276 -0.22564637 269.37732124 -0.23964691 C273.28379943 -0.25467706 277.19003138 -0.24654001 281.09652901 -0.23606491 C282.81086705 -0.24814952 282.81086705 -0.24814952 284.55983818 -0.26047826 C286.12907372 -0.25059349 286.12907372 -0.25059349 287.73001099 -0.24050903 C288.63173943 -0.24110612 289.53346788 -0.24170321 290.46252143 -0.24231839 C293.57260291 0.21742508 295.46123689 1.290937 297.99084663 3.13142776 C298.99084663 5.50642776 298.99084663 5.50642776 298.99084663 8.13142776 C297.84925474 10.41461156 296.80071981 12.32155459 294.99084663 14.13142776 C293.38914799 14.23208105 291.78299855 14.26250085 290.1781435 14.26564884 C289.13011718 14.27010669 288.08209086 14.27456453 287.00230616 14.27915746 C285.83677205 14.2789731 284.67123793 14.27878873 283.4703846 14.27859879 C281.62961246 14.28411382 281.62961246 14.28411382 279.75165302 14.28974026 C276.32974766 14.29888925 272.90789034 14.30348163 269.48597729 14.30612957 C265.80148641 14.3100242 262.11700952 14.31960311 258.43252754 14.32834244 C249.52665981 14.34813095 240.62079089 14.35817618 231.71490666 14.36707023 C227.52491682 14.37144931 223.33492826 14.37681711 219.14493942 14.3820591 C205.2230903 14.39907393 191.30124197 14.41356913 177.37938404 14.42080784 C173.76427586 14.42271785 170.14916768 14.42463817 166.53405952 14.42659378 C165.18621907 14.42731939 165.18621907 14.42731939 163.81114952 14.42805966 C149.24802522 14.43636377 134.68498296 14.46170596 120.1218945 14.49417446 C105.18307793 14.52721012 90.24430309 14.54525344 75.30544978 14.54845208 C66.9126396 14.55062045 58.51994904 14.55941664 50.12717438 14.58491325 C42.98082033 14.60657266 35.83461494 14.61469428 28.68823179 14.60494647 C25.04010805 14.60038781 21.39229133 14.602378 17.74420929 14.62170792 C13.79343031 14.64246146 9.84307908 14.63239907 5.8922596 14.61917496 C4.73341765 14.6301442 3.57457569 14.64111345 2.38061732 14.6524151 C1.32476776 14.6438342 0.26891819 14.63525331 -0.81892681 14.62641239 C-1.73123241 14.6273892 -2.64353801 14.62836601 -3.58348924 14.62937242 C-6.79936927 13.96921084 -8.00394354 12.68120518 -10.00915337 10.13142776 C-10.51214653 6.02365027 -10.33664681 4.62266794 -8.00915337 1.13142776 C-5.03730948 0.14081313 -3.10057789 0.0042876 0 0 Z ",
    fill: "#222223",
    transform: "translate(393.00915336608887,687.8685722351074)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C3.59167969 1.84402344 4.18335938 1.68804688 4.79296875 1.52734375 C9.26820283 0.42496146 12.46350296 -0.20083745 17 1 C17.99 0.67 18.98 0.34 20 0 C20 0.66 20 1.32 20 2 C23.3 2 26.6 2 30 2 C30 2.66 30 3.32 30 4 C30.763125 4.268125 31.52625 4.53625 32.3125 4.8125 C35.78528316 6.34698558 37.32917361 7.69780759 39.0625 11.0625 C41.45504697 18.55914719 42.30066608 25.78960341 42.08203125 33.62890625 C42.05516487 34.94072121 42.05516487 34.94072121 42.02775574 36.27903748 C41.98689958 38.1118579 41.94039743 39.94456063 41.88842773 41.77709961 C41.81259531 44.55900351 41.76364239 47.34052125 41.71679688 50.12304688 C41.67349498 51.91670651 41.62862586 53.71032913 41.58203125 55.50390625 C41.56936722 56.32290909 41.55670319 57.14191193 41.5436554 57.98573303 C41.30888976 65.03235002 40.0066378 72.54131119 35.125 77.9375 C34.65320313 78.48277344 34.18140625 79.02804687 33.6953125 79.58984375 C29.84415897 82.79322261 25.73400197 83.27491256 20.859375 83.44921875 C19.70695313 83.49240234 18.55453125 83.53558594 17.3671875 83.58007812 C16.17351563 83.61552734 14.97984375 83.65097656 13.75 83.6875 C12.54085937 83.73455078 11.33171875 83.78160156 10.0859375 83.83007812 C3.50997579 84.05543412 3.50997579 84.05543412 1 84 C-0.75439163 82.24560837 -0.11982963 79.94502544 -0.12442017 77.60829163 C-0.12082489 76.8357756 -0.11722961 76.06325958 -0.11352539 75.26733398 C-0.11367142 74.4576416 -0.11381744 73.64794922 -0.1139679 72.8137207 C-0.11326854 70.12448492 -0.1054751 67.43531751 -0.09765625 64.74609375 C-0.09579215 62.88664284 -0.09436821 61.02719144 -0.09336853 59.16773987 C-0.08954271 54.26370904 -0.07971188 49.35970764 -0.06866455 44.45568848 C-0.05845181 39.45548908 -0.05387121 34.45528494 -0.04882812 29.45507812 C-0.03808967 19.63670579 -0.02101248 9.81835534 0 0 Z M14 13 C14 13.69935165 14 14.39870331 14 15.11924744 C14 33.74616496 14 52.37308248 14 71 C19.91951977 71.44920761 19.91951977 71.44920761 25 69 C26.90632952 63.66868877 27.29521908 58.91366305 27.265625 53.28515625 C27.26753845 52.47058456 27.2694519 51.65601288 27.27142334 50.8167572 C27.27277728 49.10317677 27.26913645 47.3895858 27.26074219 45.67602539 C27.25004518 43.07349255 27.2606572 40.47165207 27.2734375 37.86914062 C27.27211549 36.195311 27.26955225 34.52148179 27.265625 32.84765625 C27.26967346 32.0797023 27.27372192 31.31174835 27.27789307 30.52052307 C27.210196 21.52302765 27.210196 21.52302765 23 14 C20.79749008 13.53993654 20.79749008 13.53993654 18.375 13.375 C17.14910156 13.26285156 17.14910156 13.26285156 15.8984375 13.1484375 C15.27195312 13.09945312 14.64546875 13.05046875 14 13 Z ",
    fill: "#1D1E1F",
    transform: "translate(517,712)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.55740603 2.45474016 7.58572098 6.39955614 9.8203125 10.98046875 C11.03550045 16.38899957 10.99860914 21.7632125 11.0234375 27.27734375 C11.02913757 28.2661554 11.03483765 29.25496704 11.04071045 30.27374268 C11.05013172 32.36152079 11.05668297 34.44931358 11.06054688 36.53710938 C11.07023766 39.70599766 11.10128279 42.87423281 11.1328125 46.04296875 C11.13934512 48.07942327 11.14459457 50.11588238 11.1484375 52.15234375 C11.1607843 53.08810242 11.1731311 54.02386108 11.18585205 54.98797607 C11.16086532 62.48818871 10.19252025 70.25069916 5.5703125 76.41796875 C-0.31332396 81.90044818 -5.47844607 82.49632992 -13.30859375 82.26171875 C-18.6591492 81.73758271 -22.35242799 80.18704877 -25.9921875 76.10546875 C-29.57475814 70.98751069 -30.4338776 67.01820476 -30.7421875 60.79296875 C-30.82126184 56.22319666 -30.82126184 56.22319666 -32.1796875 51.98046875 C-32.5096875 51.32046875 -32.8396875 50.66046875 -33.1796875 49.98046875 C-32.5196875 49.98046875 -31.8596875 49.98046875 -31.1796875 49.98046875 C-31.18492432 49.11881104 -31.19016113 48.25715332 -31.19555664 47.36938477 C-31.21273354 44.13208265 -31.22520281 40.89480399 -31.23461914 37.6574707 C-31.23960707 36.26390818 -31.24639981 34.87035077 -31.25512695 33.47680664 C-31.38603284 12.01594232 -31.38603284 12.01594232 -28.1796875 5.98046875 C-27.5196875 5.65046875 -26.8596875 5.32046875 -26.1796875 4.98046875 C-25.5196875 3.99046875 -24.8596875 3.00046875 -24.1796875 1.98046875 C-16.13674025 -2.48949636 -8.5878956 -3.58670934 0 0 Z M-13.1796875 10.98046875 C-15.84536936 13.41435219 -17.0624425 15.24075251 -17.31340027 18.96453857 C-17.31721207 19.71841858 -17.32102386 20.47229858 -17.32495117 21.24902344 C-17.33133102 22.10711609 -17.33771088 22.96520874 -17.34428406 23.8493042 C-17.34539688 24.77430725 -17.3465097 25.6993103 -17.34765625 26.65234375 C-17.35098465 27.60812317 -17.35431305 28.56390259 -17.35774231 29.54864502 C-17.3628069 31.5727897 -17.36515078 33.59694274 -17.36499023 35.62109375 C-17.3671692 38.70456902 -17.38530914 41.78768214 -17.40429688 44.87109375 C-17.40723246 46.83984253 -17.40921615 48.80859301 -17.41015625 50.77734375 C-17.41734177 51.69424988 -17.42452728 52.61115601 -17.43193054 53.55584717 C-17.41362511 58.73637381 -17.08368001 63.13192507 -15.1796875 67.98046875 C-12.35251537 70.31343126 -12.35251537 70.31343126 -9.1171875 69.73046875 C-6.0802285 69.22114435 -6.0802285 69.22114435 -4.1796875 66.98046875 C-2.73856108 62.2385502 -3.01783827 57.24166204 -3.01171875 52.33203125 C-3.00839035 51.40127777 -3.00506195 50.47052429 -3.00163269 49.51156616 C-2.99658011 47.54645276 -2.99422385 45.58133082 -2.99438477 43.61621094 C-2.99220022 40.62290183 -2.97403205 37.62996263 -2.95507812 34.63671875 C-2.9521434 32.7226575 -2.95015913 30.80859452 -2.94921875 28.89453125 C-2.94203323 28.00577301 -2.93484772 27.11701477 -2.92744446 26.20132446 C-2.94614413 21.07014785 -3.51623465 16.84185509 -5.1796875 11.98046875 C-6.1696875 11.98046875 -7.1596875 11.98046875 -8.1796875 11.98046875 C-8.5096875 12.31046875 -8.8396875 12.64046875 -9.1796875 12.98046875 C-10.51302083 12.31380208 -11.84635417 11.64713542 -13.1796875 10.98046875 Z ",
    fill: "#1C1D1E",
    transform: "translate(620.1796875,714.01953125)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C7.65 1.34 9.3 0.68 11 0 C12.80503885 1.80503885 12.16264337 4.56693546 12.18945312 7.00097656 C12.20617065 8.28611145 12.22288818 9.57124634 12.2401123 10.89532471 C12.24679428 11.58677834 12.25347626 12.27823196 12.26036072 12.99063873 C12.28135362 15.15128964 12.30838297 17.31178908 12.33703613 19.47235107 C12.39683044 24.06484245 12.44887672 28.65740505 12.5 33.25 C12.55928077 38.55764217 12.62173555 43.86521127 12.69187927 49.17272186 C12.71837553 51.29808722 12.73924378 53.42346007 12.7598877 55.54888916 C12.77660522 56.84663269 12.79332275 58.14437622 12.81054688 59.48144531 C12.82307495 60.62204407 12.83560303 61.76264282 12.84851074 62.93780518 C12.98686095 65.73440813 13.36504453 68.2781385 14 71 C18.65052872 71.26932521 18.65052872 71.26932521 23 70 C24.10154467 66.69536599 24.15818717 64.17389081 24.20532227 60.69262695 C24.22526749 59.39150467 24.24521271 58.09038239 24.26576233 56.74983215 C24.28274546 55.3293164 24.29962431 53.9087994 24.31640625 52.48828125 C24.33698137 51.03524694 24.35797799 49.58221854 24.37937927 48.12919617 C24.43454234 44.3070047 24.48397698 40.48475974 24.53222656 36.66247559 C24.58248372 32.76126348 24.63814778 28.86012895 24.69335938 24.95898438 C24.80087041 17.30605531 24.90233098 9.65306167 25 2 C28.68890899 0.77036367 32.13699206 0.44329599 36 0 C36 0.66 36 1.32 36 2 C36.99 2.33 37.98 2.66 39 3 C39.04652964 10.92834458 39.08197329 18.85663123 39.10362434 26.785079 C39.11402058 30.46736443 39.12810285 34.1495558 39.15087891 37.83178711 C39.17275687 41.39147415 39.18459984 44.95107125 39.18975449 48.51082039 C39.19519796 50.51639398 39.21078654 52.52193187 39.22659302 54.52745056 C39.2287848 72.52761532 39.2287848 72.52761532 33.6875 78.4375 C33.11386719 79.07558594 32.54023438 79.71367188 31.94921875 80.37109375 C26.16621572 85.20378366 19.14002272 84.55894117 12 84 C6.62889526 82.33984035 2.80460489 78.84273391 0 74 C-1.35685799 69.37376037 -2 64.81622243 -2 60 C-2.66 60 -3.32 60 -4 60 C-4 58.68 -4 57.36 -4 56 C-3.34 56 -2.68 56 -2 56 C-2.00444122 55.37217117 -2.00888245 54.74434235 -2.01345825 54.0974884 C-2.05772275 47.56005124 -2.08787946 41.02265669 -2.10986328 34.48510742 C-2.1199176 32.0456367 -2.13356292 29.60617803 -2.15087891 27.16674805 C-2.17515182 23.65931221 -2.18648891 20.15203579 -2.1953125 16.64453125 C-2.20563507 15.55477493 -2.21595764 14.46501862 -2.22659302 13.34223938 C-2.22681961 11.81121834 -2.22681961 11.81121834 -2.22705078 10.24926758 C-2.231492 9.35436111 -2.23593323 8.45945465 -2.24050903 7.53742981 C-1.97350263 4.72044624 -1.16460699 2.56584518 0 0 Z M-2 56 C-2.33 56.66 -2.66 57.32 -3 58 C-2.34 58 -1.68 58 -1 58 C-1.33 57.34 -1.66 56.68 -2 56 Z ",
    fill: "#1D1F20",
    transform: "translate(469,712)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.40534923 3.01687492 5.89358554 6.57434215 7 11 C7.14928287 14.34084776 7.11678634 17.65861317 7 21 C5.2300132 21.19532961 3.45895721 21.38098882 1.6875 21.5625 C0.70136719 21.66691406 -0.28476562 21.77132812 -1.30078125 21.87890625 C-4 22 -4 22 -7 21 C-7.19916016 19.93458984 -7.19916016 19.93458984 -7.40234375 18.84765625 C-7.57894531 17.92855469 -7.75554687 17.00945313 -7.9375 16.0625 C-8.11152344 15.14597656 -8.28554688 14.22945312 -8.46484375 13.28515625 C-8.77714988 11.04710156 -8.77714988 11.04710156 -10 10 C-12.33297433 9.95907063 -14.66705225 9.95758277 -17 10 C-19.27067953 15.20920597 -19.46238035 19.57250781 -18 25 C-15.24433591 29.50091801 -11.84684515 31.89474059 -7.5625 34.9375 C0.72705737 40.83948633 5.00799299 45.8588734 7 56 C7.78508853 62.28070826 6.01392618 67.52856479 3 73 C-0.64803001 77.29767919 -5.28253599 79.71492544 -10.8671875 80.30078125 C-23.354531 80.34943324 -23.354531 80.34943324 -28.68359375 75.453125 C-34.24744587 69.42228289 -35.27603452 64.00500117 -35 56 C-26.57142857 53.57142857 -26.57142857 53.57142857 -22 55 C-21.67 54.34 -21.34 53.68 -21 53 C-20.34 57.62 -19.68 62.24 -19 67 C-14.96797664 67.35131202 -14.96797664 67.35131202 -11 67 C-8.91783124 64.6450037 -8.91783124 64.6450037 -8 62 C-8.66 62 -9.32 62 -10 62 C-9.67 61.34 -9.34 60.68 -9 60 C-8.34 60.33 -7.68 60.66 -7 61 C-7 60.34 -7 59.68 -7 59 C-7.66 59 -8.32 59 -9 59 C-9 57.989375 -9 56.97875 -9 55.9375 C-9.62677026 51.33494821 -12.44411937 49.30941808 -15.89453125 46.48046875 C-17.86960904 45.09168492 -19.81050385 44.00864429 -22 43 C-22 42.34 -22 41.68 -22 41 C-22.89332031 40.62101563 -22.89332031 40.62101563 -23.8046875 40.234375 C-26.26973104 38.84833628 -27.44981328 37.51281766 -29.125 35.25 C-29.62257813 34.59515625 -30.12015625 33.9403125 -30.6328125 33.265625 C-34.82614788 26.31666922 -34.72017174 18.87687839 -34 11 C-32.37135357 5.04988834 -29.05869451 1.37246301 -24 -2 C-15.31740175 -5.37656598 -7.85609686 -4.87257916 0 0 Z ",
    fill: "#1E1F20",
    transform: "translate(412,716)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.31903207 3.38011206 6.37329828 6.77743133 8 12 C8.22538071 15.35131315 8.18211987 18.64764529 8 22 C5.85473901 22.19393875 3.70876323 22.37998676 1.5625 22.5625 C0.36753906 22.66691406 -0.82742188 22.77132812 -2.05859375 22.87890625 C-3.51458984 22.93884766 -3.51458984 22.93884766 -5 23 C-6.73605513 21.26394487 -6.65611982 18.79450504 -7.0625 16.4375 C-7.23910156 15.42558594 -7.41570313 14.41367187 -7.59765625 13.37109375 C-7.79681641 12.19740234 -7.79681641 12.19740234 -8 11 C-10.64 11 -13.28 11 -16 11 C-17.90068959 16.78411293 -18.4478629 21.2060228 -16.1640625 26.9453125 C-13.6542585 31.37536922 -9.55993878 33.88297675 -5.49609375 36.79296875 C0.61880367 41.35863732 4.94473146 45.48122866 7 53 C7.89662314 60.17298512 8.03843873 67.11708718 4.20703125 73.453125 C1.47107449 76.95939969 -1.90902657 79.34530335 -6 81 C-13.35720556 81.69001806 -20.63538367 82.06252106 -27 78 C-30.75957828 74.39201762 -33.82595004 70.49239546 -34.1953125 65.203125 C-34.17210937 64.22859375 -34.14890625 63.2540625 -34.125 62.25 C-34.09792969 60.77273438 -34.09792969 60.77273438 -34.0703125 59.265625 C-34.03550781 58.14414062 -34.03550781 58.14414062 -34 57 C-31.37670316 55.68835158 -29.36301375 55.86737154 -26.4375 55.875 C-25.44621094 55.87242187 -24.45492187 55.86984375 -23.43359375 55.8671875 C-21 56 -21 56 -20 57 C-19.6068352 58.67884238 -19.25914548 60.36850045 -18.9375 62.0625 C-18.67259766 63.44115234 -18.67259766 63.44115234 -18.40234375 64.84765625 C-18.26957031 65.55792969 -18.13679687 66.26820313 -18 67 C-12.71800407 68.19988045 -12.71800407 68.19988045 -8 66 C-6.98762804 60.83690299 -7.2441793 56.31008922 -9.875 51.75 C-13.07036271 48.58202611 -16.92392952 46.16871703 -20.6328125 43.6484375 C-27.24414811 39.04450412 -30.50096172 33.49711483 -33 26 C-33.63595216 16.94991159 -33.19727426 10.8510368 -28.1875 3.25 C-20.46281331 -4.69539203 -9.50581636 -4.44915089 0 0 Z ",
    fill: "#1E1F20",
    transform: "translate(671,715)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.82948373 0.62528239 9.49968436 0.45964572 14.29296875 -0.390625 C18.90887346 -1.06835704 22.09394022 0.42230869 26.29296875 2.296875 C27.54296875 9.921875 27.54296875 9.921875 25.29296875 13.296875 C22.25390625 13.58984375 22.25390625 13.58984375 18.66796875 13.484375 C17.47945313 13.45730469 16.2909375 13.43023438 15.06640625 13.40234375 C14.15117187 13.36753906 13.2359375 13.33273437 12.29296875 13.296875 C12.30771744 14.13181488 12.32246613 14.96675476 12.33766174 15.82699585 C12.47555223 23.68471548 12.60852427 31.54249948 12.73593235 39.40039635 C12.80161303 43.44048594 12.86921427 47.48052458 12.94116211 51.52050781 C13.010489 55.41724907 13.0748266 59.31404333 13.13566399 63.21092606 C13.15979213 64.69974396 13.18573659 66.18853355 13.21350288 67.67728806 C13.2520025 69.75795816 13.28411919 71.83863414 13.31469727 73.91943359 C13.33468277 75.10524017 13.35466827 76.29104675 13.3752594 77.51278687 C13.29296875 80.296875 13.29296875 80.296875 12.29296875 82.296875 C9.32296875 82.296875 6.35296875 82.296875 3.29296875 82.296875 C3.29296875 82.956875 3.29296875 83.616875 3.29296875 84.296875 C1.35546875 83.734375 1.35546875 83.734375 -0.70703125 82.296875 C-2.28365476 75.42858137 -1.83253807 68.2745331 -1.8046875 61.26953125 C-1.80281965 59.91190137 -1.80139748 58.55427081 -1.80039978 57.19664001 C-1.79660347 53.64405416 -1.78679821 50.09150996 -1.7756958 46.53894043 C-1.76541926 42.90552331 -1.76088885 39.27209938 -1.75585938 35.63867188 C-1.74517302 28.52472103 -1.72759997 21.41080514 -1.70703125 14.296875 C-5.33703125 13.966875 -8.96703125 13.636875 -12.70703125 13.296875 C-12.70703125 9.336875 -12.70703125 5.376875 -12.70703125 1.296875 C-8.07668205 -0.72148234 -4.84631596 -0.6818937 0 0 Z ",
    fill: "#1B1C1D",
    transform: "translate(436.70703125,712.703125)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 2 3 2 3.68614197 4.15348816 C4.06952764 7.63057571 4.08697398 11.05321427 4.02172852 14.54418945 C4.0073172 15.6571917 4.0073172 15.6571917 3.99261475 16.79267883 C3.95976599 19.2329805 3.91938046 21.67309515 3.87890625 24.11328125 C3.85459131 25.81006725 3.83074844 27.50686007 3.80735779 29.20365906 C3.74465357 33.66053059 3.6755485 38.11728065 3.60510254 42.57403564 C3.53429542 47.1254729 3.46955262 51.67699599 3.40429688 56.22851562 C3.27546074 65.1524381 3.1398612 74.07624398 3 83 C-1 84 -1 84 -11 83 C-11 56.27 -11 29.54 -11 2 C-6.74213431 -0.12893285 -4.66111976 -0.33899053 0 0 Z ",
    fill: "#222324",
    transform: "translate(577,712)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C98.01 0 196.02 0 297 0 C297.33 1.65 297.66 3.3 298 5 C297.01 4.34 296.02 3.68 295 3 C292.65951721 2.69557506 292.65951721 2.69557506 290.00811481 2.73828697 C288.45252746 2.72708873 288.45252746 2.72708873 286.8655141 2.71566427 C285.72253193 2.717599 284.57954976 2.71953374 283.40193176 2.7215271 C282.19063699 2.7157347 280.97934222 2.7099423 279.73134154 2.70397437 C276.36319271 2.68987873 272.99524226 2.6847416 269.62707818 2.68332577 C265.99721585 2.6796384 262.3673996 2.66448628 258.73756409 2.65071106 C252.44665316 2.62841349 246.15575858 2.61341525 239.86481667 2.60334396 C230.76912398 2.588772 221.67348819 2.56323938 212.57782885 2.53501268 C197.82151358 2.48951768 183.06519013 2.45291409 168.30883789 2.421875 C153.97256025 2.39170053 139.63630264 2.35735535 125.30004883 2.31738281 C124.41668631 2.31492126 123.53332379 2.31245972 122.62319271 2.30992357 C118.19171932 2.29754919 113.76024618 2.28509261 109.32877314 2.27259517 C72.55254304 2.16898684 35.77628909 2.07979698 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#040505",
    transform: "translate(392,689)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 27.73 2 54.46 2 82 C1.34 81.67 0.68 81.34 0 81 C0.33 55.59 0.66 30.18 1 4 C-2.3 4 -5.6 4 -9 4 C-9 29.41 -9 54.82 -9 81 C-6.36 81 -3.72 81 -1 81 C-1.495 81.99 -1.495 81.99 -2 83 C-4.97 83 -7.94 83 -11 83 C-11 56.27 -11 29.54 -11 2 C-6.75824072 -0.12087964 -4.6377859 -0.25765477 0 0 Z ",
    fill: "#181919",
    transform: "translate(577,712)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0.33 7.92 0.66 12 1 C12 1.33 12 1.66 12 2 C8.7 2 5.4 2 2 2 C2 24.11 2 46.22 2 69 C1.34 69 0.68 69 0 69 C-0.33 65.37 -0.66 61.74 -1 58 C-1.66 58 -2.32 58 -3 58 C-3 56.68 -3 55.36 -3 54 C-2.34 54 -1.68 54 -1 54 C-1.00222061 53.36772995 -1.00444122 52.7354599 -1.00672913 52.08403015 C-1.02882064 45.51444055 -1.04392283 38.94486147 -1.05493164 32.37524414 C-1.0599662 29.92211478 -1.06679424 27.46898843 -1.07543945 25.01586914 C-1.08754332 21.4936448 -1.09323703 17.97146006 -1.09765625 14.44921875 C-1.10281754 13.34913986 -1.10797882 12.24906097 -1.11329651 11.11564636 C-1.11337204 10.09481461 -1.11344757 9.07398285 -1.11352539 8.0222168 C-1.115746 7.12286911 -1.11796661 6.22352142 -1.12025452 5.29692078 C-1 3 -1 3 0 0 Z M-1 54 C-1.33 54.66 -1.66 55.32 -2 56 C-1.34 56 -0.68 56 0 56 C-0.33 55.34 -0.66 54.68 -1 54 Z ",
    fill: "#151516",
    transform: "translate(468,714)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C3.59167969 1.84402344 4.18335938 1.68804688 4.79296875 1.52734375 C9.26820283 0.42496146 12.46350296 -0.20083745 17 1 C17.99 0.67 18.98 0.34 20 0 C20 0.66 20 1.32 20 2 C22.64 2 25.28 2 28 2 C28 2.33 28 2.66 28 3 C19.09 3 10.18 3 1 3 C1 29.4 1 55.8 1 83 C0.67 83 0.34 83 0 83 C0 55.61 0 28.22 0 0 Z ",
    fill: "#3F3F3F",
    transform: "translate(517,712)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.39092132 0.13477303 8.29355889 2.30072116 12.1015625 5.82421875 C17.77723978 12.32905875 20.14032178 19.704926 20.0625 28.1875 C20.05347656 29.45980469 20.04445313 30.73210938 20.03515625 32.04296875 C20.02355469 33.01878906 20.01195312 33.99460937 20 35 C23.3 35 26.6 35 30 35 C29.67 35.66 29.34 36.32 29 37 C26.75 37.44921875 26.75 37.44921875 24 37.6875 C23.0925 37.77386719 22.185 37.86023438 21.25 37.94921875 C20.5075 37.96597656 19.765 37.98273437 19 38 C17.16702947 36.16702947 17.78110145 33.09072954 17.6875 30.625 C17.06121831 21.16332891 15.00651749 12.68803943 8 6 C5.90103621 4.56551264 3.78169397 3.24130025 1.57421875 1.98046875 C1.05472656 1.65691406 0.53523437 1.33335937 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(599,547)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.02283554 0.71552536 1.04567108 1.43105072 1.06919861 2.16825867 C1.28546722 8.92155326 1.50574458 15.6747039 1.73049068 22.42772198 C1.84588567 25.89925734 1.95974691 29.3708287 2.07006836 32.8425293 C2.1970569 36.83658614 2.33077848 40.83039314 2.46484375 44.82421875 C2.50343002 46.06709152 2.5420163 47.30996429 2.58177185 48.59049988 C2.64172081 50.33173882 2.64172081 50.33173882 2.70288086 52.1081543 C2.73619003 53.12741501 2.76949921 54.14667572 2.80381775 55.19682312 C2.99142689 57.87750198 3.40867308 60.38161992 4 63 C7.3 63.33 10.6 63.66 14 64 C10.64672361 66.23551759 10.09256343 66.17283528 6.3125 65.625 C5.50425781 65.51414062 4.69601562 65.40328125 3.86328125 65.2890625 C3.24839844 65.19367188 2.63351562 65.09828125 2 65 C0.21177031 61.15386408 -0.24485088 58.15208344 -0.22705078 53.92456055 C-0.22689972 52.72369308 -0.22674866 51.52282562 -0.22659302 50.28556824 C-0.21627045 48.99894791 -0.20594788 47.71232758 -0.1953125 46.38671875 C-0.19157912 45.04865226 -0.18873368 43.71058303 -0.18673706 42.37251282 C-0.17912616 38.86258301 -0.15949982 35.35282055 -0.1373291 31.84295654 C-0.11681564 28.25665551 -0.10772362 24.67032726 -0.09765625 21.08398438 C-0.07625129 14.05592115 -0.04214631 7.02796862 0 0 Z ",
    fill: "#0C0D0D",
    transform: "translate(479,720)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.66 5.94 2.32 11.88 3 18 C3.33 18 3.66 18 4 18 C4.05828635 22.20827473 4.093693 26.41644489 4.125 30.625 C4.15013672 32.40970703 4.15013672 32.40970703 4.17578125 34.23046875 C4.18222656 35.38417969 4.18867187 36.53789063 4.1953125 37.7265625 C4.20578613 38.78439941 4.21625977 39.84223633 4.22705078 40.93212891 C3.98019336 44.2676239 3.28489305 46.91659496 2 50 C1.01 50.495 1.01 50.495 0 51 C0 34.17 0 17.34 0 0 Z ",
    fill: "#262728",
    transform: "translate(627,733)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65061922 2.9138835 2.27090714 5.09132962 2.38232422 8.4296875 C2.4314949 9.73123779 2.4314949 9.73123779 2.48165894 11.05908203 C2.50575836 11.98833496 2.52985779 12.91758789 2.5546875 13.875 C2.58354034 14.83647949 2.61239319 15.79795898 2.64212036 16.78857422 C2.69911943 18.81919948 2.75090589 20.84997682 2.79785156 22.88085938 C2.87473632 25.98933921 2.98354263 29.0956709 3.09375 32.203125 C3.14519224 34.17703315 3.19473538 36.1509919 3.2421875 38.125 C3.27843231 39.05425293 3.31467712 39.98350586 3.35202026 40.94091797 C3.45538546 47.40856165 3.45538546 47.40856165 0.98486328 50.6171875 C0.00235596 51.30167969 0.00235596 51.30167969 -1 52 C-1.02514475 47.16601927 -1.04306491 42.33207847 -1.05493164 37.49804688 C-1.05989045 35.86132136 -1.06665953 34.2246001 -1.07543945 32.58789062 C-1.13240371 21.67755934 -0.8320668 10.88159519 0 0 Z ",
    fill: "#111212",
    transform: "translate(617,728)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2.05076475 7.31710371 2.0857608 13.63415469 2.10986328 19.95141602 C2.11991265 22.09987351 2.13355433 24.24831737 2.15087891 26.39672852 C2.17517376 29.48717622 2.18649386 32.57744287 2.1953125 35.66796875 C2.20563507 36.62648239 2.21595764 37.58499603 2.22659302 38.57255554 C2.22736062 43.14860751 2.20761889 46.85594033 0 51 C-0.33 51 -0.66 51 -1 51 C-1.02541101 44.70118066 -1.04289254 38.40237461 -1.05493164 32.10351562 C-1.05995204 29.96190904 -1.06676969 27.82030586 -1.07543945 25.67871094 C-1.08760549 22.59569454 -1.09325133 19.51272357 -1.09765625 16.4296875 C-1.10281754 15.47633514 -1.10797882 14.52298279 -1.11329651 13.54074097 C-1.11368501 8.90907835 -0.95837521 4.55642749 0 0 Z ",
    fill: "#0C0D0D",
    transform: "translate(544,731)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.91850553 7.77449325 2.10942263 15.49136025 2.125 23.3125 C2.13176758 24.72619873 2.13176758 24.72619873 2.13867188 26.16845703 C2.12793636 31.22040938 1.86529886 36.02109782 1 41 C-0.485 41.495 -0.485 41.495 -2 42 C-1.8820735 36.17913293 -1.75784958 30.3584481 -1.62768555 24.5378418 C-1.58426856 22.55610854 -1.54259863 20.57433622 -1.50268555 18.5925293 C-1.44514617 15.7503683 -1.38140555 12.90840517 -1.31640625 10.06640625 C-1.29969376 9.17474258 -1.28298126 8.28307892 -1.26576233 7.36439514 C-1.11387171 1.11387171 -1.11387171 1.11387171 0 0 Z ",
    fill: "#1A1A1B",
    transform: "translate(506,743)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.91587891 -0.01224609 1.83175781 -0.02449219 2.77539062 -0.03710938 C8.10883415 -0.04859561 12.51895496 0.43231858 17.5625 2.1875 C17.5625 4.8275 17.5625 7.4675 17.5625 10.1875 C16.5725 10.1875 15.5825 10.1875 14.5625 10.1875 C14.5625 8.2075 14.5625 6.2275 14.5625 4.1875 C4.3325 4.1875 -5.8975 4.1875 -16.4375 4.1875 C-16.4375 3.1975 -16.4375 2.2075 -16.4375 1.1875 C-10.94433143 0.04499406 -5.58389027 0.00391303 0 0 Z ",
    fill: "#141414",
    transform: "translate(375.4375,542.8125)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.57142857 -0.28571429 8.57142857 -0.28571429 12 2 C12 2.33 12 2.66 12 3 C8.37 2.67 4.74 2.34 1 2 C1 21.47 1 40.94 1 61 C3.97 61 6.94 61 10 61 C10 61.33 10 61.66 10 62 C6.37 62 2.74 62 -1 62 C-1.02257029 54.21151485 -1.04092629 46.42304749 -1.05181217 38.63453865 C-1.05703619 35.01822828 -1.06412515 31.40194139 -1.07543945 27.78564453 C-1.08628538 24.29731896 -1.09228047 20.80901602 -1.09487724 17.3206749 C-1.09763081 15.33862308 -1.1054401 13.3565804 -1.11329651 11.37454224 C-1.11337204 10.17344818 -1.11344757 8.97235413 -1.11352539 7.73486328 C-1.115746 6.67341095 -1.11796661 5.61195862 -1.12025452 4.51834106 C-1 2 -1 2 0 0 Z ",
    fill: "#050606",
    transform: "translate(529,723)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.25 7.625 1.25 7.625 -1 11 C-4.0390625 11.29296875 -4.0390625 11.29296875 -7.625 11.1875 C-8.81351562 11.16042969 -10.00203125 11.13335938 -11.2265625 11.10546875 C-12.14179688 11.07066406 -13.05703125 11.03585937 -14 11 C-14 10.67 -14 10.34 -14 10 C-10.04 10 -6.08 10 -2 10 C-2 9.34 -2 8.68 -2 8 C-2.66 8 -3.32 8 -4 8 C-4 6.02 -4 4.04 -4 2 C-9.94 2 -15.88 2 -22 2 C-20.68 1.34 -19.36 0.68 -18 0 C-17.67 -0.66 -17.34 -1.32 -17 -2 C-10.49942422 -3.50906223 -6.11001727 -2.50340985 0 0 Z ",
    fill: "#292A2A",
    transform: "translate(463,715)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C0.99 2.33 1.98 2.66 3 3 C-1.29 3 -5.58 3 -10 3 C-10 24.12 -10 45.24 -10 67 C-10.33 67 -10.66 67 -11 67 C-11 45.55 -11 24.1 -11 2 C-7.2701171 0.7567057 -3.93878291 0 0 0 Z ",
    fill: "#404142",
    transform: "translate(505,712)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.72058594 0.09925781 1.44117188 0.19851563 2.18359375 0.30078125 C3.90034936 0.57985975 5.61360506 0.8807725 7.32421875 1.1953125 C11.19389785 1.78346638 15.03223055 2.03460991 18.9375 2.25 C19.67355469 2.29318359 20.40960938 2.33636719 21.16796875 2.38085938 C22.96598068 2.48593799 24.76421958 2.58712093 26.5625 2.6875 C26.5625 3.0175 26.5625 3.3475 26.5625 3.6875 C15.0125 3.6875 3.4625 3.6875 -8.4375 3.6875 C-8.4375 6.3275 -8.4375 8.9675 -8.4375 11.6875 C-4.8075 11.6875 -1.1775 11.6875 2.5625 11.6875 C2.5625 12.0175 2.5625 12.3475 2.5625 12.6875 C-1.3975 12.6875 -5.3575 12.6875 -9.4375 12.6875 C-9.4375 9.0575 -9.4375 5.4275 -9.4375 1.6875 C-3.80965355 -0.56363858 -3.80965355 -0.56363858 0 0 Z ",
    fill: "#0D0E0E",
    transform: "translate(434.4375,712.3125)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C27.72 0 55.44 0 84 0 C84 0.33 84 0.66 84 1 C56.28 1 28.56 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#363536",
    transform: "translate(531,703)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C3.55240398 9.90681177 3.0277443 19.5740324 2.625 29.6875 C2.56662754 31.37170768 2.50932762 33.05595289 2.453125 34.74023438 C2.31443737 38.82736044 2.16127175 42.91370532 2 47 C1.67 47 1.34 47 1 47 C-0.27096493 42.12283698 -0.12655874 37.32429344 -0.09765625 32.32421875 C-0.0962413 31.3990596 -0.09482635 30.47390045 -0.09336853 29.52070618 C-0.08778715 26.57627073 -0.07523805 23.63191233 -0.0625 20.6875 C-0.05748259 18.68685006 -0.05292011 16.68619892 -0.04882812 14.68554688 C-0.03782381 9.79033506 -0.02057198 4.89518058 0 0 Z ",
    fill: "#060707",
    transform: "translate(192,478)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.35360596 0.64743164 0.70721191 1.29486328 1.0715332 1.96191406 C2.89941778 4.29916605 2.89941778 4.29916605 6.09448242 4.54589844 C7.95617065 4.57731934 7.95617065 4.57731934 9.85546875 4.609375 C10.51710526 4.62591125 11.17874176 4.64244751 11.86042786 4.65948486 C13.96954601 4.70799288 16.07794323 4.72933927 18.1875 4.75 C19.61917695 4.77815777 21.05082028 4.80808495 22.48242188 4.83984375 C25.98812393 4.91374893 29.49368875 4.96330788 33 5 C33.495 5.99 33.495 5.99 34 7 C29.31860746 7.02465288 24.63725241 7.04283739 19.95581055 7.05493164 C18.36205386 7.05997157 16.76830181 7.0668035 15.17456055 7.07543945 C12.88849747 7.08751999 10.60249533 7.09323155 8.31640625 7.09765625 C7.59973282 7.10281754 6.88305939 7.10797882 6.14466858 7.11329651 C4.42936328 7.11349263 2.71418734 7.06192007 1 7 C0 6 0 6 -0.0625 2.9375 C-0.041875 1.968125 -0.02125 0.99875 0 0 Z ",
    fill: "#0A0B0B",
    transform: "translate(457,369)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C24.09 0 48.18 0 73 0 C73 0.33 73 0.66 73 1 C48.91 1 24.82 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#353535",
    transform: "translate(426,703)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.62 1 9.24 1 14 C9.25 14 17.5 14 26 14 C25.67 14.99 25.34 15.98 25 17 C22.69 17 20.38 17 18 17 C18 16.67 18 16.34 18 16 C14.04 15.67 10.08 15.34 6 15 C5.67 15.66 5.34 16.32 5 17 C2.07175348 16.02391783 0.38573379 14.89213369 -2 13 C-1.48041715 8.62065881 -0.94324258 4.31196609 0 0 Z ",
    fill: "#2F302F",
    transform: "translate(378,359)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.16257324 0.01047363 2.32514648 0.02094727 3.52294922 0.03173828 C5.40820312 0.04140625 5.40820312 0.04140625 7.33154297 0.05126953 C9.30960938 0.07640625 9.30960938 0.07640625 11.32763672 0.10205078 C12.66747393 0.11208096 14.00731823 0.12120674 15.34716797 0.12939453 C18.63250244 0.15303003 21.91748137 0.18597844 25.20263672 0.22705078 C25.53263672 1.87705078 25.86263672 3.52705078 26.20263672 5.22705078 C25.21263672 5.72205078 25.21263672 5.72205078 24.20263672 6.22705078 C24.20263672 4.90705078 24.20263672 3.58705078 24.20263672 2.22705078 C14.63263672 2.22705078 5.06263672 2.22705078 -4.79736328 2.22705078 C-2.79736328 0.22705078 -2.79736328 0.22705078 0 0 Z ",
    fill: "#0A0A0A",
    transform: "translate(762.79736328125,450.77294921875)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.556875 0.70125 1.11375 1.4025 1.6875 2.125 C2.8321875 3.548125 2.8321875 3.548125 4 5 C4.763125 6.010625 5.52625 7.02125 6.3125 8.0625 C11.52445684 13.75929003 17.78245115 15.83964524 25 18 C25 18.33 25 18.66 25 19 C18.01685475 19.63483139 13.62019855 18.21758401 8 14 C0.13629034 6.76434036 0.13629034 6.76434036 -0.21484375 2.21875 C-0.14394531 1.4865625 -0.07304687 0.754375 0 0 Z ",
    fill: "#141414",
    transform: "translate(221,508)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C11.22 0 22.44 0 34 0 C34 0.33 34 0.66 34 1 C18.16 1.495 18.16 1.495 2 2 C1.67 4.31 1.34 6.62 1 9 C0.34 9.66 -0.32 10.32 -1 11 C-1.07622858 7.03611362 -0.9681648 3.8726592 0 0 Z ",
    fill: "#0A0B0B",
    transform: "translate(638,403)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.19397476 1.97854258 1.38001321 3.9578648 1.5625 5.9375 C1.66691406 7.03964844 1.77132813 8.14179687 1.87890625 9.27734375 C1.91886719 10.17582031 1.95882813 11.07429687 2 12 C0.03177114 13.96822886 -3.34808709 13.66248381 -6 14 C-6 16.64 -6 19.28 -6 22 C-9 21 -9 21 -11 18 C-11.33 18 -11.66 18 -12 18 C-12 16.35 -12 14.7 -12 13 C-11.01 13.495 -11.01 13.495 -10 14 C-9.67 13.67 -9.34 13.34 -9 13 C-5.55393517 10.67157782 -4.29713755 10 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#262727",
    transform: "translate(476,571)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.8125 1.625 0.8125 1.625 1 4 C-1.64109418 8.04417546 -4.18150282 10.78022107 -8.8203125 12.54296875 C-13.48107063 13.52022449 -18.26727675 13.20982517 -23 13 C-23 12.34 -23 11.68 -23 11 C-22.29875 10.97421875 -21.5975 10.9484375 -20.875 10.921875 C-14.57790823 10.54541843 -9.14336338 9.88475211 -4 6 C-2.33028828 4.06540484 -1.23409533 2.2625081 0 0 Z ",
    fill: "#161617",
    transform: "translate(415,783)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.43496578 11.06746256 0.22636903 21.17295538 -2 32 C-2.33 32 -2.66 32 -3 32 C-3.53132662 21.03892859 -1.90858766 10.75852688 0 0 Z ",
    fill: "#111112",
    transform: "translate(809,518)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.30886984 5.37229007 0.28582428 10.59969827 -0.9375 15.875 C-1.10701172 16.64585937 -1.27652344 17.41671875 -1.45117188 18.2109375 C-1.90171775 20.15702157 -2.44374765 22.08145416 -3 24 C-3.66 24.33 -4.32 24.66 -5 25 C-5.33 22.69 -5.66 20.38 -6 18 C-5.34 18 -4.68 18 -4 18 C-3.81824219 16.80503906 -3.81824219 16.80503906 -3.6328125 15.5859375 C-1.96836555 5.06151142 -1.96836555 5.06151142 0 0 Z ",
    fill: "#161717",
    transform: "translate(294,456)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.44133265 10.46121827 0.22066559 19.82194937 -2 30 C-4.00116697 26.6980745 -4.16496024 24.49895182 -3.828125 20.68359375 C-3.74046875 19.67232422 -3.6528125 18.66105469 -3.5625 17.61914062 C-3.459375 16.56919922 -3.35625 15.51925781 -3.25 14.4375 C-3.16234375 13.38369141 -3.0746875 12.32988281 -2.984375 11.24414062 C-2.26303433 3.39455149 -2.26303433 3.39455149 0 0 Z ",
    fill: "#222324",
    transform: "translate(730,424)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.21698236 5.64116126 1.41385617 11.28252856 1.59204102 16.92504883 C1.65550909 18.84483642 1.72449015 20.76444994 1.79907227 22.68383789 C1.90526548 25.44129801 1.99168026 28.1987744 2.07421875 30.95703125 C2.1302552 32.24623222 2.1302552 32.24623222 2.18742371 33.56147766 C2.21779472 34.76238289 2.21779472 34.76238289 2.2487793 35.98754883 C2.27320602 36.6914827 2.29763275 37.39541656 2.32279968 38.12068176 C2 40 2 40 -1 43 C-0.67 28.81 -0.34 14.62 0 0 Z ",
    fill: "#292929",
    transform: "translate(809,483)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.01417969 0.89203125 1.02835938 1.7840625 1.04296875 2.703125 C1.09066406 3.87359375 1.13835938 5.0440625 1.1875 6.25 C1.23970703 7.99023438 1.23970703 7.99023438 1.29296875 9.765625 C1.73117996 13.15054179 1.73117996 13.15054179 4.34375 15.375 C7.2918462 17.1785412 9.5814497 17.68199532 13 18 C12.67 18.66 12.34 19.32 12 20 C5.25 20.125 5.25 20.125 3 19 C3 18.34 3 17.68 3 17 C2.34 17 1.68 17 1 17 C-0.98170967 13.69453961 -1.24423132 11.20178541 -1.1875 7.375 C-1.18105469 6.41335938 -1.17460938 5.45171875 -1.16796875 4.4609375 C-1 2 -1 2 0 0 Z ",
    fill: "#0C0D0D",
    transform: "translate(589,487)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.67848546 2.67848546 -4.13970861 2.30504006 -7.8828125 2.4140625 C-9.04941406 2.45273437 -10.21601562 2.49140625 -11.41796875 2.53125 C-13.25294922 2.57765625 -13.25294922 2.57765625 -15.125 2.625 C-16.97158203 2.68300781 -16.97158203 2.68300781 -18.85546875 2.7421875 C-21.90349376 2.8366999 -24.95150862 2.92225494 -28 3 C-27.34 2.01 -26.68 1.02 -26 0 C-23.70922852 -0.44824219 -23.70922852 -0.44824219 -20.87890625 -0.546875 C-19.86119141 -0.58683594 -18.84347656 -0.62679687 -17.79492188 -0.66796875 C-16.72822266 -0.69503906 -15.66152344 -0.72210937 -14.5625 -0.75 C-12.96825195 -0.81380859 -12.96825195 -0.81380859 -11.34179688 -0.87890625 C-3.44579658 -1.14859886 -3.44579658 -1.14859886 0 0 Z ",
    fill: "#0C0D0E",
    transform: "translate(546,793)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.07836613 0.95535501 4.00121326 2.00190656 5.75 4.75 C8.01041273 10.48045173 7.22618647 16.95998361 7 23 C6.01 23 5.02 23 4 23 C4.02320313 22.29875 4.04640625 21.5975 4.0703125 20.875 C4.21240903 13.40478247 3.86600942 6.62744472 0 0 Z ",
    fill: "#1A1A1B",
    transform: "translate(671,759)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.43230491 7.34918342 -0.18225815 13.90215087 -2 21 C-4.3125 21.625 -4.3125 21.625 -7 22 C-7.99 21.34 -8.98 20.68 -10 20 C-8.35 19.67 -6.7 19.34 -5 19 C-4.72285156 17.79601562 -4.44570313 16.59203125 -4.16015625 15.3515625 C-3.79440321 13.77601093 -3.42851055 12.20049177 -3.0625 10.625 C-2.88009766 9.8309375 -2.69769531 9.036875 -2.50976562 8.21875 C-2.33251953 7.45820313 -2.15527344 6.69765625 -1.97265625 5.9140625 C-1.81031494 5.2123291 -1.64797363 4.5105957 -1.48071289 3.78759766 C-1 2 -1 2 0 0 Z ",
    fill: "#171818",
    transform: "translate(458,503)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.37746856 4.02633131 0.36027067 6.95268432 -1.1328125 10.6640625 C-2.74622308 15.0100964 -3.83781848 19.51612234 -5 24 C-5.33 24 -5.66 24 -6 24 C-6.63401814 16.03954999 -5.17676385 9.32742611 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#131414",
    transform: "translate(636,595)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 3 3 3 3.36328125 5.63671875 C3.26138486 11.75834022 2.80325676 17.13941553 1 23 C0.67 23 0.34 23 0 23 C0 15.41 0 7.82 0 0 Z ",
    fill: "#161717",
    transform: "translate(693,428)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.66 3.3 2.32 6.6 3 10 C8.94 10.99 8.94 10.99 15 12 C15 12.66 15 13.32 15 14 C10.06622151 15.20336061 6.72844261 14.87353387 2 13 C0.0625 11.3125 0.0625 11.3125 -1 9 C-1.42424242 2.84848485 -1.42424242 2.84848485 0 0 Z ",
    fill: "#131314",
    transform: "translate(372,486)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.0149482 3.15055912 0.95658521 5.11792772 0.07421875 8.29296875 C-0.14556641 9.08767578 -0.36535156 9.88238281 -0.59179688 10.70117188 C-0.82962891 11.52166016 -1.06746094 12.34214844 -1.3125 13.1875 C-1.6518457 14.43563477 -1.6518457 14.43563477 -1.99804688 15.70898438 C-3.29055082 20.27930814 -3.29055082 20.27930814 -4 22 C-4.66 22.33 -5.32 22.66 -6 23 C-5.38273804 17.32644329 -4.72054048 11.66138945 -4 6 C-3.34 6 -2.68 6 -2 6 C-2 5.01 -2 4.02 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#151515",
    transform: "translate(716,594)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C3.72409058 8.71708984 4.15034839 16.91227489 4 26 C-0.85752081 18.71371878 -0.3006976 8.48635444 0 0 Z ",
    fill: "#141314",
    transform: "translate(194,529)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.498951 -0.56081938 4.04655908 -2.6875 6.6875 C-5.40985544 10.15641154 -7.71969491 13.71413785 -9.921875 17.53125 C-10.45554688 18.25828125 -10.45554688 18.25828125 -11 19 C-11.66 19 -12.32 19 -13 19 C-11.45424849 11.12575997 -6.40612177 4.57580126 0 0 Z ",
    fill: "#1C1D1D",
    transform: "translate(241,423)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.525 7.125 0.525 7.125 -1.5 10.5 C-5.22468915 12.73481349 -8.76620499 12.83392932 -13 12 C-15.0625 10 -15.0625 10 -16 8 C-15.67 7.34 -15.34 6.68 -15 6 C-14.34 6.33 -13.68 6.66 -13 7 C-13 7.66 -13 8.32 -13 9 C-8.97128121 9.33600895 -8.97128121 9.33600895 -5 9 C-2.09515903 6.31860833 -0.58118849 3.92302229 0 0 Z ",
    fill: "#131414",
    transform: "translate(406,774)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 3 3 3 3.36328125 6.8359375 C3.36195396 8.34905244 3.34444211 9.86222167 3.3125 11.375 C3.31572266 12.13039063 3.31894531 12.88578125 3.32226562 13.6640625 C3.28171977 17.88083157 2.9233754 21.15324919 1 25 C0.67 25 0.34 25 0 25 C0 16.75 0 8.5 0 0 Z ",
    fill: "#0B0C0C",
    transform: "translate(505,718)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-6.93 0.67 -13.86 0.34 -21 0 C-15.10229693 -5.89770307 -6.63938595 -2.84545112 0 0 Z ",
    fill: "#161717",
    transform: "translate(720,560)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-2.97 1 -5.94 1 -9 1 C-9 1.66 -9 2.32 -9 3 C-16.59 3 -24.18 3 -32 3 C-32 2.67 -32 2.34 -32 2 C-21.23827939 0.24554191 -10.88890097 -0.23990235 0 0 Z ",
    fill: "#2B2B2B",
    transform: "translate(449,178)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C5.08759124 16.82481752 5.08759124 16.82481752 2 23 C1.34 23 0.68 23 0 23 C0 15.41 0 7.82 0 0 Z ",
    fill: "#262626",
    transform: "translate(589,734)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-3.62 7.62 -8.24 12.24 -13 17 C-13.99 16.67 -14.98 16.34 -16 16 C-10.72 10.72 -5.44 5.44 0 0 Z ",
    fill: "#171818",
    transform: "translate(737,711)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-5.3534469 4.95065425 -9.14741951 5.22148123 -13.875 5.125 C-15.60363281 5.09792969 -15.60363281 5.09792969 -17.3671875 5.0703125 C-18.23601562 5.04710937 -19.10484375 5.02390625 -20 5 C-20.33 4.34 -20.66 3.68 -21 3 C-19.86820312 2.86722656 -18.73640625 2.73445312 -17.5703125 2.59765625 C-16.08851821 2.4194658 -14.60674864 2.24106971 -13.125 2.0625 C-12.00544922 1.93198242 -12.00544922 1.93198242 -10.86328125 1.79882812 C-7.1026544 1.34145459 -3.69009316 0 0 0 Z ",
    fill: "#141515",
    transform: "translate(329,523)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 5.61 2 11.22 2 17 C1.67 17 1.34 17 1 17 C0.67 19.97 0.34 22.94 0 26 C-0.33 26 -0.66 26 -1 26 C-1.02716089 22.97910522 -1.04691657 19.95845871 -1.0625 16.9375 C-1.07087891 16.08994141 -1.07925781 15.24238281 -1.08789062 14.36914062 C-1.10683006 9.4638278 -0.83326345 4.83555245 0 0 Z ",
    fill: "#282929",
    transform: "translate(217,471)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.45291624 6.64277148 0.87689259 15.66812439 -3.60546875 20.859375 C-4.06566406 21.23578125 -4.52585937 21.6121875 -5 22 C-4.38955672 14.36945905 -2.20378179 7.29810526 0 0 Z ",
    fill: "#131314",
    transform: "translate(536,193)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C3.59167969 1.84402344 4.18335938 1.68804688 4.79296875 1.52734375 C9.26820283 0.42496146 12.46350296 -0.20083745 17 1 C17.99 0.67 18.98 0.34 20 0 C20 0.66 20 1.32 20 2 C22.64 2 25.28 2 28 2 C28 2.33 28 2.66 28 3 C19.09 3 10.18 3 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#282828",
    transform: "translate(517,712)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1 3 -1 3 -3.91015625 4.67578125 C-8.68016447 6.54453224 -13.38584761 6.32933905 -18.4375 6.1875 C-19.35982422 6.17396484 -20.28214844 6.16042969 -21.23242188 6.14648438 C-23.48890383 6.11140953 -25.74413226 6.06226387 -28 6 C-28 5.67 -28 5.34 -28 5 C-26.96101563 4.97421875 -25.92203125 4.9484375 -24.8515625 4.921875 C-17.25709343 4.64393967 -10.7986682 4.1634335 -3.8203125 0.83984375 C-2 0 -2 0 0 0 Z ",
    fill: "#10100F",
    transform: "translate(318,664)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.02929977 3.35414799 1.0468989 6.70826253 1.0625 10.0625 C1.07087891 11.00544922 1.07925781 11.94839844 1.08789062 12.91992188 C1.10581103 18.0630768 0.89259611 22.93258427 0 28 C-0.33 28 -0.66 28 -1 28 C-3.01019023 18.4515964 -1.82471864 9.48202008 0 0 Z ",
    fill: "#292929",
    transform: "translate(556,482)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.04898438 0.73605469 1.09796875 1.47210938 1.1484375 2.23046875 C1.22320313 3.20628906 1.29796875 4.18210937 1.375 5.1875 C1.44460938 6.15042969 1.51421875 7.11335938 1.5859375 8.10546875 C2.17170766 12.20033372 2.93600074 15.09247122 6.125 17.8125 C6.74375 18.204375 7.3625 18.59625 8 19 C3.48780488 19.36585366 3.48780488 19.36585366 1.25 17.6875 C-1.05559367 14.57494855 -1.13611829 11.7357464 -1.125 8 C-1.12757813 7.13375 -1.13015625 6.2675 -1.1328125 5.375 C-1 3 -1 3 0 0 Z ",
    fill: "#0E0E0F",
    transform: "translate(717,485)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.7425 0.763125 1.485 1.52625 2.25 2.3125 C6.77051808 6.73027904 9.37202668 8.35836347 15.75 9.1875 C16.92046875 9.34605469 18.0909375 9.50460937 19.296875 9.66796875 C20.18890625 9.77753906 21.0809375 9.88710938 22 10 C22 10.33 22 10.66 22 11 C10.02565375 12.05952783 10.02565375 12.05952783 5.2890625 9.58203125 C3.1970793 7.8110202 1.50186391 6.29477342 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#121212",
    transform: "translate(470,784)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C14.52 0 29.04 0 44 0 C44 0.33 44 0.66 44 1 C29.48 1 14.96 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#383738",
    transform: "translate(643,703)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.19335938 1.15757812 1.38671875 2.31515625 1.5859375 3.5078125 C1.84871147 5.04691717 2.11174612 6.58597734 2.375 8.125 C2.50132812 8.88554688 2.62765625 9.64609375 2.7578125 10.4296875 C3.50756511 14.77825262 4.47199888 18.84117955 6 23 C5.34 23 4.68 23 4 23 C-1.52332519 16.09584351 -0.36276872 8.39406518 0 0 Z ",
    fill: "#101011",
    transform: "translate(379,729)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 4.125 2.6875 C6.3002525 8.43638162 6.12522069 14.32486537 6.0625 20.375 C6.05798828 21.20644531 6.05347656 22.03789063 6.04882812 22.89453125 C6.03713164 24.92971897 6.01919935 26.96486923 6 29 C5.67 29 5.34 29 5 29 C4.90912109 27.35451172 4.90912109 27.35451172 4.81640625 25.67578125 C4.73195502 24.22134346 4.64730934 22.76691695 4.5625 21.3125 C4.52318359 20.59126953 4.48386719 19.87003906 4.44335938 19.12695312 C4.06345851 11.67884443 4.06345851 11.67884443 1 5 C0.61500109 3.34450469 0.27206865 1.6777567 0 0 Z ",
    fill: "#323333",
    transform: "translate(625,720)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.77991125 2.86993261 -7.66612507 5.57279425 -11.5625 8.28125 C-13.73967115 9.81643478 -15.8784416 11.38918714 -18 13 C-15.16658459 6.04525308 -7.83841185 -0.9221661 0 0 Z ",
    fill: "#121313",
    transform: "translate(500,404)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.02703562 2.58340384 1.04685611 5.16652308 1.0625 7.75 C1.07087891 8.47960937 1.07925781 9.20921875 1.08789062 9.9609375 C1.10391684 13.48670558 0.95292713 16.61034916 0 20 C-0.66 20 -1.32 20 -2 20 C-2.26618595 13.04958914 -1.6120509 6.76485645 0 0 Z ",
    fill: "#131313",
    transform: "translate(560,321)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.01417969 0.87140625 1.02835938 1.7428125 1.04296875 2.640625 C1.39336138 11.39097061 3.11054766 18.16368644 7 26 C3.43909755 24.81303252 2.54328125 23.35991822 0.80273438 20.11669922 C-0.63964595 16.31334233 -0.41813893 12.57520021 -0.25 8.5625 C-0.23195313 7.73556641 -0.21390625 6.90863281 -0.1953125 6.05664062 C-0.1486214 4.03725067 -0.07689393 2.01846555 0 0 Z ",
    fill: "#0C0C0C",
    transform: "translate(666,622)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 0.22729492 4.80932617 C-0.18415771 5.46392822 -0.59561035 6.11853027 -1.01953125 6.79296875 C-1.46490234 7.50517578 -1.91027344 8.21738281 -2.36914062 8.95117188 C-2.84544922 9.68916016 -3.32175781 10.42714844 -3.8125 11.1875 C-4.27720703 11.93708984 -4.74191406 12.68667969 -5.22070312 13.45898438 C-7.81437369 17.54857397 -7.81437369 17.54857397 -9 19 C-9.66 19 -10.32 19 -11 19 C-9.60318936 13.9499923 -7.40056078 10.30405582 -4.375 6.125 C-3.95476562 5.53203125 -3.53453125 4.9390625 -3.1015625 4.328125 C-2.07434578 2.88068326 -1.0380937 1.43966081 0 0 Z ",
    fill: "#161617",
    transform: "translate(246,326)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.75 1.875 2.75 1.875 2 4 C1.360625 4.309375 0.72125 4.61875 0.0625 4.9375 C-2.77205655 6.3977261 -2.88659605 8.07731463 -4 11 C-6.125 13.3125 -6.125 13.3125 -8 15 C-7.44011356 10.80085169 -6.04944839 8.14003726 -3.625 4.6875 C-3.01914063 3.80449219 -2.41328125 2.92148437 -1.7890625 2.01171875 C-1.19867188 1.34785156 -0.60828125 0.68398438 0 0 Z ",
    fill: "#161617",
    transform: "translate(247,304)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.19647038 2.68711024 1.38239615 5.37428331 1.5625 8.0625 C1.61857422 8.81466797 1.67464844 9.56683594 1.73242188 10.34179688 C2.04000617 15.07859502 1.83807173 19.32542212 1 24 C-1.47846301 20.28230548 -1.26100633 17.41931728 -1.1875 13.125 C-1.18685547 12.41730469 -1.18621094 11.70960938 -1.18554688 10.98046875 C-1.15388927 7.20266084 -0.90008547 3.6723487 0 0 Z ",
    fill: "#080909",
    transform: "translate(303,615)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.144375 1.134375 1.28875 2.26875 1.4375 3.4375 C1.61171478 6.80777201 1.61171478 6.80777201 3 8 C3.04080783 9.99958364 3.04254356 12.00045254 3 14 C3.66 14 4.32 14 5 14 C5 15.65 5 17.3 5 19 C4.67 19 4.34 19 4 19 C3.67 20.65 3.34 22.3 3 24 C2.67 24 2.34 24 2 24 C1.66029235 21.50072231 1.32811968 19.00080405 1 16.5 C0.90460938 15.80390625 0.80921875 15.1078125 0.7109375 14.390625 C0.0838378 9.55299871 -0.08789528 4.87818804 0 0 Z ",
    fill: "#2C2C2C",
    transform: "translate(181,520)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.24091535 7.2274605 0.34495828 13.90294338 -1 21 C-1.66 21 -2.32 21 -3 21 C-3.43230491 13.65081658 -1.81774185 7.09784913 0 0 Z ",
    fill: "#171718",
    transform: "translate(199,434)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.34 3.31 1.68 5.62 1 8 C3.64 8.66 6.28 9.32 9 10 C8.67 10.99 8.34 11.98 8 13 C7.67 12.34 7.34 11.68 7 11 C5.865625 10.855625 4.73125 10.71125 3.5625 10.5625 C2.386875 10.376875 1.21125 10.19125 0 10 C-2 7 -2 7 -1.6875 4.4375 C-1 2 -1 2 0 0 Z ",
    fill: "#1C1D1C",
    transform: "translate(599,289)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 0 3 0 4.75390625 1.609375 C5.64916016 2.66898437 5.64916016 2.66898437 6.5625 3.75 C7.16191406 4.44609375 7.76132812 5.1421875 8.37890625 5.859375 C9.88245173 7.84477963 10.97578001 9.7375439 12 12 C12.66 12 13.32 12 14 12 C14.33 12.99 14.66 13.98 15 15 C12 15 12 15 10.3515625 13.49609375 C9.78179688 12.81675781 9.21203125 12.13742187 8.625 11.4375 C8.01785156 10.71433594 7.41070313 9.99117188 6.78515625 9.24609375 C4.39673204 6.24096482 2.17465478 3.16313423 0 0 Z ",
    fill: "#1A1A1A",
    transform: "translate(734,284)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.639375 0.70125 1.27875 1.4025 1.9375 2.125 C5.49799687 5.71636823 9.74812946 8.30436965 14 11 C13.67 11.66 13.34 12.32 13 13 C8.12804142 11.52364892 4.39295745 8.74048409 1 5 C0.0625 2.125 0.0625 2.125 0 0 Z ",
    fill: "#171717",
    transform: "translate(401,655)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C3.72464924 10.02040425 2.78341357 19.78386363 2 30 C1.67 30 1.34 30 1 30 C0.12198822 19.96557967 -0.1176305 10.06394247 0 0 Z ",
    fill: "#111112",
    transform: "translate(192,478)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.1968999 2.35371114 1.38270974 4.7074695 1.5625 7.0625 C1.66691406 8.37347656 1.77132812 9.68445313 1.87890625 11.03515625 C1.99765619 14.92325897 1.66866216 18.19110223 1 22 C0.34 21.67 -0.32 21.34 -1 21 C-1.0270203 18.24993392 -1.04684883 15.50013454 -1.0625 12.75 C-1.07087891 11.97269531 -1.07925781 11.19539063 -1.08789062 10.39453125 C-1.09111328 9.64042969 -1.09433594 8.88632812 -1.09765625 8.109375 C-1.10289307 7.41811523 -1.10812988 6.72685547 -1.11352539 6.01464844 C-0.99437971 3.90026102 -0.57618237 2.03358485 0 0 Z ",
    fill: "#070808",
    transform: "translate(253,476)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C7.3620694 0.4859793 14.69100518 0.97674072 22 2 C21.67 2.66 21.34 3.32 21 4 C13.74 3.67 6.48 3.34 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#060607",
    transform: "translate(330,354)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.14369185 1.38123062 5.21403736 4.19503066 7.25 7.8125 C7.81460938 8.75706055 7.81460938 8.75706055 8.390625 9.72070312 C11.06453395 14.40495905 11.06453395 14.40495905 10.734375 17.44921875 C10.49203125 17.96097656 10.2496875 18.47273438 10 19 C8.70425129 16.77312024 7.41332692 14.54366825 6.125 12.3125 C5.76019531 11.68666016 5.39539063 11.06082031 5.01953125 10.41601562 C3.06258803 7.01805058 1.34392261 3.69932381 0 0 Z ",
    fill: "#171617",
    transform: "translate(777,340)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.5351499 2.51853031 2.05329429 5.03870748 2.5625 7.5625 C2.71396484 8.26697266 2.86542969 8.97144531 3.02148438 9.69726562 C3.96760613 14.47188005 3.94832051 18.22071586 3 23 C2.67 23 2.34 23 2 23 C0.48462814 15.2472493 -0.27990605 7.89957062 0 0 Z ",
    fill: "#111111",
    transform: "translate(375,243)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.34855655 7.62951555 1.0017506 13.92444501 -2 21 C-2.33 21 -2.66 21 -3 21 C-3.15639125 15.93683317 -2.62766071 11.49601562 -1.5 6.5625 C-1.2215625 5.32628906 -0.943125 4.09007812 -0.65625 2.81640625 C-0.4396875 1.88699219 -0.223125 0.95757813 0 0 Z ",
    fill: "#151515",
    transform: "translate(817,545)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.93521641 5.90282461 3.12430212 13.13576053 3 20 C2.34 20 1.68 20 1 20 C-0.03026944 13.30324864 -0.10152799 6.7685324 0 0 Z ",
    fill: "#181818",
    transform: "translate(806,448)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.87305969 4.29975855 7.8200442 9.37224317 11 15 C10.34 15.66 9.68 16.32 9 17 C7.49157829 14.73437454 5.99317749 12.46313837 4.5 10.1875 C4.07074219 9.54490234 3.64148438 8.90230469 3.19921875 8.24023438 C0 3.33984375 0 3.33984375 0 0 Z ",
    fill: "#161616",
    transform: "translate(758,331)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 1.98 1.66 3.96 2 6 C3.98 6 5.96 6 8 6 C5.93243723 8.7972908 4.85559629 9.02692273 1.3125 9.6875 C0.219375 9.790625 -0.87375 9.89375 -2 10 C-1.54177532 6.53058454 -1.10868317 3.32604951 0 0 Z ",
    fill: "#131414",
    transform: "translate(367,650)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.35482211 7.21471629 0.1591338 13.12418702 -2 20 C-2.33 20 -2.66 20 -3 20 C-3.35482211 12.78528371 -2.1591338 6.87581298 0 0 Z ",
    fill: "#131414",
    transform: "translate(432,604)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C3.20335937 2.67095703 3.20335937 2.67095703 2.390625 3.35546875 C-1.47888319 6.66714638 -4.98587305 9.85557544 -8 14 C-8.66 13.67 -9.32 13.34 -10 13 C-7.02480663 8.30834891 -3.68606635 4.15296809 0 0 Z ",
    fill: "#151515",
    transform: "translate(679,408)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.61246888 3.61246888 4.125 9.03845507 4.125 14 C4.08375 14.99 4.0425 15.98 4 17 C3.01 16.67 2.02 16.34 1 16 C0.67 10.72 0.34 5.44 0 0 Z ",
    fill: "#1D1D1D",
    transform: "translate(433,260)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 6.27 1 12.54 1 19 C-1.96108164 14.55837754 -2.26467712 12.38176809 -2 7 C-1.46502633 4.59959642 -0.76501613 2.34286191 0 0 Z ",
    fill: "#141414",
    transform: "translate(354,236)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.81242052 -0.02687279 3.62495233 -0.04633715 5.4375 -0.0625 C6.44683594 -0.07410156 7.45617187 -0.08570313 8.49609375 -0.09765625 C11 0 11 0 12 1 C12.39454223 2.84599688 12.74176866 4.70225822 13.0625 6.5625 C13.23910156 7.57441406 13.41570313 8.58632813 13.59765625 9.62890625 C13.73042969 10.41136719 13.86320313 11.19382812 14 12 C13.01 12 12.02 12 11 12 C10.34 8.7 9.68 5.4 9 2 C6.03 1.67 3.06 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#252626",
    transform: "translate(639,771)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.19644384 1.89492746 1.38177288 3.79100903 1.5625 5.6875 C1.66691406 6.74324219 1.77132813 7.79898438 1.87890625 8.88671875 C1.99277552 11.81426086 1.70848415 14.17131144 1 17 C0.34 17 -0.32 17 -1 17 C-1.02684679 14.35409986 -1.04676357 11.70846904 -1.0625 9.0625 C-1.07087891 8.30775391 -1.07925781 7.55300781 -1.08789062 6.77539062 C-1.09652441 4.85005687 -1.05224333 2.92464419 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#101011",
    transform: "translate(506,743)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 -0.43359375 6.35546875 C-1.09148807 7.6380304 -1.75989743 8.91524057 -2.4375 10.1875 C-2.77587891 10.84169922 -3.11425781 11.49589844 -3.46289062 12.16992188 C-4.29969098 13.78459299 -5.14869746 15.39292763 -6 17 C-6.86177951 14.57726137 -7.15546869 13.4070311 -6.22265625 10.96484375 C-5.83980469 10.29582031 -5.45695312 9.62679687 -5.0625 8.9375 C-3.5191704 6.21182298 -3 5.222928 -3 2 C-2.01 1.34 -1.02 0.68 0 0 Z ",
    fill: "#151515",
    transform: "translate(339,622)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.31985731 6.71700347 0.4793824 11.75726932 -2 18 C-2.66 17.67 -3.32 17.34 -4 17 C-2.68 11.39 -1.36 5.78 0 0 Z ",
    fill: "#161617",
    transform: "translate(775,506)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C-0.80411834 4.91939465 -4.81576108 8.49102731 -9 12 C-8.40503246 8.67258892 -7.29522827 6.82909592 -5.0625 4.3125 C-4.53785156 3.71050781 -4.01320313 3.10851562 -3.47265625 2.48828125 C-2 1 -2 1 0 0 Z ",
    fill: "#141515",
    transform: "translate(551,267)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-0.21929728 4.30098717 -1.45092452 5.59042437 -2.6875 6.875 C-3.37199219 7.59429688 -4.05648437 8.31359375 -4.76171875 9.0546875 C-7.09591291 11.08335887 -9.08467634 12.02992733 -12 13 C-10.86528532 9.59585597 -9.82774013 8.75723352 -7.125 6.5 C-4.64584653 4.41421775 -2.2560424 2.32698713 0 0 Z ",
    fill: "#151515",
    transform: "translate(700,651)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.6852084 4.07679159 0.16939007 6.83075593 -1.4375 10.75 C-1.91058594 11.92046875 -2.38367188 13.0909375 -2.87109375 14.296875 C-3.24363281 15.18890625 -3.61617187 16.0809375 -4 17 C-4.66 17 -5.32 17 -6 17 C-5.35956665 10.75577479 -2.77121909 5.54243818 0 0 Z ",
    fill: "#141515",
    transform: "translate(678,582)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.56332031 0.24105469 1.12664062 0.48210938 1.70703125 0.73046875 C1.11535156 1.189375 0.52367187 1.64828125 -0.0859375 2.12109375 C-4.17676697 5.29765954 -8.26115146 8.47900319 -12.29296875 11.73046875 C-11.76265264 7.74860371 -9.91540427 6.04548058 -6.98046875 3.41796875 C-5.81064453 2.34095703 -5.81064453 2.34095703 -4.6171875 1.2421875 C-2.29296875 -0.26953125 -2.29296875 -0.26953125 0 0 Z ",
    fill: "#131313",
    transform: "translate(431.29296875,554.26953125)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.625 1.8125 0.625 1.8125 1 4 C0.01 5.485 0.01 5.485 -1 7 C-1.66 7 -2.32 7 -3 7 C-3 7.66 -3 8.32 -3 9 C-7.47058824 13 -7.47058824 13 -10 13 C-8.60366893 9.81440048 -6.95442507 7.76056155 -4.4375 5.375 C-1.85984611 2.95478041 -1.85984611 2.95478041 0 0 Z ",
    fill: "#161616",
    transform: "translate(284,507)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 2.64 1.66 5.28 2 8 C2.33 8 2.66 8 3 8 C3.22226864 9.76913824 3.42733873 11.54044371 3.625 13.3125 C3.74101563 14.29863281 3.85703125 15.28476562 3.9765625 16.30078125 C4 19 4 19 2 22 C0.39118425 14.57359158 -0.26442904 7.59498961 0 0 Z ",
    fill: "#282828",
    transform: "translate(520,331)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.45098757 2.90197514 1.31205534 5.64637919 1.5 8.875 C1.80702453 14.50994763 1.80702453 14.50994763 3 20 C2.34 20.33 1.68 20.66 1 21 C-1.08560886 16.74634716 -1.27256739 12.89736579 -1.1875 8.25 C-1.18685547 7.56550781 -1.18621094 6.88101563 -1.18554688 6.17578125 C-1.14067963 1.14067963 -1.14067963 1.14067963 0 0 Z ",
    fill: "#0F1010",
    transform: "translate(640,728)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.11328125 1.57421875 3.11328125 1.57421875 4.3125 3.6875 C6.51607249 7.37979558 8.83510818 10.10638462 12 13 C9.20394902 12.91776321 7.47169095 12.41865393 5.3671875 10.55078125 C2.38533578 7.23041013 0.27999125 4.61985569 0 0 Z ",
    fill: "#121313",
    transform: "translate(268,651)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0 2.64 0 4 0 C4.33 1.32 4.66 2.64 5 4 C4.01 4.495 4.01 4.495 3 5 C2.30906104 7.57951874 2.30906104 7.57951874 1.875 10.5625 C1.70742188 11.57441406 1.53984375 12.58632813 1.3671875 13.62890625 C1.24601562 14.41136719 1.12484375 15.19382812 1 16 C0.67 16 0.34 16 0 16 C-0.19672365 14.27185839 -0.38196799 12.54240803 -0.5625 10.8125 C-0.71912109 9.36810547 -0.71912109 9.36810547 -0.87890625 7.89453125 C-0.99758751 5.05766623 -0.67765639 2.74576329 0 0 Z ",
    fill: "#292A2A",
    transform: "translate(393,471)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.8971875 0.309375 0.8971875 0.309375 1.8125 0.625 C0.45125 1.3365625 0.45125 1.3365625 -0.9375 2.0625 C-5.18040621 4.82742703 -6.51482629 9.02022768 -8.1875 13.625 C-8.5175 13.625 -8.8475 13.625 -9.1875 13.625 C-9.69182107 8.3296288 -8.47507779 5.75795494 -5.1875 1.625 C-2.1875 -0.375 -2.1875 -0.375 0 0 Z ",
    fill: "#111111",
    transform: "translate(354.1875,464.375)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.62651431 0.28119857 5.25069335 0.57443838 7.875 0.875 C8.62136719 0.95363281 9.36773438 1.03226562 10.13671875 1.11328125 C15.7734375 1.7734375 15.7734375 1.7734375 18 4 C15.89590361 4.02701408 13.79170822 4.04640223 11.6875 4.0625 C10.51574219 4.07410156 9.34398437 4.08570313 8.13671875 4.09765625 C5 4 5 4 2 3 C2 2.34 2 1.68 2 1 C1.34 0.67 0.68 0.34 0 0 Z ",
    fill: "#121211",
    transform: "translate(545,374)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-0.41027446 4.46451579 -1.82848796 5.9213893 -3.25 7.375 C-4.03890625 8.18710937 -4.8278125 8.99921875 -5.640625 9.8359375 C-7.73379455 11.75583143 -9.40397179 12.91633685 -12 14 C-12 13.01 -12 12.02 -12 11 C-10.13671875 9.31640625 -10.13671875 9.31640625 -7.6875 7.5625 C-4.53090531 5.29036179 -2.19167694 3.22722657 0 0 Z ",
    fill: "#131314",
    transform: "translate(593,648)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.90747183 2.86120775 3.00353706 5.35254993 4.1875 8.5625 C4.55230469 9.53316406 4.91710937 10.50382813 5.29296875 11.50390625 C6 14 6 14 5 16 C3.5 14.625 3.5 14.625 2 13 C2 12.34 2 11.68 2 11 C1.34 10.67 0.68 10.34 0 10 C0 6.7 0 3.4 0 0 Z ",
    fill: "#101111",
    transform: "translate(512,641)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.27351308 2.54702616 0.80191925 3.4282945 0.0625 6.125 C-0.13214844 6.84945312 -0.32679688 7.57390625 -0.52734375 8.3203125 C-0.68332031 8.87460937 -0.83929688 9.42890625 -1 10 C1.64 10 4.28 10 7 10 C7 10.33 7 10.66 7 11 C5.52168779 11.19412181 4.04230684 11.38012131 2.5625 11.5625 C1.73878906 11.66691406 0.91507812 11.77132812 0.06640625 11.87890625 C-0.61550781 11.91886719 -1.29742187 11.95882812 -2 12 C-3 11 -3 11 -3.25 7.6875 C-2.99337817 3.90232794 -2.56295176 2.66974142 0 0 Z ",
    fill: "#111112",
    transform: "translate(488,513)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.64989059 10.17286652 1.64989059 10.17286652 -1.0625 13.625 C-1.701875 14.07875 -2.34125 14.5325 -3 15 C-3 11.68455701 -2.32773835 9.01998611 -1.5 5.8125 C-1.2215625 4.72582031 -0.943125 3.63914062 -0.65625 2.51953125 C-0.33140625 1.27236328 -0.33140625 1.27236328 0 0 Z ",
    fill: "#101111",
    transform: "translate(736,498)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C2.6328125 3.109375 2.6328125 3.109375 3.125 5.75 C3.29257812 6.61109375 3.46015625 7.4721875 3.6328125 8.359375 C3.9923991 10.94533821 4.06564041 13.39313809 4 16 C1.44617265 13.77928057 0.61382461 12.30520944 0 9 C-0.06548492 7.41788427 -0.08578381 5.83329919 -0.0625 4.25 C-0.05347656 3.45078125 -0.04445313 2.6515625 -0.03515625 1.828125 C-0.02355469 1.22484375 -0.01195312 0.6215625 0 0 Z ",
    fill: "#131313",
    transform: "translate(451,342)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.62356346 1.96937661 5.13559566 3.93345148 6.625 6 C7.04523437 6.57234375 7.46546875 7.1446875 7.8984375 7.734375 C8.93805801 9.15203933 9.96977591 10.57549262 11 12 C10.34 12.66 9.68 13.32 9 14 C7.67925885 12.42353449 6.36868776 10.83854469 5.0625 9.25 C4.33160156 8.36828125 3.60070312 7.4865625 2.84765625 6.578125 C1.16962815 4.23669045 0.41264834 2.80338873 0 0 Z ",
    fill: "#151515",
    transform: "translate(746,315)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.119212 1.36405618 -4.24448118 2.71631775 -6.375 4.0625 C-6.97828125 4.45244141 -7.5815625 4.84238281 -8.203125 5.24414062 C-9.76492557 6.22460432 -11.37992214 7.11916075 -13 8 C-13.66 7.67 -14.32 7.34 -15 7 C-10.7055697 2.32664938 -6.59500687 -2.07069033 0 0 Z ",
    fill: "#161617",
    transform: "translate(572,256)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.53160457 2.41474617 2.05054766 4.83108107 2.5625 7.25 C2.71396484 7.93191406 2.86542969 8.61382812 3.02148438 9.31640625 C3.75233495 12.81769038 4.32203546 15.60298173 3 19 C2.34 18.67 1.68 18.34 1 18 C0.62109375 15.8203125 0.62109375 15.8203125 0.4375 13.125 C0.22371654 10.13203161 -0.04428957 7.8671313 -1 5 C-0.5625 2.3125 -0.5625 2.3125 0 0 Z ",
    fill: "#222324",
    transform: "translate(463,239)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.24687592 0.96239452 -2.49764969 1.91974009 -3.75 2.875 C-4.44609375 3.40867187 -5.1421875 3.94234375 -5.859375 4.4921875 C-7.84722603 5.89238914 -9.79843386 6.97855265 -12 8 C-11.60824727 5.56068635 -11.2627764 4.26829402 -9.51171875 2.48046875 C-8.90972656 2.05378906 -8.30773437 1.62710938 -7.6875 1.1875 C-7.09324219 0.74792969 -6.49898438 0.30835938 -5.88671875 -0.14453125 C-3.51795836 -1.21856546 -2.39906969 -0.86324141 0 0 Z ",
    fill: "#151616",
    transform: "translate(298,688)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.28 0.33 10.56 0.66 16 1 C13 4 13 4 10.37109375 4.1796875 C9.40300781 4.07914063 8.43492187 3.97859375 7.4375 3.875 C6.46683594 3.78992188 5.49617187 3.70484375 4.49609375 3.6171875 C2 3 2 3 0 0 Z ",
    fill: "#121313",
    transform: "translate(536,669)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-5.15047317 2.62779243 -8.17389609 3.51478702 -14 2 C-14.33 1.34 -14.66 0.68 -15 0 C-13.25093341 -0.19601608 -11.50068154 -0.38147403 -9.75 -0.5625 C-8.77546875 -0.66691406 -7.8009375 -0.77132812 -6.796875 -0.87890625 C-4.2368648 -0.98974468 -2.41851841 -0.77738092 0 0 Z ",
    fill: "#151515",
    transform: "translate(689,648)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.30624582 0.2449071 4.29042449 1.27722338 6.75 3.625 C9.41830608 6.98690246 9.42559968 9.74400319 9 14 C7.0098337 11.01475054 5.1117018 7.9846907 3.21875 4.9375 C2.17266071 3.27448625 1.08980133 1.63470199 0 0 Z ",
    fill: "#131414",
    transform: "translate(526,407)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.2358396 5.77807024 0.86783046 10.51324804 -1 16 C-1.66 16 -2.32 16 -3 16 C-2.52013969 10.43109483 -1.70084819 5.32932432 0 0 Z ",
    fill: "#151616",
    transform: "translate(526,233)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.3984791 3.4087928 -2.85006933 4.87393835 -6 6.75 C-7.051875 7.39195312 -7.051875 7.39195312 -8.125 8.046875 C-10 9 -10 9 -12 9 C-12 8.01 -12 7.02 -12 6 C-9.8828125 4.39453125 -9.8828125 4.39453125 -7.125 2.8125 C-6.22007812 2.28269531 -5.31515625 1.75289062 -4.3828125 1.20703125 C-2 0 -2 0 0 0 Z ",
    fill: "#181718",
    transform: "translate(387,659)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.57159226 3.14318453 0.04018399 5.92933389 -0.9375 9.125 C-1.13279297 9.78371094 -1.32808594 10.44242188 -1.52929688 11.12109375 C-2.01304986 12.74933552 -2.50569075 14.37493182 -3 16 C-3.33 16 -3.66 16 -4 16 C-4.63019694 6.00437637 -4.63019694 6.00437637 -2 1.8125 C-1.34 1.214375 -0.68 0.61625 0 0 Z ",
    fill: "#111212",
    transform: "translate(334,652)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.16691444 3.48419134 0.85285758 6.10222787 0.1875 9.6875 C0.01605469 10.66074219 -0.15539062 11.63398438 -0.33203125 12.63671875 C-0.55246094 13.41660156 -0.77289062 14.19648438 -1 15 C-1.99 15.495 -1.99 15.495 -3 16 C-3.37952295 9.80112515 -2.8352113 5.5522888 0 0 Z ",
    fill: "#131414",
    transform: "translate(632,434)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.71788123 1.6266848 1.42397625 3.25132896 1.125 4.875 C0.96257812 5.77992188 0.80015625 6.68484375 0.6328125 7.6171875 C0 10 0 10 -2 12 C-3.32 10.68 -4.64 9.36 -6 8 C-5.38125 7.79375 -4.7625 7.5875 -4.125 7.375 C-1.15346355 5.45224112 -0.86975341 3.33405473 0 0 Z ",
    fill: "#151515",
    transform: "translate(306,401)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 2 -0.32 2 -1 2 C-1.20625 2.556875 -1.4125 3.11375 -1.625 3.6875 C-3.55000774 6.92501302 -6.03850902 8.68231141 -9 11 C-9.66 10.67 -10.32 10.34 -11 10 C-10.236875 9.2575 -9.47375 8.515 -8.6875 7.75 C-6.05190726 5.18870238 -6.05190726 5.18870238 -4.375 2.75 C-3 1 -3 1 0 0 Z ",
    fill: "#111112",
    transform: "translate(591,344)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-0.36328125 5.69921875 -0.36328125 5.69921875 -2.3125 8.6875 C-2.94800781 9.68136719 -3.58351563 10.67523438 -4.23828125 11.69921875 C-4.81964844 12.45847656 -5.40101563 13.21773438 -6 14 C-6.66 14 -7.32 14 -8 14 C-7.36561334 10.53466285 -5.98631946 8.20125787 -4 5.3125 C-3.46375 4.52488281 -2.9275 3.73726563 -2.375 2.92578125 C-1 1 -1 1 0 0 Z ",
    fill: "#161516",
    transform: "translate(580,275)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C-5.435 10.495 -5.435 10.495 -12 11 C-11.34 10.01 -10.68 9.02 -10 8 C-6.28359861 7.72971626 -3.542799 7.819067 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#262728",
    transform: "translate(678,727)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 4.95 1.66 9.9 2 15 C1.01 14.34 0.02 13.68 -1 13 C-1.328125 10.21484375 -1.328125 10.21484375 -1.25 6.9375 C-1.23453125 5.85339844 -1.2190625 4.76929688 -1.203125 3.65234375 C-1 1 -1 1 0 0 Z ",
    fill: "#0C0D0D",
    transform: "translate(744,629)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.57910004 5.60461531 0.08386889 10.72086547 -2 16 C-2.33 16 -2.66 16 -3 16 C-3.37851209 10.06997733 -2.10575375 5.52760359 0 0 Z ",
    fill: "#111212",
    transform: "translate(428,485)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.34362255 0.24767574 4.28573857 1.27924452 6.75 3.6875 C8.74760776 6.21047249 8.99922125 6.99158949 9.3125 10.375 C9.1578125 11.674375 9.1578125 11.674375 9 13 C6.8082282 10.8082282 5.51990614 8.44559004 4.01953125 5.75390625 C2.83033348 3.70812158 1.47741124 1.84676405 0 0 Z ",
    fill: "#121212",
    transform: "translate(592,408)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.51553092 3.97450493 0.49888623 7.20481149 -0.4375 11.25 C-0.72496094 12.51328125 -1.01242187 13.7765625 -1.30859375 15.078125 C-1.53675781 16.04234375 -1.76492188 17.0065625 -2 18 C-2.33 18 -2.66 18 -3 18 C-4.125 11.375 -4.125 11.375 -3 8 C-2.34 8 -1.68 8 -1 8 C-1.309375 6.576875 -1.309375 6.576875 -1.625 5.125 C-1.74875 4.09375 -1.8725 3.0625 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#232223",
    transform: "translate(427,266)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11.33 2.64 11.66 5.28 12 8 C10 6 10 6 9 3 C6.03 2.67 3.06 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#0A0A0A",
    transform: "translate(440,179)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C8.57142857 -0.28571429 8.57142857 -0.28571429 12 2 C12 2.33 12 2.66 12 3 C8.37 3 4.74 3 1 3 C0.34 4.32 -0.32 5.64 -1 7 C-0.67 4.69 -0.34 2.38 0 0 Z ",
    fill: "#111111",
    transform: "translate(529,723)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 0.33 30 0.66 30 1 C20.1 1 10.2 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#363536",
    transform: "translate(500,703)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C9.9 0 19.8 0 30 0 C30 0.33 30 0.66 30 1 C20.1 1 10.2 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#353535",
    transform: "translate(395,703)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.70125 0.721875 1.4025 1.44375 2.125 2.1875 C4.92770745 4.99823813 7.92262792 7.49516226 11 10 C9.234375 10.69921875 9.234375 10.69921875 7 11 C5.078125 9.70703125 5.078125 9.70703125 3.25 7.8125 C2.63640625 7.20019531 2.0228125 6.58789062 1.390625 5.95703125 C0 4 0 4 0 0 Z ",
    fill: "#111212",
    transform: "translate(634,656)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.93045933 2.55144824 1.08564091 3.74006478 0.22265625 6.359375 C-0.16019531 7.14828125 -0.54304687 7.9371875 -0.9375 8.75 C-1.50791016 9.94882812 -1.50791016 9.94882812 -2.08984375 11.171875 C-2.39019531 11.77515625 -2.69054687 12.3784375 -3 13 C-3.66 13 -4.32 13 -5 13 C-4.36070838 8.78067529 -3.10894036 3.10894036 0 0 Z ",
    fill: "#141515",
    transform: "translate(589,613)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.8505939 4.06394865 2.00432764 6.98268944 1 11 C0.66055205 12.99897128 0.32578384 14.99875639 0 17 C-0.99 17 -1.98 17 -3 17 C-2.68853528 15.10399631 -2.37578283 13.20820413 -2.0625 11.3125 C-1.88847656 10.25675781 -1.71445312 9.20101562 -1.53515625 8.11328125 C-1.06832879 5.39750396 -0.55577384 2.69875765 0 0 Z ",
    fill: "#262626",
    transform: "translate(804,551)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 7.26 1.66 14.52 2 22 C-1 19 -1 19 -1.2487793 16.9152832 C-1.19117432 16.13499756 -1.13356934 15.35471191 -1.07421875 14.55078125 C-1.01943359 13.70322266 -0.96464844 12.85566406 -0.90820312 11.98242188 C-0.79895508 10.66081055 -0.79895508 10.66081055 -0.6875 9.3125 C-0.62626953 8.41982422 -0.56503906 7.52714844 -0.50195312 6.60742188 C-0.34874168 4.40353414 -0.18091866 2.20175794 0 0 Z ",
    fill: "#2D2D2D",
    transform: "translate(194,512)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C2 0.99 2 1.98 2 3 C-1.23934303 5.85351557 -4.70120583 7.86470894 -9 8.3125 C-9.99 8.1578125 -9.99 8.1578125 -11 8 C-7.76446401 5.51112616 -4.39550259 3.26366839 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#161616",
    transform: "translate(726,517)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.83861979 5.36716665 -1.07929595 8.79627239 -4 13 C-4.86443295 10.5653629 -5.12994709 9.36863937 -4.2578125 6.89453125 C-3.88398438 6.20746094 -3.51015625 5.52039063 -3.125 4.8125 C-2.57199219 3.77029297 -2.57199219 3.77029297 -2.0078125 2.70703125 C-1 1 -1 1 0 0 Z ",
    fill: "#131414",
    transform: "translate(288,483)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.27991594 4.60853797 -0.31295939 8.67237409 -2 13 C-2.66 13 -3.32 13 -4 13 C-3.40895235 8.15340923 -2.02055843 4.39251833 0 0 Z ",
    fill: "#131314",
    transform: "translate(264,438)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.99 0 -1.98 0 -3 0 C-3 0.66 -3 1.32 -3 2 C-4.24176695 2.70226141 -5.49385599 3.38629109 -6.75 4.0625 C-7.79414063 4.63677734 -7.79414063 4.63677734 -8.859375 5.22265625 C-11.36140628 6.1312406 -12.5332355 5.88336837 -15 5 C-12.74306568 2.74306568 -10.95858483 2.12707993 -8 1 C-7.319375 0.608125 -6.63875 0.21625 -5.9375 -0.1875 C-3.5476033 -1.18971474 -2.39624834 -0.85580298 0 0 Z ",
    fill: "#252625",
    transform: "translate(342,229)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.54775239 5.91492272 -0.1582605 11.35199888 -2 17 C-2.33 17 -2.66 17 -3 17 C-3.40368295 10.54107286 -2.5915262 5.93891422 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(413,200)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.2186994 2.1926135 -8.60185899 4.36894477 -13.4375 3.625 C-13.953125 3.41875 -14.46875 3.2125 -15 3 C-10.27805833 -0.77755334 -5.74071928 -0.30096975 0 0 Z ",
    fill: "#141414",
    transform: "translate(612,713)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.22095672 10.55808656 0.22095672 10.55808656 -2 15 C-2.33 15 -2.66 15 -3 15 C-3.36263859 9.1977825 -2.25684543 5.36000789 0 0 Z ",
    fill: "#121213",
    transform: "translate(345,598)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.8971875 0.309375 0.8971875 0.309375 1.8125 0.625 C0.8225 0.955 -0.1675 1.285 -1.1875 1.625 C-1.1875 2.285 -1.1875 2.945 -1.1875 3.625 C-6.8125 6.625 -6.8125 6.625 -10.1875 6.625 C-3.20231959 -0.54896907 -3.20231959 -0.54896907 0 0 Z ",
    fill: "#161617",
    transform: "translate(673.1875,549.375)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.7734375 0.7115625 0.7734375 0.7115625 1.5625 1.4375 C4.66782675 3.42809407 7.36632504 3.65060818 11 4 C11 4.66 11 5.32 11 6 C7.44706507 7.14947895 6.20023331 7.0868937 2.6875 5.5625 C1.800625 5.046875 0.91375 4.53125 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#171617",
    transform: "translate(346,480)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.18451025 9.41002278 1.18451025 9.41002278 0 14 C-0.66 14 -1.32 14 -2 14 C-2.33 14.66 -2.66 15.32 -3 16 C-2.40984815 10.49191603 -1.43336231 5.35121931 0 0 Z ",
    fill: "#131414",
    transform: "translate(408,350)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.48517081 5.852795 -0.45357192 11.3297637 -2 17 C-2.33 17 -2.66 17 -3 17 C-3.40368295 10.54107286 -2.5915262 5.93891422 0 0 Z ",
    fill: "#121212",
    transform: "translate(606,305)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C6.3 2.33 9.6 2.66 13 3 C9.64672361 5.23551759 9.09256343 5.17283528 5.3125 4.625 C4.10013672 4.45871094 4.10013672 4.45871094 2.86328125 4.2890625 C1.94095703 4.14597656 1.94095703 4.14597656 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#141515",
    transform: "translate(480,781)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.96 0 7.92 0 12 0 C12 0.33 12 0.66 12 1 C7.545 1.495 7.545 1.495 3 2 C2.67 4.64 2.34 7.28 2 10 C-0.4294516 6.3558226 -0.16179575 4.28758728 0 0 Z ",
    fill: "#060607",
    transform: "translate(637,772)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.67 4.95 0.34 9.9 0 15 C-2.46934085 11.29598872 -2.44928433 8.29412135 -2 4 C-1 1.5 -1 1.5 0 0 Z ",
    fill: "#101011",
    transform: "translate(392,726)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C5.21979128 -0.1799928 9.07262981 0.02905192 14 2 C11.23184713 3.96077495 9.15014529 4.1221501 5.875 3.8125 C2 3 2 3 0 0 Z ",
    fill: "#252626",
    transform: "translate(606,712)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3 0.66 3 1.32 3 2 C2.01 2 1.02 2 0 2 C-0.2475 2.5775 -0.495 3.155 -0.75 3.75 C-2.16683317 6.3002997 -3.87627537 8.01785701 -6 10 C-6.66 9.67 -7.32 9.34 -8 9 C-6.85459775 7.68712379 -5.70866567 6.37470979 -4.5625 5.0625 C-3.92441406 4.33160156 -3.28632813 3.60070312 -2.62890625 2.84765625 C-1.77458541 1.87860647 -0.91348825 0.91348825 0 0 Z ",
    fill: "#101011",
    transform: "translate(396,648)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.556875 0.28875 1.11375 0.5775 1.6875 0.875 C4.08494645 2.0413253 6.51596939 3.0339881 9 4 C9 4.66 9 5.32 9 6 C10.65 6 12.3 6 14 6 C14 6.33 14 6.66 14 7 C8.31845765 7.45452339 5.39963479 6.66636232 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#141414",
    transform: "translate(549,643)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 0 3 0 4.38671875 1.3203125 C7.28325547 5.33893102 8.626788 7.8603384 8 13 C5.5720406 10.5720406 4.50920609 8.07878042 3 5 C2.01612294 3.32376502 1.02137457 1.65365406 0 0 Z ",
    fill: "#131313",
    transform: "translate(491,552)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.93972656 0.12568359 0.93972656 0.12568359 1.8984375 0.25390625 C3.12433594 0.40666016 3.12433594 0.40666016 4.375 0.5625 C5.59316406 0.71912109 5.59316406 0.71912109 6.8359375 0.87890625 C9.04899186 1.18237328 9.04899186 1.18237328 11 0 C10.42655063 2.86724686 10.1385485 3.8614515 8 6 C4.92115427 4.25254702 2.44038613 2.55489105 0 0 Z ",
    fill: "#131314",
    transform: "translate(720,546)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.64936913 0.78427352 3.29441127 1.57765259 4.9375 2.375 C5.85402344 2.81585938 6.77054687 3.25671875 7.71484375 3.7109375 C10 5 10 5 11 7 C6.75651873 7.36372697 4.37287736 6.62334906 1 4 C0.359375 1.890625 0.359375 1.890625 0 0 Z ",
    fill: "#151515",
    transform: "translate(360,444)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C-3.06533164 3.53266582 -6.26754272 3.10276471 -9.625 3.0625 C-10.33140625 3.05798828 -11.0378125 3.05347656 -11.765625 3.04882812 C-13.51045275 3.03703875 -15.255237 3.01910324 -17 3 C-17 2.67 -17 2.34 -17 2 C-14.72954771 1.66408104 -12.45862367 1.33134935 -10.1875 1 C-8.29064453 0.7215625 -8.29064453 0.7215625 -6.35546875 0.4375 C-3 0 -3 0 0 0 Z ",
    fill: "#0C0D0D",
    transform: "translate(669,792)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.67 4.62 0.34 9.24 0 14 C-2.46751239 10.29873141 -2.30721156 8.37776468 -2 4 C-1 1.5625 -1 1.5625 0 0 Z ",
    fill: "#121313",
    transform: "translate(652,726)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.56327794 3.53286034 -8.49633208 3.32374517 -14 3 C-13 1 -13 1 -11.07421875 0.33203125 C-10.28660156 0.16058594 -9.49898438 -0.01085937 -8.6875 -0.1875 C-7.90761719 -0.36667969 -7.12773437 -0.54585937 -6.32421875 -0.73046875 C-3.90795241 -1.01067443 -2.29757048 -0.74132137 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(514,592)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.43358249 4.30764815 -1.68336156 8.06171464 -4 12 C-4.33 12 -4.66 12 -5 12 C-5.70731186 7.33174173 -3.92277529 4.96719769 -1.2890625 1.35546875 C-0.86367188 0.90816406 -0.43828125 0.46085938 0 0 Z ",
    fill: "#131313",
    transform: "translate(283,572)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.85851562 0.33451172 0.85851562 0.33451172 1.734375 0.67578125 C0.49065311 1.66291003 -0.76089718 2.6401803 -2.015625 3.61328125 C-2.71171875 4.15855469 -3.4078125 4.70382812 -4.125 5.265625 C-6.22654628 6.65003779 -7.80884299 7.23865112 -10.265625 7.67578125 C-10.265625 7.01578125 -10.265625 6.35578125 -10.265625 5.67578125 C-8.65625 4.1328125 -8.65625 4.1328125 -6.515625 2.48828125 C-5.81953125 1.93785156 -5.1234375 1.38742187 -4.40625 0.8203125 C-2.265625 -0.32421875 -2.265625 -0.32421875 0 0 Z ",
    fill: "#111112",
    transform: "translate(489.265625,425.32421875)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 4.62 1 9.24 1 14 C0.01 13.67 -0.98 13.34 -2 13 C-1.48041715 8.62065881 -0.94324258 4.31196609 0 0 Z ",
    fill: "#272727",
    transform: "translate(378,359)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-5.445 3.96 -5.445 3.96 -11 8 C-11.33 7.01 -11.66 6.02 -12 5 C-10.76265016 3.96386967 -9.50955363 2.94652198 -8.25 1.9375 C-7.55390625 1.36902344 -6.8578125 0.80054688 -6.140625 0.21484375 C-4 -1 -4 -1 0 0 Z ",
    fill: "#111112",
    transform: "translate(595,266)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C0.03 3.64 -2.94 6.28 -6 9 C-6.66 8.67 -7.32 8.34 -8 8 C-3.375 2.25 -3.375 2.25 0 0 Z ",
    fill: "#131314",
    transform: "translate(293,258)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.66 6 1.32 6 2 C7.65 1.34 9.3 0.68 11 0 C11.33 1.32 11.66 2.64 12 4 C10.37399059 3.9129995 8.74910322 3.8048219 7.125 3.6875 C6.22007812 3.62949219 5.31515625 3.57148437 4.3828125 3.51171875 C2 3 2 3 0 0 Z ",
    fill: "#282827",
    transform: "translate(469,712)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.94139078 1.66751148 6.7892812 4.22710649 10 7 C8.203125 7.67578125 8.203125 7.67578125 6 8 C4.296875 6.85546875 4.296875 6.85546875 2.75 5.1875 C2.22921875 4.64480469 1.7084375 4.10210938 1.171875 3.54296875 C0 2 0 2 0 0 Z ",
    fill: "#141415",
    transform: "translate(518,658)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.25127906 3.54667178 0.72285053 5.72253438 -0.4375 9.25 C-0.72496094 10.14203125 -1.01242187 11.0340625 -1.30859375 11.953125 C-1.53675781 12.62859375 -1.76492188 13.3040625 -2 14 C-2.33 14 -2.66 14 -3 14 C-3.32374517 8.49633208 -3.53286034 4.56327794 0 0 Z ",
    fill: "#111111",
    transform: "translate(516,603)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.33 1.02 1.66 0 2 C-0.33 2.99 -0.66 3.98 -1 5 C-1.66 5 -2.32 5 -3 5 C-3.66 6.32 -4.32 7.64 -5 9 C-5.33 7.68 -5.66 6.36 -6 5 C-1.60546875 0.99609375 -1.60546875 0.99609375 0 0 Z ",
    fill: "#161617",
    transform: "translate(296,558)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.31881505 2.67901932 -4.31814468 3.66204403 -7.6875 4.6875 C-8.89986328 5.06455078 -8.89986328 5.06455078 -10.13671875 5.44921875 C-11.05904297 5.72185547 -11.05904297 5.72185547 -12 6 C-11 3 -11 3 -9.00390625 1.796875 C-8.19824219 1.45140625 -7.39257812 1.1059375 -6.5625 0.75 C-5.75941406 0.39421875 -4.95632813 0.0384375 -4.12890625 -0.328125 C-2 -1 -2 -1 0 0 Z ",
    fill: "#151516",
    transform: "translate(602,521)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C3.99 3.63 4.98 7.26 6 11 C4.68 10.67 3.36 10.34 2 10 C2 7.36 2 4.72 2 2 C1.01 1.67 0.02 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(287,504)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.13732426 3.40401948 0.83989957 5.77456664 0.0625 9.25 C-0.13214844 10.14203125 -0.32679688 11.0340625 -0.52734375 11.953125 C-0.68332031 12.62859375 -0.83929688 13.3040625 -1 14 C-1.33 14 -1.66 14 -2 14 C-2.83154187 9.38032292 -3.19811544 5.57462259 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#232425",
    transform: "translate(327,468)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.19294408 4.82360189 0.75747614 8.49646738 -1 13 C-1.66 12.67 -2.32 12.34 -3 12 C-2.67 9.03 -2.34 6.06 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#151616",
    transform: "translate(383,429)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 0.07421875 5.04296875 C-0.61220703 6.10451172 -0.61220703 6.10451172 -1.3125 7.1875 C-1.76238281 7.90292969 -2.21226562 8.61835938 -2.67578125 9.35546875 C-3.11277344 9.89816406 -3.54976563 10.44085938 -4 11 C-4.66 11 -5.32 11 -6 11 C-4.74194623 6.49197399 -3.09592835 3.5087188 0 0 Z ",
    fill: "#151616",
    transform: "translate(272,426)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.33 5.94 0.66 9 1 C9.33 2.32 9.66 3.64 10 5 C9.67 4.34 9.34 3.68 9 3 C8.01 3.33 7.02 3.66 6 4 C4.32577014 3.70700977 2.65821773 3.37309899 1 3 C0.01 3 -0.98 3 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#242424",
    transform: "translate(422,422)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.875 0.25 2.875 0.25 6 1 C7.5 2.8125 7.5 2.8125 8 5 C7.125 7.25 7.125 7.25 6 9 C5.7525 8.195625 5.505 7.39125 5.25 6.5625 C4.27761141 3.828919 4.27761141 3.828919 1.875 3.1875 C1.25625 3.125625 0.6375 3.06375 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#222324",
    transform: "translate(658,275)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.99500618 1.3697164 6.80009492 3.25722422 10 6 C9.67 6.66 9.34 7.32 9 8 C7.49460339 7.05016642 5.99579653 6.08988109 4.5 5.125 C3.6646875 4.59132813 2.829375 4.05765625 1.96875 3.5078125 C1.3190625 3.01023437 0.669375 2.51265625 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#151616",
    transform: "translate(397,747)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C0.69 3.97 -1.62 6.94 -4 10 C-4.33 9.01 -4.66 8.02 -5 7 C-4.00390625 5.17578125 -4.00390625 5.17578125 -2.5625 3.3125 C-2.08941406 2.68988281 -1.61632812 2.06726563 -1.12890625 1.42578125 C-0.75636719 0.95527344 -0.38382813 0.48476563 0 0 Z ",
    fill: "#171818",
    transform: "translate(747,680)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 -2.3125 5.6875 C-5 8 -5 8 -8 8 C-6.49776416 3.79373966 -3.71449966 2.26099979 0 0 Z ",
    fill: "#141415",
    transform: "translate(576,639)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C0.35 4.63 -1.3 8.26 -3 12 C-3.33 12 -3.66 12 -4 12 C-3.5317879 7.22423661 -2.75668002 3.95523655 0 0 Z ",
    fill: "#131314",
    transform: "translate(783,621)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.15957207 3.47871621 0.77456651 4.34219645 -0.4375 7.6875 C-0.72496094 8.49574219 -1.01242187 9.30398438 -1.30859375 10.13671875 C-1.65083984 11.05904297 -1.65083984 11.05904297 -2 12 C-2.33 12 -2.66 12 -3 12 C-3.15384615 4 -3.15384615 4 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#121313",
    transform: "translate(637,415)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.78375 0.04125 1.5675 0.0825 2.375 0.125 C0.88402342 3.9202131 -1.38200849 5.73542731 -4.625 8.125 C-4.75 5.25 -4.75 5.25 -4.625 2.125 C-2.625 0.125 -2.625 0.125 0 0 Z ",
    fill: "#141415",
    transform: "translate(391.625,403.875)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.32829194 3.8063457 0.27253436 7.35206816 -1 11 C-1.99 10.67 -2.98 10.34 -4 10 C-2.68 6.7 -1.36 3.4 0 0 Z ",
    fill: "#141414",
    transform: "translate(570,290)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C1.66 3 2.32 3 3 3 C3 6.63 3 10.26 3 14 C0.81005752 10.71508627 0.64722661 9.16904361 0.375 5.3125 C0.30023438 4.31863281 0.22546875 3.32476562 0.1484375 2.30078125 C0.09945313 1.54152344 0.05046875 0.78226563 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(460,230)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.29315061 0.95632999 2.58446853 1.91513851 3.875 2.875 C4.59429687 3.40867187 5.31359375 3.94234375 6.0546875 4.4921875 C8 6 8 6 10 8 C7.8125 8.3125 7.8125 8.3125 5 8 C2.1875 5.6875 2.1875 5.6875 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#111111",
    transform: "translate(381,786)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C-0.49825283 4.21203935 -3.0702992 7.17493137 -6 10 C-6.66 9.67 -7.32 9.34 -8 9 C-6.4169423 4.7257442 -3.49431596 2.73468206 0 0 Z ",
    fill: "#131313",
    transform: "translate(723,709)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.64 1 5.28 1 8 C-1.3125 8.625 -1.3125 8.625 -4 9 C-4.99 8.34 -5.98 7.68 -7 7 C-5.35 6.67 -3.7 6.34 -2 6 C-1.34 4.02 -0.68 2.04 0 0 Z ",
    fill: "#100F10",
    transform: "translate(455,516)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.09898702 3.29696105 0.87124444 4.40494903 0.0625 7.6875 C-0.22947266 8.89986328 -0.22947266 8.89986328 -0.52734375 10.13671875 C-0.68332031 10.75160156 -0.83929687 11.36648438 -1 12 C-1.33 11.01 -1.66 10.02 -2 9 C-2.66 9 -3.32 9 -4 9 C-4 7.68 -4 6.36 -4 5 C-3.34 5 -2.68 5 -2 5 C-1.7834375 4.0409375 -1.7834375 4.0409375 -1.5625 3.0625 C-1 1 -1 1 0 0 Z ",
    fill: "#262627",
    transform: "translate(526,490)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.21386936 3.64160808 0.6674695 4.33165469 -0.9375 7.6875 C-1.31777344 8.49574219 -1.69804688 9.30398438 -2.08984375 10.13671875 C-2.39019531 10.75160156 -2.69054687 11.36648438 -3 12 C-3.33 12 -3.66 12 -4 12 C-3.5317879 7.22423661 -2.75668002 3.95523655 0 0 Z ",
    fill: "#111212",
    transform: "translate(621,479)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.21192221 5.19209404 0.5912689 9.126739 -1 14 C-1.33 14 -1.66 14 -2 14 C-2.05437607 12.41705218 -2.09296271 10.83355744 -2.125 9.25 C-2.14820313 8.36828125 -2.17140625 7.4865625 -2.1953125 6.578125 C-1.99139502 3.8864142 -1.36551721 2.30095026 0 0 Z ",
    fill: "#0B0C0C",
    transform: "translate(432,468)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 4.29 1.66 8.58 2 13 C1.01 13.495 1.01 13.495 0 14 C-0.91297308 9.02936879 -0.91297308 4.97063121 0 0 Z ",
    fill: "#252525",
    transform: "translate(819,452)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.07421875 3.9453125 0.07421875 3.9453125 -1.3125 6.125 C-1.76238281 6.84945313 -2.21226562 7.57390625 -2.67578125 8.3203125 C-3.11277344 8.87460937 -3.54976562 9.42890625 -4 10 C-4.66 10 -5.32 10 -6 10 C-5.00475043 5.35550201 -4.03925611 2.69283741 0 0 Z ",
    fill: "#111111",
    transform: "translate(234,432)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88610125 1.79240663 0.75852313 3.58394835 0.625 5.375 C0.52058594 6.87160156 0.52058594 6.87160156 0.4140625 8.3984375 C0 11 0 11 -2 13 C-2.05447047 11.58376784 -2.09300508 10.16691809 -2.125 8.75 C-2.14820313 7.96109375 -2.17140625 7.1721875 -2.1953125 6.359375 C-1.9828378 3.79268059 -1.28654105 2.2083933 0 0 Z ",
    fill: "#0E0F0F",
    transform: "translate(384,337)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.19294408 4.82360189 0.75747614 8.49646738 -1 13 C-1.33 13 -1.66 13 -2 13 C-2.05447047 11.58376784 -2.09300508 10.16691809 -2.125 8.75 C-2.14820313 7.96109375 -2.17140625 7.1721875 -2.1953125 6.359375 C-1.9828378 3.79268059 -1.28654105 2.2083933 0 0 Z ",
    fill: "#0E0F0F",
    transform: "translate(389,314)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2.625 2.625 C3.12095645 5.7660575 3.06103811 8.82601831 3 12 C2.67 11.01 2.34 10.02 2 9 C1.34 9 0.68 9 0 9 C0 6.03 0 3.06 0 0 Z ",
    fill: "#0E0E0F",
    transform: "translate(442,301)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C0.36 3.64 -2.28 6.28 -5 9 C-5.33 8.01 -5.66 7.02 -6 6 C-4.02 4.02 -2.04 2.04 0 0 Z ",
    fill: "#141415",
    transform: "translate(270,279)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.721875 0.61875 1.44375 1.2375 2.1875 1.875 C4.78381938 3.83666353 6.94671666 4.95316 10 6 C10 6.33 10 6.66 10 7 C6.33924624 7.3327958 4.60499012 7.46170299 1.625 5.1875 C0 3 0 3 0 0 Z ",
    fill: "#161516",
    transform: "translate(641,787)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.2475 0.598125 0.495 1.19625 0.75 1.8125 C2.16444091 4.28777159 3.72860188 5.33430804 6 7 C6 7.66 6 8.32 6 9 C7.32 9.33 8.64 9.66 10 10 C3.56985294 9.51470588 3.56985294 9.51470588 1.0625 7.25 C-0.16717908 4.64597372 -0.23723981 2.84687774 0 0 Z ",
    fill: "#0C0C0D",
    transform: "translate(602,776)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.37031549 0.9481262 3.76672508 1.68896678 5.3125 3.75 C6.22969251 6.75172093 5.68688835 8.97769126 5 12 C4.67 12 4.34 12 4 12 C3.71125 10.7625 3.4225 9.525 3.125 8.25 C2.38665206 5.27551258 1.55525067 2.666144 0 0 Z ",
    fill: "#111212",
    transform: "translate(671,759)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.66 0 1.32 0 2 C0.99 2.33 1.98 2.66 3 3 C-0.96 3 -4.92 3 -9 3 C-8.67 2.34 -8.34 1.68 -8 1 C-5.2303041 0.27113266 -2.87137415 0 0 0 Z ",
    fill: "#292828",
    transform: "translate(505,712)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1 3 -1 3 -2.6875 4.1875 C-5.54969093 5.19313465 -7.98827908 5.13689641 -11 5 C-8.12934225 2.12934225 -4.13678472 0 0 0 Z ",
    fill: "#131313",
    transform: "translate(686,664)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C-0.07692746 3.6815279 -2.19734663 4.42087807 -6.25 4.6875 C-7.14203125 4.75324219 -8.0340625 4.81898438 -8.953125 4.88671875 C-9.62859375 4.92410156 -10.3040625 4.96148438 -11 5 C-11 4.67 -11 4.34 -11 4 C-10.37351562 3.79503906 -9.74703125 3.59007812 -9.1015625 3.37890625 C-8.28429687 3.10949219 -7.46703125 2.84007812 -6.625 2.5625 C-5.81289063 2.29566406 -5.00078125 2.02882813 -4.1640625 1.75390625 C-1.98968201 1.04820271 -1.98968201 1.04820271 0 0 Z ",
    fill: "#0F0E0E",
    transform: "translate(451,645)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.1725131 0.95117134 2.33787015 1.91117009 3.5 2.875 C4.47453125 3.67550781 4.47453125 3.67550781 5.46875 4.4921875 C5.9740625 4.98976563 6.479375 5.48734375 7 6 C7 6.66 7 7.32 7 8 C7.66 8.33 8.32 8.66 9 9 C6.75 8.875 6.75 8.875 4 8 C0 2.91891892 0 2.91891892 0 0 Z ",
    fill: "#111111",
    transform: "translate(430,640)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 0.22265625 5.921875 C-0.8515625 7.61458333 -1.92578125 9.30729167 -3 11 C-3.66 10.34 -4.32 9.68 -5 9 C-3.35 6.03 -1.7 3.06 0 0 Z ",
    fill: "#131314",
    transform: "translate(488,628)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.68201156 5.37084106 2.11521265 10.58500559 2 16 C1.67 16 1.34 16 1 16 C-0.79074734 10.10106757 -1.08360869 6.06820868 0 0 Z ",
    fill: "#232424",
    transform: "translate(512,612)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.28571429 8.57142857 1.28571429 8.57142857 -1 12 C-1.33 12 -1.66 12 -2 12 C-1.85904936 10.3745692 -1.71207913 8.74965949 -1.5625 7.125 C-1.48128906 6.22007812 -1.40007813 5.31515625 -1.31640625 4.3828125 C-1 2 -1 2 0 0 Z ",
    fill: "#101011",
    transform: "translate(669,607)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 1.32 1.32 2.64 2 4 C1.01 4 0.02 4 -1 4 C-1.66 5.98 -2.32 7.96 -3 10 C-3.66 10 -4.32 10 -5 10 C-4.38545304 6.00544473 -2.29353263 3.25533664 0 0 Z ",
    fill: "#171718",
    transform: "translate(446,572)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C4.25 6.625 4.25 6.625 2 10 C1.71125 9.030625 1.4225 8.06125 1.125 7.0625 C0.35785318 3.89335797 0.35785318 3.89335797 -2 3 C-1 1 -1 1 0 0 Z ",
    fill: "#2A2A2A",
    transform: "translate(189,572)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.31611677 0.95336021 2.62778961 1.91285774 3.9375 2.875 C4.66839844 3.40867187 5.39929688 3.94234375 6.15234375 4.4921875 C8 6 8 6 9 8 C6.69 7.34 4.38 6.68 2 6 C2 5.34 2 4.68 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#101011",
    transform: "translate(560,516)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.45606519 4.52092968 0.27032841 7.51648796 -1 12 C-1.66 12 -2.32 12 -3 12 C-2.67 9.03 -2.34 6.06 -2 3 C-1.34 3 -0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#111111",
    transform: "translate(743,500)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.25127906 3.54667178 0.72285053 5.72253438 -0.4375 9.25 C-0.72496094 10.14203125 -1.01242187 11.0340625 -1.30859375 11.953125 C-1.53675781 12.62859375 -1.76492188 13.3040625 -2 14 C-2.33 14 -2.66 14 -3 14 C-3.29341888 8.32723489 -3.00559652 5.00932754 0 0 Z ",
    fill: "#0B0B0B",
    transform: "translate(618,505)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C3.71034824 1.37562854 2.37310707 2.70766393 1 4 C0.34 4 -0.32 4 -1 4 C-1 4.66 -1 5.32 -1 6 C-1.99 6.33 -2.98 6.66 -4 7 C-4 6.01 -4 5.02 -4 4 C-3.34 4 -2.68 4 -2 4 C-1.34 2.68 -0.68 1.36 0 0 Z ",
    fill: "#141515",
    transform: "translate(338,497)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 4.95 -0.66 9.9 -1 15 C-1.33 15 -1.66 15 -2 15 C-2.33 10.38 -2.66 5.76 -3 1 C-1 0 -1 0 0 0 Z ",
    fill: "#252526",
    transform: "translate(325,482)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.39009109 3.55780196 0.4216319 6.6828589 -1 10 C-1.66 10 -2.32 10 -3 10 C-2.49287967 6.28111761 -1.88391785 3.26545761 0 0 Z ",
    fill: "#171818",
    transform: "translate(204,378)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.13732426 3.40401948 0.83989957 5.77456664 0.0625 9.25 C-0.13214844 10.14203125 -0.32679688 11.0340625 -0.52734375 11.953125 C-0.68332031 12.62859375 -0.83929688 13.3040625 -1 14 C-1.33 14 -1.66 14 -2 14 C-2.05410687 12.22950311 -2.09284119 10.45853151 -2.125 8.6875 C-2.14820313 7.70136719 -2.17140625 6.71523438 -2.1953125 5.69921875 C-2 3 -2 3 0 0 Z ",
    fill: "#090A0A",
    transform: "translate(381,352)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3.39593478 -0.52165948 4.06619881 -2.5 6.6875 C-2.9640625 7.31011719 -3.428125 7.93273437 -3.90625 8.57421875 C-4.2671875 9.04472656 -4.628125 9.51523437 -5 10 C-5.33 9.01 -5.66 8.02 -6 7 C-2.73239437 1.36619718 -2.73239437 1.36619718 0 0 Z ",
    fill: "#131213",
    transform: "translate(237,320)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.3 1 6.6 1 10 C0.34 10 -0.32 10 -1 10 C-1.33 10.99 -1.66 11.98 -2 13 C-1.85851011 11.3954444 -1.71164314 9.79136233 -1.5625 8.1875 C-1.48128906 7.29417969 -1.40007812 6.40085937 -1.31640625 5.48046875 C-1 3 -1 3 0 0 Z ",
    fill: "#0F0F10",
    transform: "translate(415,317)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.08131463 1.43655854 1.13933559 2.8744483 1.1875 4.3125 C1.23970703 5.51326172 1.23970703 5.51326172 1.29296875 6.73828125 C0.93801608 9.47851584 0.10633718 10.29171079 -2 12 C-1.85904936 10.3745692 -1.71207913 8.74965949 -1.5625 7.125 C-1.48128906 6.22007812 -1.40007812 5.31515625 -1.31640625 4.3828125 C-1 2 -1 2 0 0 Z ",
    fill: "#0D0E0E",
    transform: "translate(421,289)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.8125 1.6875 0.8125 1.6875 1 4 C-1.125 6.8125 -1.125 6.8125 -4 9 C-6.8125 8.8125 -6.8125 8.8125 -9 8 C-8.4225 7.731875 -7.845 7.46375 -7.25 7.1875 C-3.5421173 5.23056191 -1.35687262 4.07061787 0 0 Z ",
    fill: "#171817",
    transform: "translate(617,777)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.475 0.99 2.475 0.99 5 2 C3.9024777 4.99324263 3.32317108 5.84610901 0.375 7.25 C-0.40875 7.4975 -1.1925 7.745 -2 8 C-1.67 7.236875 -1.34 6.47375 -1 5.6875 C0.17436686 3.00930865 0.17436686 3.00930865 0 0 Z ",
    fill: "#262627",
    transform: "translate(577,632)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.18414294 3.55242882 0.69535532 4.69830562 -0.4375 8.1875 C-0.72496094 9.08855469 -1.01242187 9.98960937 -1.30859375 10.91796875 C-1.53675781 11.60503906 -1.76492188 12.29210937 -2 13 C-3.29696563 8.66052854 -2.79928632 5.43240597 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#0C0D0D",
    transform: "translate(399,599)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.21065165 3.63195496 0.62784815 5.06531629 -0.4375 8.6875 C-0.86869141 10.17830078 -0.86869141 10.17830078 -1.30859375 11.69921875 C-1.53675781 12.45847656 -1.76492188 13.21773437 -2 14 C-3.29653752 9.65221251 -2.78866917 6.44522621 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#0A0A0A",
    transform: "translate(270,600)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.38461538 7.50769231 0.38461538 7.50769231 -1.5625 10 C-2.036875 10.33 -2.51125 10.66 -3 11 C-2.53199289 6.94393835 -2.12046792 3.53411321 0 0 Z ",
    fill: "#101111",
    transform: "translate(552,596)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.43454163 3.95820859 0.19097652 6.6659053 -2 10 C-2.6875 8.375 -2.6875 8.375 -3 6 C-1.5625 2.75 -1.5625 2.75 0 0 Z ",
    fill: "#141415",
    transform: "translate(404,584)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.90318884 2.85478326 2.4619099 4.41941308 3.125 7.6875 C3.29257813 8.49574219 3.46015625 9.30398438 3.6328125 10.13671875 C3.75398437 10.75160156 3.87515625 11.36648438 4 12 C3.01 11.67 2.02 11.34 1 11 C-0.47666292 7.50970582 -0.07164685 3.72563614 0 0 Z ",
    fill: "#272728",
    transform: "translate(204,578)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 0.22265625 4.82421875 C-0.8515625 6.54947917 -1.92578125 8.27473958 -3 10 C-3.66 10 -4.32 10 -5 10 C-4.49701212 5.59885603 -2.91227269 3.28804981 0 0 Z ",
    fill: "#151515",
    transform: "translate(685,571)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.62845496 2.95409701 -0.98863724 5.44008376 -3 8 C-3.99 7.67 -4.98 7.34 -6 7 C-5.04882866 5.8274869 -4.08882991 4.66212985 -3.125 3.5 C-2.59132813 2.8503125 -2.05765625 2.200625 -1.5078125 1.53125 C-0.76144531 0.77328125 -0.76144531 0.77328125 0 0 Z ",
    fill: "#111111",
    transform: "translate(453,563)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C2.28571429 8.42857143 2.28571429 8.42857143 1 13 C0.67 13 0.34 13 0 13 C-1.85072153 7.85910687 -2.21474076 5.04468729 0 0 Z ",
    fill: "#242424",
    transform: "translate(186,549)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.60226955 0.22245393 -3.20696767 0.42746669 -4.8125 0.625 C-5.70582031 0.74101563 -6.59914063 0.85703125 -7.51953125 0.9765625 C-10 1 -10 1 -13 -1 C-7.44830932 -3.09730537 -5.16442135 -2.67125242 0 0 Z ",
    fill: "#232425",
    transform: "translate(327,547)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-1.31 4.98 -3.62 6.96 -6 9 C-6 6 -6 6 -4.6875 4.39453125 C-4.130625 3.87246094 -3.57375 3.35039063 -3 2.8125 C-2.443125 2.28269531 -1.88625 1.75289062 -1.3125 1.20703125 C-0.6628125 0.60955078 -0.6628125 0.60955078 0 0 Z ",
    fill: "#121212",
    transform: "translate(340,512)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.5504955 3.31554985 1.09010284 4.62738358 0.625 5.9375 C0.36976563 6.66839844 0.11453125 7.39929688 -0.1484375 8.15234375 C-1 10 -1 10 -3 11 C-2.25 3.375 -2.25 3.375 0 0 Z ",
    fill: "#242525",
    transform: "translate(392,487)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.25127906 3.54667178 0.72285053 5.72253438 -0.4375 9.25 C-0.72496094 10.14203125 -1.01242188 11.0340625 -1.30859375 11.953125 C-1.53675781 12.62859375 -1.76492187 13.3040625 -2 14 C-2.33 14 -2.66 14 -3 14 C-3.29341888 8.32723489 -3.00559652 5.00932754 0 0 Z ",
    fill: "#0B0B0B",
    transform: "translate(222,456)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88601335 1.62580966 0.75844341 3.25067157 0.625 4.875 C0.52058594 6.23238281 0.52058594 6.23238281 0.4140625 7.6171875 C0 10 0 10 -2 12 C-2.28571429 3.42857143 -2.28571429 3.42857143 0 0 Z ",
    fill: "#0C0D0D",
    transform: "translate(443,419)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33292585 4.24480464 1.43885872 6.35542625 -1 9.9375 C-1.66 10.618125 -2.32 11.29875 -3 12 C-2.40075776 7.80530429 -1.42500059 3.99000166 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(479,408)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.455 2.97 -4.455 2.97 -9 6 C-8 2 -8 2 -6.1875 0.1875 C-4 -1 -4 -1 0 0 Z ",
    fill: "#141414",
    transform: "translate(556,408)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.14958831 3.42346555 3.56179109 6.44262737 4 11 C3.34 11 2.68 11 2 11 C0.57741188 7.17679443 -0.24042276 4.08718695 0 0 Z ",
    fill: "#131313",
    transform: "translate(792,396)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.08667969 0.11988281 2.17335938 0.23976563 3.29296875 0.36328125 C4.12441406 0.47027344 4.95585938 0.57726562 5.8125 0.6875 C5.8125 1.0175 5.8125 1.3475 5.8125 1.6875 C0.73163204 2.53431133 -4.03578377 2.77788099 -9.1875 2.6875 C-6.51245717 -0.96369882 -4.27917944 -0.5061395 0 0 Z ",
    fill: "#30302F",
    transform: "translate(567.1875,376.3125)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.5078125 1.75 3.5078125 1.75 5.125 4 C5.66382813 4.7425 6.20265625 5.485 6.7578125 6.25 C7.16773438 6.8275 7.57765625 7.405 8 8 C4.21956837 7.22167584 2.48590701 6.01860137 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#141515",
    transform: "translate(560,348)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.08167446 1.41569064 1.13949698 2.83276805 1.1875 4.25 C1.22230469 5.03890625 1.25710938 5.8278125 1.29296875 6.640625 C0.93578688 9.51712968 -0.11751718 10.84576769 -2 13 C-1.85851011 11.3954444 -1.71164314 9.79136233 -1.5625 8.1875 C-1.48128906 7.29417969 -1.40007812 6.40085937 -1.31640625 5.48046875 C-1 3 -1 3 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(412,331)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2.4140625 3.28515625 2.4140625 3.28515625 2.625 6.0625 C2.69976562 6.98160156 2.77453125 7.90070313 2.8515625 8.84765625 C2.92503906 9.91306641 2.92503906 9.91306641 3 11 C0.9375 9.4375 0.9375 9.4375 -1 7 C-0.75 3.25 -0.75 3.25 0 0 Z ",
    fill: "#101111",
    transform: "translate(445,315)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.44499019 3.81684226 -2.03595495 6.19195732 -5 9 C-5.66 8.67 -6.32 8.34 -7 8 C-5.38405168 5.95880212 -3.7143618 3.95927063 -2 2 C-1.34 2 -0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#0F1010",
    transform: "translate(279,286)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88557539 1.60495567 0.75805306 3.20898119 0.625 4.8125 C0.55539062 5.70582031 0.48578125 6.59914063 0.4140625 7.51953125 C0 10 0 10 -2 13 C-2.05447047 11.58376784 -2.09300508 10.16691809 -2.125 8.75 C-2.14820313 7.96109375 -2.17140625 7.1721875 -2.1953125 6.359375 C-1.9828378 3.79268059 -1.28654105 2.2083933 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(490,273)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 2 3 2 3.75 4.5 C4 7 4 7 3 9 C2.01 9 1.02 9 0 9 C-0.33 8.01 -0.66 7.02 -1 6 C-0.67 5.67 -0.34 5.34 0 5 C0.04063832 3.33382885 0.042721 1.66611905 0 0 Z ",
    fill: "#282828",
    transform: "translate(353,252)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.23941385 3.71824156 -2.9233963 4.67378745 -6 7 C-6.66 7.66 -7.32 8.32 -8 9 C-7.70100785 5.41209425 -7.23013399 4.21833224 -4.5625 1.6875 C-2 0 -2 0 0 0 Z ",
    fill: "#181818",
    transform: "translate(397,205)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88590407 1.45922693 0.75834456 2.91740598 0.625 4.375 C0.55539062 5.18710938 0.48578125 5.99921875 0.4140625 6.8359375 C0 9 0 9 -2 11 C-2.25 3.375 -2.25 3.375 0 0 Z ",
    fill: "#0F1010",
    transform: "translate(506,202)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88601335 1.62580966 0.75844341 3.25067157 0.625 4.875 C0.52058594 6.23238281 0.52058594 6.23238281 0.4140625 7.6171875 C0 10 0 10 -2 12 C-2.05422947 10.5629191 -2.09289723 9.12524538 -2.125 7.6875 C-2.14820313 6.88699219 -2.17140625 6.08648437 -2.1953125 5.26171875 C-2 3 -2 3 0 0 Z ",
    fill: "#0F0F10",
    transform: "translate(509,188)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.71758359 1.46015291 1.42373386 2.91809793 1.125 4.375 C0.96257813 5.18710938 0.80015625 5.99921875 0.6328125 6.8359375 C0 9 0 9 -2 11 C-1.85957123 9.35369672 -1.71250671 7.70795821 -1.5625 6.0625 C-1.48128906 5.14597656 -1.40007813 4.22945312 -1.31640625 3.28515625 C-1 1 -1 1 0 0 Z ",
    fill: "#151515",
    transform: "translate(539,181)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C-2.32307692 6.93846154 -2.32307692 6.93846154 -5.75 7.25 C-6.4925 7.1675 -7.235 7.085 -8 7 C-7.236875 6.401875 -6.47375 5.80375 -5.6875 5.1875 C-3.6516425 3.53040668 -1.8021721 1.89702326 0 0 Z ",
    fill: "#121213",
    transform: "translate(502,787)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.99 1.98 1.98 3 3 C2.875 6.0625 2.875 6.0625 2 9 C1.01 9.66 0.02 10.32 -1 11 C-0.67 7.37 -0.34 3.74 0 0 Z ",
    fill: "#262526",
    transform: "translate(689,690)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-4.55426184 2.66590937 -7.73946963 3.31563182 -13 3 C-13 2.67 -13 2.34 -13 2 C-11.02 2 -9.04 2 -7 2 C-7 1.34 -7 0.68 -7 0 C-3.86650268 -1.04449911 -3.01031744 -0.93423645 0 0 Z ",
    fill: "#101010",
    transform: "translate(325,647)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 2.97 1.66 5.94 2 9 C1.34 9 0.68 9 0 9 C-0.99 9.99 -1.98 10.98 -3 12 C-2.01 8.04 -1.02 4.08 0 0 Z ",
    fill: "#2A2B2B",
    transform: "translate(472,606)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 -0.4375 6.75 C-1.2109375 7.86375 -1.2109375 7.86375 -2 9 C-2.99 8.67 -3.98 8.34 -5 8 C-3.35 5.36 -1.7 2.72 0 0 Z ",
    fill: "#131314",
    transform: "translate(319,572)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C1.36 2.98 -1.28 4.96 -4 7 C-4.66 6.67 -5.32 6.34 -6 6 C-4 4 -2 2 0 0 Z ",
    fill: "#111212",
    transform: "translate(547,552)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.08131463 1.43655854 1.13933559 2.8744483 1.1875 4.3125 C1.23970703 5.51326172 1.23970703 5.51326172 1.29296875 6.73828125 C0.93801608 9.47851584 0.10633718 10.29171079 -2 12 C-1.85831863 10.56208484 -1.71148957 9.1246763 -1.5625 7.6875 C-1.48128906 6.88699219 -1.40007812 6.08648437 -1.31640625 5.26171875 C-1 3 -1 3 0 0 Z ",
    fill: "#0F1010",
    transform: "translate(461,490)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.37211538 7.56634615 1.37211538 7.56634615 -0.51171875 9.76171875 C-1.00285156 10.17035156 -1.49398438 10.57898438 -2 11 C-1.85892253 9.54119891 -1.71197585 8.08296449 -1.5625 6.625 C-1.48128906 5.81289063 -1.40007812 5.00078125 -1.31640625 4.1640625 C-1 2 -1 2 0 0 Z ",
    fill: "#0D0D0D",
    transform: "translate(466,469)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 2.64 1.66 5.28 2 8 C0.68 8.99 -0.64 9.98 -2 11 C-1.85892253 9.54119891 -1.71197585 8.08296449 -1.5625 6.625 C-1.48128906 5.81289063 -1.40007812 5.00078125 -1.31640625 4.1640625 C-1 2 -1 2 0 0 Z ",
    fill: "#101011",
    transform: "translate(469,457)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.08090971 1.62418745 1.13914995 3.24951745 1.1875 4.875 C1.22230469 5.77992188 1.25710938 6.68484375 1.29296875 7.6171875 C1.19628906 8.40351563 1.09960938 9.18984375 1 10 C0.01 10.66 -0.98 11.32 -2 12 C-1.34 8.04 -0.68 4.08 0 0 Z ",
    fill: "#0F100F",
    transform: "translate(600,440)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.00390625 4.82421875 0.00390625 4.82421875 -1.4375 6.6875 C-1.91058594 7.31011719 -2.38367188 7.93273437 -2.87109375 8.57421875 C-3.24363281 9.04472656 -3.61617187 9.51523437 -4 10 C-4.65234375 8.203125 -4.65234375 8.203125 -5 6 C-3.63510623 3.66629928 -1.8580962 1.99405446 0 0 Z ",
    fill: "#181818",
    transform: "translate(254,315)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.34 9 -0.32 9 -1 9 C-1.33 9.99 -1.66 10.98 -2 12 C-1.85904936 10.3745692 -1.71207913 8.74965949 -1.5625 7.125 C-1.48128906 6.22007812 -1.40007812 5.31515625 -1.31640625 4.3828125 C-1 2 -1 2 0 0 Z ",
    fill: "#0F0F0F",
    transform: "translate(508,309)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88490339 1.41750563 0.75746342 2.83401169 0.625 4.25 C0.55539062 5.03890625 0.48578125 5.8278125 0.4140625 6.640625 C-0.01507113 9.085877 -0.78600638 10.84836903 -2 13 C-2.05447047 11.58376784 -2.09300508 10.16691809 -2.125 8.75 C-2.14820313 7.96109375 -2.17140625 7.1721875 -2.1953125 6.359375 C-1.9828378 3.79268059 -1.28654105 2.2083933 0 0 Z ",
    fill: "#0C0C0D",
    transform: "translate(394,291)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88557539 1.60495567 0.75805306 3.20898119 0.625 4.8125 C0.55539062 5.70582031 0.48578125 6.59914062 0.4140625 7.51953125 C0 10 0 10 -2 13 C-2.05447047 11.58376784 -2.09300508 10.16691809 -2.125 8.75 C-2.14820313 7.96109375 -2.17140625 7.1721875 -2.1953125 6.359375 C-1.9828378 3.79268059 -1.28654105 2.2083933 0 0 Z ",
    fill: "#0B0B0B",
    transform: "translate(501,224)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.98248524 4.0527516 2.08159574 7.83861737 2 12 C1.01 11.34 0.02 10.68 -1 10 C-0.67 6.7 -0.34 3.4 0 0 Z ",
    fill: "#2B2A2C",
    transform: "translate(417,767)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C8.33 1.65 8.66 3.3 9 5 C8.01 4.34 7.02 3.68 6 3 C4.01200182 2.29835358 2.01301483 1.62627128 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#0B0C0C",
    transform: "translate(681,689)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C3.5625 2.8125 3.5625 2.8125 5 6 C4.67 6.99 4.34 7.98 4 9 C1.49701566 6.06171403 0.53069061 3.82097239 0 0 Z ",
    fill: "#181818",
    transform: "translate(217,618)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.17835515 4.54805635 0.99785435 7.8794254 -1 12 C-1.33 12 -1.66 12 -2 12 C-2.21278058 7.53160785 -1.59138085 4.17737474 0 0 Z ",
    fill: "#0E0F0F",
    transform: "translate(593,594)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.39195915 4.17587745 -0.17676781 6.13474776 -2 10 C-2.33 10 -2.66 10 -3 10 C-2.88637738 8.5199159 -2.75877092 7.04089926 -2.625 5.5625 C-2.55539062 4.73878906 -2.48578125 3.91507813 -2.4140625 3.06640625 C-2.27742187 2.38449219 -2.14078125 1.70257812 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#101211",
    transform: "translate(520,592)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2.52956528 3.0916909 -5.22454612 3.90931332 -9 5 C-6.81610567 0.16423399 -5.20641855 -0.13701101 0 0 Z ",
    fill: "#141414",
    transform: "translate(443,548)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.125 7.75 1.125 7.75 0 10 C-1.32 9.67 -2.64 9.34 -4 9 C-3.2884375 7.88625 -3.2884375 7.88625 -2.5625 6.75 C-1.22130673 4.38949985 -0.487688 2.63351523 0 0 Z ",
    fill: "#131314",
    transform: "translate(519,515)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.37211538 7.56634615 1.37211538 7.56634615 -0.51171875 9.76171875 C-1.00285156 10.17035156 -1.49398437 10.57898438 -2 11 C-1.85892253 9.54119891 -1.71197585 8.08296449 -1.5625 6.625 C-1.48128906 5.81289063 -1.40007813 5.00078125 -1.31640625 4.1640625 C-1 2 -1 2 0 0 Z ",
    fill: "#101010",
    transform: "translate(653,489)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.36923077 5.41538462 1.36923077 5.41538462 -0.5 8.375 C-0.995 8.91125 -1.49 9.4475 -2 10 C-2.25 3.375 -2.25 3.375 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(496,475)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.14285714 7.42857143 1.14285714 7.42857143 0 11 C-0.66 11 -1.32 11 -2 11 C-1.125 3.375 -1.125 3.375 0 0 Z ",
    fill: "#121212",
    transform: "translate(726,450)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.34 3.63 0.68 7.26 0 11 C-0.33 11 -0.66 11 -1 11 C-1.0270043 9.54176788 -1.04639787 8.08339325 -1.0625 6.625 C-1.07410156 5.81289063 -1.08570313 5.00078125 -1.09765625 4.1640625 C-1 2 -1 2 0 0 Z ",
    fill: "#0F0F0F",
    transform: "translate(297,443)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 6 3 C1.38 3 -3.24 3 -8 3 C-8 2.67 -8 2.34 -8 2 C-6.865625 1.855625 -5.73125 1.71125 -4.5625 1.5625 C-1.19222799 1.38828522 -1.19222799 1.38828522 0 0 Z ",
    fill: "#393839",
    transform: "translate(401,400)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.01 9.33 -0.98 9.66 -2 10 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#111112",
    transform: "translate(349,369)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.08131463 1.43655854 1.13933559 2.8744483 1.1875 4.3125 C1.23970703 5.51326172 1.23970703 5.51326172 1.29296875 6.73828125 C0.93801608 9.47851584 0.10633718 10.29171079 -2 12 C-1.85831863 10.56208484 -1.71148957 9.1246763 -1.5625 7.6875 C-1.48128906 6.88699219 -1.40007812 6.08648437 -1.31640625 5.26171875 C-1 3 -1 3 0 0 Z ",
    fill: "#0D0D0D",
    transform: "translate(418,303)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.08096803 1.45742463 1.13917774 2.91612807 1.1875 4.375 C1.22230469 5.18710937 1.25710938 5.99921875 1.29296875 6.8359375 C1.19628906 7.55007813 1.09960938 8.26421875 1 9 C0.01 9.66 -0.98 10.32 -2 11 C-1.125 3.375 -1.125 3.375 0 0 Z ",
    fill: "#0E0E0F",
    transform: "translate(511,296)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.36983503 3.16115776 -1.9890638 3.9927092 -5 6 C-7.1875 5.625 -7.1875 5.625 -9 5 C-7.87926138 4.16094435 -6.75325453 3.32892169 -5.625 2.5 C-4.99851562 2.0359375 -4.37203125 1.571875 -3.7265625 1.09375 C-2 0 -2 0 0 0 Z ",
    fill: "#111212",
    transform: "translate(657,290)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.40178571 8.03571429 1.40178571 8.03571429 -2 12 C-1.85904936 10.3745692 -1.71207913 8.74965949 -1.5625 7.125 C-1.48128906 6.22007812 -1.40007813 5.31515625 -1.31640625 4.3828125 C-1 2 -1 2 0 0 Z ",
    fill: "#0C0C0D",
    transform: "translate(515,279)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.36923077 7.50769231 1.36923077 7.50769231 -0.5 10 C-0.995 10.33 -1.49 10.66 -2 11 C-2.19622241 6.78121808 -1.80230168 3.82989106 0 0 Z ",
    fill: "#0F1010",
    transform: "translate(522,250)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.33 2.64 0.66 4 1 C1.69 2.65 -0.62 4.3 -3 6 C-3.66 5.67 -4.32 5.34 -5 5 C-2.75 2.4375 -2.75 2.4375 0 0 Z ",
    fill: "#161617",
    transform: "translate(320,238)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.98 2 -2.96 2 -5 2 C-5.33 2.66 -5.66 3.32 -6 4 C-6.99 3.01 -7.98 2.02 -9 1 C-3.375 -1.125 -3.375 -1.125 0 0 Z ",
    fill: "#2F2F30",
    transform: "translate(586,212)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-3.3 0.66 -6.6 1.32 -10 2 C-10 1.01 -10 0.02 -10 -1 C-5.46625958 -2.03039555 -4.35532149 -2.17766075 0 0 Z ",
    fill: "#242423",
    transform: "translate(326,734)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.26785714 8.03571429 1.26785714 8.03571429 -1 12 C-1.2226746 10.56465159 -1.42761906 9.12654475 -1.625 7.6875 C-1.74101562 6.88699219 -1.85703125 6.08648438 -1.9765625 5.26171875 C-2 3 -2 3 0 0 Z ",
    fill: "#242525",
    transform: "translate(430,619)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2 2.32 2 3.64 2 5 C1.01 5.495 1.01 5.495 0 6 C0 5.01 0 4.02 0 3 C-1.32 2.67 -2.64 2.34 -4 2 C-2.125 0.9375 -2.125 0.9375 0 0 Z ",
    fill: "#111111",
    transform: "translate(637,588)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.45606519 4.52092968 0.27032841 7.51648796 -1 12 C-1.33 12 -1.66 12 -2 12 C-2.05422947 10.5629191 -2.09289723 9.12524538 -2.125 7.6875 C-2.14820313 6.88699219 -2.17140625 6.08648438 -2.1953125 5.26171875 C-2 3 -2 3 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(348,585)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.979375 0.94875 1.95875 1.8975 1.9375 2.875 C1.77448174 5.90666283 1.77448174 5.90666283 3 8 C1.68 7.67 0.36 7.34 -1 7 C-1.04254356 5.00045254 -1.04080783 2.99958364 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(585,584)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-1.99 2.34 -2.98 1.68 -4 1 C-6.0492094 0.54860541 -6.0492094 0.54860541 -8.1875 0.375 C-9.445625 0.25125 -10.70375 0.1275 -12 0 C-12 -0.33 -12 -0.66 -12 -1 C-3.42857143 -2.42857143 -3.42857143 -2.42857143 0 0 Z ",
    fill: "#292929",
    transform: "translate(347,561)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.37211538 7.56634615 1.37211538 7.56634615 -0.51171875 9.76171875 C-1.00285156 10.17035156 -1.49398437 10.57898438 -2 11 C-1.85892253 9.54119891 -1.71197585 8.08296449 -1.5625 6.625 C-1.48128906 5.81289063 -1.40007813 5.00078125 -1.31640625 4.1640625 C-1 2 -1 2 0 0 Z ",
    fill: "#0C0C0D",
    transform: "translate(770,527)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.37211538 7.56634615 1.37211538 7.56634615 -0.51171875 9.76171875 C-1.00285156 10.17035156 -1.49398437 10.57898438 -2 11 C-1.85892253 9.54119891 -1.71197585 8.08296449 -1.5625 6.625 C-1.48128906 5.81289063 -1.40007813 5.00078125 -1.31640625 4.1640625 C-1 2 -1 2 0 0 Z ",
    fill: "#0F1010",
    transform: "translate(779,491)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.29296875 6.0546875 1.29296875 6.0546875 1 8 C0.01 8.66 -0.98 9.32 -2 10 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#101111",
    transform: "translate(784,471)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.97 1 5.94 1 9 C0.34 9 -0.32 9 -1 9 C-1.33 9.66 -1.66 10.32 -2 11 C-1.125 3.375 -1.125 3.375 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(328,459)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.37211538 6.57403846 1.37211538 6.57403846 -0.51171875 8.73046875 C-1.00285156 9.14941406 -1.49398438 9.56835938 -2 10 C-1.85950482 8.52031676 -1.71245174 7.04125484 -1.5625 5.5625 C-1.48128906 4.73878906 -1.40007812 3.91507812 -1.31640625 3.06640625 C-1 1 -1 1 0 0 Z ",
    fill: "#111111",
    transform: "translate(331,448)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1 3 -1 3 -4 5 C-6.6875 5.125 -6.6875 5.125 -9 5 C-2.87096774 0 -2.87096774 0 0 0 Z ",
    fill: "#171717",
    transform: "translate(424,444)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.99324263 1.0975223 3.84610901 1.67682892 5.25 4.625 C5.4975 5.40875 5.745 6.1925 6 7 C5.01 7 4.02 7 3 7 C1.79371992 4.66785852 0.8345262 2.50357861 0 0 Z ",
    fill: "#121314",
    transform: "translate(374,433)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C0.69 2.65 -1.62 4.3 -4 6 C-4.66 5.67 -5.32 5.34 -6 5 C-2.25 1.125 -2.25 1.125 0 0 Z ",
    fill: "#111111",
    transform: "translate(410,433)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.39763185 2.39763185 2.34280586 3.33273498 2.625 6.625 C2.69976563 7.44226563 2.77453125 8.25953125 2.8515625 9.1015625 C2.90054688 9.72804688 2.94953125 10.35453125 3 11 C2.67 10.01 2.34 9.02 2 8 C1.34 8 0.68 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#111111",
    transform: "translate(801,425)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88590407 1.45922693 0.75834456 2.91740598 0.625 4.375 C0.55539062 5.18710937 0.48578125 5.99921875 0.4140625 6.8359375 C0 9 0 9 -2 11 C-2.28571429 3.57142857 -2.28571429 3.57142857 0 0 Z ",
    fill: "#0D0D0D",
    transform: "translate(446,406)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.88590407 1.45922693 0.75834456 2.91740598 0.625 4.375 C0.55539062 5.18710937 0.48578125 5.99921875 0.4140625 6.8359375 C0 9 0 9 -2 11 C-2.28571429 3.57142857 -2.28571429 3.57142857 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(314,368)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.15546298 3.23319447 2.68074747 5.16896958 3 9 C2.34 9.99 1.68 10.98 1 12 C-0.3271261 8.0186217 -0.06915913 4.14954773 0 0 Z ",
    fill: "#161617",
    transform: "translate(455,360)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.22265625 3.7265625 0.22265625 3.7265625 -0.9375 5.625 C-1.618125 6.73875 -2.29875 7.8525 -3 9 C-3.89674777 6.48910624 -4.13172674 5.35464891 -3.1875 2.8125 C-2 1 -2 1 0 0 Z ",
    fill: "#131313",
    transform: "translate(217,353)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.2542015 2.83430453 4.5206753 4.68607774 5 9 C4.34 9 3.68 9 3 9 C0 3.375 0 3.375 0 0 Z ",
    fill: "#121313",
    transform: "translate(769,348)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 -0.4375 6.1875 C-1.2109375 7.5796875 -1.2109375 7.5796875 -2 9 C-2.33 9 -2.66 9 -3 9 C-2.4140625 2.84765625 -2.4140625 2.84765625 -2 1 C-1.34 0.67 -0.68 0.34 0 0 Z ",
    fill: "#111112",
    transform: "translate(530,298)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C4.38671875 1.53125 4.38671875 1.53125 5.6875 3.5 C6.12449219 4.1496875 6.56148437 4.799375 7.01171875 5.46875 C7.33785156 5.9740625 7.66398438 6.479375 8 7 C7.01 7 6.02 7 5 7 C3.61328125 5.46875 3.61328125 5.46875 2.3125 3.5 C1.87550781 2.8503125 1.43851563 2.200625 0.98828125 1.53125 C0.49908203 0.77328125 0.49908203 0.77328125 0 0 Z ",
    fill: "#141414",
    transform: "translate(734,284)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C2.22080679 5.37154989 2.22080679 5.37154989 1.1875 8.3125 C0 10 0 10 -2 11 C-1.34 7.37 -0.68 3.74 0 0 Z ",
    fill: "#262627",
    transform: "translate(491,264)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.39763185 2.39763185 2.34280586 3.33273498 2.625 6.625 C2.69976562 7.44226563 2.77453125 8.25953125 2.8515625 9.1015625 C2.90054687 9.72804688 2.94953125 10.35453125 3 11 C2.67 10.01 2.34 9.02 2 8 C1.34 8 0.68 8 0 8 C0 5.36 0 2.72 0 0 Z ",
    fill: "#0E0E0F",
    transform: "translate(433,260)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.875 4.75 4.875 4.75 6 7 C4.35 6.67 2.7 6.34 1 6 C0.67 4.02 0.34 2.04 0 0 Z ",
    fill: "#151515",
    transform: "translate(356,259)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.65 0 3.3 0 5 0 C6.0625 1.8125 6.0625 1.8125 7 4 C6.67 4.99 6.34 5.98 6 7 C5.34 5.35 4.68 3.7 4 2 C2.68 2 1.36 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#101010",
    transform: "translate(339,229)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 0.33 0 0.66 0 1 C-4.51617599 1.07654536 -8.59085217 1.10228696 -13 0 C-13 -0.33 -13 -0.66 -13 -1 C-8.15507803 -2.51403812 -4.7408989 -1.36602172 0 0 Z ",
    fill: "#353535",
    transform: "translate(312,736)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 4.25 2.8125 C5.11637742 5.33943414 4.88492145 6.52221994 4 9 C4 8.34 4 7.68 4 7 C3.34 7 2.68 7 2 7 C1.34 4.69 0.68 2.38 0 0 Z ",
    fill: "#161718",
    transform: "translate(552,721)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6.33 1.32 6.66 2.64 7 4 C5.02 4 3.04 4 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#373737",
    transform: "translate(607,724)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.36591866 1.44253657 5.51047079 3.33264727 8 6 C5.21788056 5.62403791 3.4120716 5.32681541 1.1875 3.5625 C0 2 0 2 0 0 Z ",
    fill: "#131313",
    transform: "translate(284,725)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.64 0 5.28 0 8 0 C6.8125 1.5625 6.8125 1.5625 5 3 C2.3125 2.6875 2.3125 2.6875 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#272728",
    transform: "translate(259,703)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.6875 1.6875 0.6875 1.6875 1 4 C-0.3125 6.75 -0.3125 6.75 -2 9 C-2.66 9 -3.32 9 -4 9 C-2.80100302 5.9168649 -1.52299523 2.93720508 0 0 Z ",
    fill: "#171817",
    transform: "translate(778,655)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 4.25 2.8125 C5.11637742 5.33943414 4.88492145 6.52221994 4 9 C0 2.25 0 2.25 0 0 Z ",
    fill: "#121312",
    transform: "translate(224,633)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.67 2.64 0.34 5.28 0 8 C-0.99 8.33 -1.98 8.66 -3 9 C-2.01 6.03 -1.02 3.06 0 0 Z ",
    fill: "#121212",
    transform: "translate(804,599)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-2 2 -2 2 -3.9453125 2.1953125 C-5.96354167 2.13020833 -7.98177083 2.06510417 -10 2 C-6.86358686 -1.13641314 -4.14410883 -1.38136961 0 0 Z ",
    fill: "#0F0F0F",
    transform: "translate(632,592)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.556875 0.226875 1.11375 0.45375 1.6875 0.6875 C-2.74326923 3.76442308 -2.74326923 3.76442308 -5.625 3.375 C-6.4603125 3.0346875 -6.4603125 3.0346875 -7.3125 2.6875 C-2.88173077 -0.38942308 -2.88173077 -0.38942308 0 0 Z ",
    fill: "#181818",
    transform: "translate(556.3125,548.3125)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 0.99 -0.66 1.98 -1 3 C-3.0625 3.6875 -3.0625 3.6875 -5 4 C-5 3.34 -5 2.68 -5 2 C-5.66 1.67 -6.32 1.34 -7 1 C-3.375 -1.125 -3.375 -1.125 0 0 Z ",
    fill: "#252627",
    transform: "translate(563,546)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.3828125 -0.29296875 2.3828125 -0.29296875 5.125 -0.1875 C6.03507813 -0.16042969 6.94515625 -0.13335938 7.8828125 -0.10546875 C8.58148437 -0.07066406 9.28015625 -0.03585937 10 0 C10 0.33 10 0.66 10 1 C6.04 1.66 2.08 2.32 -2 3 C-1.34 2.01 -0.68 1.02 0 0 Z ",
    fill: "#0D0D0D",
    transform: "translate(683,544)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.37211538 6.57403846 1.37211538 6.57403846 -0.51171875 8.73046875 C-1.00285156 9.14941406 -1.49398437 9.56835938 -2 10 C-1.85950482 8.52031676 -1.71245174 7.04125484 -1.5625 5.5625 C-1.48128906 4.73878906 -1.40007813 3.91507812 -1.31640625 3.06640625 C-1 1 -1 1 0 0 Z ",
    fill: "#0C0D0D",
    transform: "translate(523,499)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.66 3.63 2.32 7.26 3 11 C1.68 10.34 0.36 9.68 -1 9 C-0.67 6.03 -0.34 3.06 0 0 Z ",
    fill: "#262726",
    transform: "translate(254,492)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C2.1875 3.3125 2.1875 3.3125 2 6 C1.01 6.99 0.02 7.98 -1 9 C-0.67 6.03 -0.34 3.06 0 0 Z ",
    fill: "#121312",
    transform: "translate(786,461)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C0.67 3.3 0.34 6.6 0 10 C-0.66 9.67 -1.32 9.34 -2 9 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#0E0E0F",
    transform: "translate(438,441)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 3 1 3 -0.3125 5.6875 C-0.869375 6.450625 -1.42625 7.21375 -2 8 C-2.66 8 -3.32 8 -4 8 C-2.25 2.25 -2.25 2.25 0 0 Z ",
    fill: "#101010",
    transform: "translate(542,434)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.1953125 6.0546875 1.1953125 6.0546875 1 8 C0.34 8.66 -0.32 9.32 -1 10 C-2.31223496 6.06329512 -1.24296256 3.87511856 0 0 Z ",
    fill: "#0E0E0E",
    transform: "translate(501,338)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.5625 1.125 1.5625 1.125 3 3 C2.6875 6.1875 2.6875 6.1875 2 9 C1.67 8.01 1.34 7.02 1 6 C0.34 6 -0.32 6 -1 6 C-0.67 4.02 -0.34 2.04 0 0 Z ",
    fill: "#232526",
    transform: "translate(625,312)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.24208567 0.35049575 4.61527704 0.56221181 6.8125 3.0625 C7.204375 3.701875 7.59625 4.34125 8 5 C5 5 5 5 2.3125 2.5 C1.549375 1.675 0.78625 0.85 0 0 Z ",
    fill: "#171717",
    transform: "translate(618,256)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-0.33 3.63 -0.66 7.26 -1 11 C-1.33 11 -1.66 11 -2 11 C-2.33 7.7 -2.66 4.4 -3 1 C-1 0 -1 0 0 0 Z ",
    fill: "#242424",
    transform: "translate(378,237)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 5.75 3.5625 C6.1625 4.366875 6.575 5.17125 7 6 C6.01 6.495 6.01 6.495 5 7 C3.35 4.69 1.7 2.38 0 0 Z ",
    fill: "#171817",
    transform: "translate(408,756)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.29296875 6.0546875 1.29296875 6.0546875 1 8 C0.01 8.66 -0.98 9.32 -2 10 C-1.34 6.7 -0.68 3.4 0 0 Z ",
    fill: "#101111",
    transform: "translate(359,686)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.16115776 1.36983503 3.9927092 1.9890638 6 5 C5.67 5.99 5.34 6.98 5 8 C0 2.25 0 2.25 0 0 Z ",
    fill: "#111312",
    transform: "translate(248,672)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C0.75023244 3.65316671 0.32901247 4.78065836 -3 7 C-2.25 2.25 -2.25 2.25 0 0 Z ",
    fill: "#151616",
    transform: "translate(755,670)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C-0.98 4.97 -0.98 4.97 -3 8 C-3.75 6.25 -3.75 6.25 -4 4 C-2.0625 1.75 -2.0625 1.75 0 0 Z ",
    fill: "#111111",
    transform: "translate(763,659)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.50168276 3.68754757 0.89932357 5.60490662 -2 8 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#141414",
    transform: "translate(776,634)"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.29296875 6.0546875 1.29296875 6.0546875 1 8 C0.01 8.66 -0.98 9.32 -2 10 C-1.34 6.7 -0.68 3.4 0 0 Z ",
    fill: "#101010",
    transform: "translate(496,603)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.31223496 3.93670488 0.24296256 6.12488144 -1 10 C-1.33 10 -1.66 10 -2 10 C-2.1953125 3.9453125 -2.1953125 3.9453125 -2 2 C-1.34 1.34 -0.68 0.68 0 0 Z ",
    fill: "#0D0D0E",
    transform: "translate(374,475)"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.33 2.97 1.66 5.94 2 9 C1.01 9 0.02 9 -1 9 C-2.25541557 5.23375329 -1.37061958 3.62811066 0 0 Z ",
    fill: "#282929",
    transform: "translate(298,434)"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.1875 3.375 1.1875 3.375 1 7 C0.01 7.66 -0.98 8.32 -2 9 C-1.125 2.25 -1.125 2.25 0 0 Z ",
    fill: "#0F0F0F",
    transform: "translate(405,418)"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 2.97 1.34 5.94 1 9 C-1.08954032 4.82091936 -1.16552619 4.19589427 0 0 Z ",
    fill: "#252626",
    transform: "translate(480,403)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1.29296875 6.0546875 1.29296875 6.0546875 1 8 C0.01 8.66 -0.98 9.32 -2 10 C-1.34 6.7 -0.68 3.4 0 0 Z ",
    fill: "#101010",
    transform: "translate(504,326)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.34 3.31 1.68 5.62 1 8 C0.34 7.34 -0.32 6.68 -1 6 C-0.625 2.875 -0.625 2.875 0 0 Z ",
    fill: "#0E0E0F",
    transform: "translate(599,289)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C1.68 3.31 0.36 5.62 -1 8 C-1.93065133 5.39417629 -2.14917407 4.35801776 -1.0625 1.75 C-0.711875 1.1725 -0.36125 0.595 0 0 Z ",
    fill: "#111212",
    transform: "translate(538,281)"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C-1.15173355 2.46800047 -2.04783565 4.04783565 -4 6 C-4.99 5.67 -5.98 5.34 -7 5 C-2.25 0 -2.25 0 0 0 Z ",
    fill: "#151516",
    transform: "translate(296,272)"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4.75 0.875 4.75 0.875 7 2 C6.67 2.99 6.34 3.98 6 5 C3.98079663 3.69593116 1.98075027 2.36176581 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#151515",
    transform: "translate(662,229)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0.33 5.94 0.66 9 1 C5.00889681 2.9955516 3.30013434 3.19546065 -1 3 C-0.67 2.01 -0.34 1.02 0 0 Z ",
    fill: "#282828",
    transform: "translate(576,198)"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.32 0.66 2.64 1.32 4 2 C2.35 3.32 0.7 4.64 -1 6 C-1.66 5.67 -2.32 5.34 -3 5 C-2.01 3.35 -1.02 1.7 0 0 Z ",
    fill: "#161616",
    transform: "translate(384,192)"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 3.96 1 7.92 1 12 C0.67 12 0.34 12 0 12 C0 8.04 0 4.08 0 0 Z ",
    fill: "#2F3031",
    transform: "translate(515,740)"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.63 0 7.26 0 11 0 C11 0.33 11 0.66 11 1 C7.37 1 3.74 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#303131",
    transform: "translate(462,400)"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.97 0 5.94 0 9 0 C9 0.33 9 0.66 9 1 C6.03 1 3.06 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#343334",
    transform: "translate(624,527)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 2.31 1 4.62 1 7 C0.67 7 0.34 7 0 7 C0 4.69 0 2.38 0 0 Z ",
    fill: "#303131",
    transform: "translate(515,732)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#363636",
    transform: "translate(628,703)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.0625 4.125 0.0625 4.125 -1 6 C-1.042721 4.33388095 -1.04063832 2.66617115 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#393739",
    transform: "translate(801,559)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2.31 0 4.62 0 7 0 C7 0.33 7 0.66 7 1 C4.69 1 2.38 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#303130",
    transform: "translate(654,400)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.99 1.34 2.98 1 4 C0.67 2.68 0.34 1.36 0 0 Z ",
    fill: "#343434",
    transform: "translate(376,783)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 2 2 2 2 4 C1.34 4 0.68 4 0 4 C0 2.68 0 1.36 0 0 Z ",
    fill: "#343434",
    transform: "translate(433,737)"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#363636",
    transform: "translate(621,703)"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.98 1 3.96 1 6 C0.67 6 0.34 6 0 6 C0 4.02 0 2.04 0 0 Z ",
    fill: "#333333",
    transform: "translate(625,632)"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.67 2.99 1.34 3.98 1 5 C0.67 3.35 0.34 1.7 0 0 Z ",
    fill: "#303030",
    transform: "translate(345,564)"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.34 2.32 0.68 3.64 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#333434",
    transform: "translate(352,439)"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#303031",
    transform: "translate(647,400)"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0 3.96 0 6 0 C6 0.33 6 0.66 6 1 C4.02 1 2.04 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#2F2E2F",
    transform: "translate(388,375)"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.34 2.67 0.68 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#383839",
    transform: "translate(661,245)"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.67 1.66 2.34 2.32 2 3 C1.34 2.67 0.68 2.34 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#343535",
    transform: "translate(432,770)"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1.33 1.02 1.66 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#303131",
    transform: "translate(400,769)"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#303132",
    transform: "translate(515,765)"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0 0.66 0 1 0 C1 1.65 1 3.3 1 5 C0.67 5 0.34 5 0 5 C0 3.35 0 1.7 0 0 Z ",
    fill: "#323232",
    transform: "translate(559,730)"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.98 0.99 1.98 0.99 4 2 C2.68 1.67 1.36 1.34 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#333334",
    transform: "translate(408,667)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#323132",
    transform: "translate(618,597)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1.485 0.99 1.485 0.99 3 2 C1.68 1.67 0.36 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#383738",
    transform: "translate(601,200)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#363736",
    transform: "translate(481,797)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0 1.98 0 3 0 C2.67 0.66 2.34 1.32 2 2 C1.34 1.34 0.68 0.68 0 0 Z ",
    fill: "#353635",
    transform: "translate(393,797)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.99 1.34 1.98 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#353535",
    transform: "translate(432,792)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.34 2.67 -0.32 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#333333",
    transform: "translate(465,776)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#333332",
    transform: "translate(564,755)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#323333",
    transform: "translate(564,750)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.33 1.32 0.66 2 1 C1.01 1 0.02 1 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#353636",
    transform: "translate(646,713)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#373737",
    transform: "translate(616,703)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#343435",
    transform: "translate(645,671)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.67 1.66 1.34 2.32 1 3 C0.67 2.01 0.34 1.02 0 0 Z ",
    fill: "#3B3A3B",
    transform: "translate(208,632)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#323232",
    transform: "translate(586,611)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.34 1.66 0.68 2.32 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#303131",
    transform: "translate(464,591)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.34 2.67 -0.32 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#323133",
    transform: "translate(473,568)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#323032",
    transform: "translate(488,481)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#333233",
    transform: "translate(554,482)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 1.485 0.99 1.485 2 3 C1.34 3 0.68 3 0 3 C0 2.01 0 1.02 0 0 Z ",
    fill: "#323132",
    transform: "translate(400,481)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0 3 0 3 0 3 Z ",
    fill: "#323232",
    transform: "translate(433,449)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.33 1.98 0.66 3 1 C2.01 1 1.02 1 0 1 C0 0.67 0 0.34 0 0 Z ",
    fill: "#343434",
    transform: "translate(377,432)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.34 2.67 -0.32 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#313132",
    transform: "translate(297,430)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C4 1 4 1 4 1 Z ",
    fill: "#323132",
    transform: "translate(454,400)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#313132",
    transform: "translate(480,304)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C1 4 1 4 1 4 Z ",
    fill: "#303031",
    transform: "translate(489,264)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.99 0.66 1.98 1 3 C0.34 2.67 -0.32 2.34 -1 2 C-0.67 1.34 -0.34 0.68 0 0 Z ",
    fill: "#313232",
    transform: "translate(401,241)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#363636",
    transform: "translate(652,798)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313130",
    transform: "translate(0,0)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#323131",
    transform: "translate(658,765)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F31",
    transform: "translate(0,0)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#343434",
    transform: "translate(378,746)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0 1.32 0 2 0 C1.67 0.66 1.34 1.32 1 2 C0.67 1.34 0.34 0.68 0 0 Z ",
    fill: "#313233",
    transform: "translate(465,739)"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313131",
    transform: "translate(0,0)"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303133",
    transform: "translate(0,0)"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#343433",
    transform: "translate(451,727)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#313231",
    transform: "translate(428,727)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303032",
    transform: "translate(0,0)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#343435",
    transform: "translate(482,712)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#363637",
    transform: "translate(741,671)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#353333",
    transform: "translate(307,671)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#353435",
    transform: "translate(282,669)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#333434",
    transform: "translate(517,663)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#343333",
    transform: "translate(512,659)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2F30",
    transform: "translate(0,0)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323133",
    transform: "translate(0,0)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303030",
    transform: "translate(0,0)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#2F3130",
    transform: "translate(428,552)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.66 0.66 1.32 1.32 2 2 C1.34 2 0.68 2 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#323433",
    transform: "translate(432,544)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#333334",
    transform: "translate(495,527)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#343333",
    transform: "translate(435,527)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#313032",
    transform: "translate(428,527)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#343333",
    transform: "translate(423,527)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#343334",
    transform: "translate(300,527)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#343334",
    transform: "translate(376,501)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313131",
    transform: "translate(0,0)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3A3A",
    transform: "translate(0,0)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#313232",
    transform: "translate(640,400)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#323332",
    transform: "translate(581,400)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#323233",
    transform: "translate(517,400)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#2F2F30",
    transform: "translate(476,400)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#333231",
    transform: "translate(570,353)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#3D3C3C",
    transform: "translate(216,347)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F30",
    transform: "translate(0,0)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.33 0.66 0.66 1.32 1 2 C0.34 1.67 -0.32 1.34 -1 1 C-0.67 0.67 -0.34 0.34 0 0 Z ",
    fill: "#3E3B3C",
    transform: "translate(761,340)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#312F32",
    transform: "translate(0,0)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C0.99 0.495 0.99 0.495 2 1 C1.01 1.495 1.01 1.495 0 2 C0 1.34 0 0.68 0 0 Z ",
    fill: "#3B3B3A",
    transform: "translate(729,300)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3 1 3 1 3 1 Z ",
    fill: "#3C3D3C",
    transform: "translate(323,233)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363437",
    transform: "translate(0,0)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#353534",
    transform: "translate(536,797)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#313132",
    transform: "translate(489,797)"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343433",
    transform: "translate(0,0)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373837",
    transform: "translate(0,0)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323434",
    transform: "translate(0,0)"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353637",
    transform: "translate(0,0)"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303231",
    transform: "translate(0,0)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343435",
    transform: "translate(401,779)"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323335",
    transform: "translate(0,0)"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323133",
    transform: "translate(0,0)"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313131",
    transform: "translate(0,0)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343433",
    transform: "translate(387,769)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323433",
    transform: "translate(0,0)"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323133",
    transform: "translate(0,0)"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343434",
    transform: "translate(399,767)"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323133",
    transform: "translate(392,761)"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333234",
    transform: "translate(386,757)"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343534",
    transform: "translate(0,0)"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333433",
    transform: "translate(433,755)"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F30",
    transform: "translate(0,0)"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333433",
    transform: "translate(433,747)"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333435",
    transform: "translate(464,746)"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333434",
    transform: "translate(398,744)"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353436",
    transform: "translate(0,0)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303332",
    transform: "translate(0,0)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3B3B39",
    transform: "translate(704,735)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#393736",
    transform: "translate(324,735)"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#383938",
    transform: "translate(293,735)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323133",
    transform: "translate(0,0)"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#313132",
    transform: "translate(537,727)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313131",
    transform: "translate(0,0)"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343334",
    transform: "translate(455,727)"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373737",
    transform: "translate(0,0)"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#353537",
    transform: "translate(641,713)"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333233",
    transform: "translate(667,712)"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363738",
    transform: "translate(648,712)"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#353436",
    transform: "translate(600,712)"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#303030",
    transform: "translate(406,712)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3D",
    transform: "translate(0,0)"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#383738",
    transform: "translate(640,703)"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393739",
    transform: "translate(0,0)"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3C3D",
    transform: "translate(0,0)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363635",
    transform: "translate(677,671)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363536",
    transform: "translate(0,0)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#383839",
    transform: "translate(752,669)"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353535",
    transform: "translate(0,0)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3D3D",
    transform: "translate(0,0)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363535",
    transform: "translate(764,649)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353536",
    transform: "translate(0,0)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333432",
    transform: "translate(0,0)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323132",
    transform: "translate(384,642)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3031",
    transform: "translate(0,0)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323133",
    transform: "translate(690,640)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#303131",
    transform: "translate(696,636)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343634",
    transform: "translate(0,0)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3B3C",
    transform: "translate(0,0)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3032",
    transform: "translate(0,0)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323230",
    transform: "translate(0,0)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393939",
    transform: "translate(0,0)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3D",
    transform: "translate(0,0)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3D3D",
    transform: "translate(0,0)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3A",
    transform: "translate(0,0)"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323333",
    transform: "translate(632,577)"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333333",
    transform: "translate(565,575)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363434",
    transform: "translate(0,0)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#404041",
    transform: "translate(185,568)"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323232",
    transform: "translate(528,560)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333333",
    transform: "translate(539,553)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333436",
    transform: "translate(663,552)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323232",
    transform: "translate(675,545)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333334",
    transform: "translate(440,545)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333133",
    transform: "translate(315,544)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343233",
    transform: "translate(580,540)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323231",
    transform: "translate(466,540)"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#313232",
    transform: "translate(716,527)"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343333",
    transform: "translate(615,527)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343434",
    transform: "translate(503,527)"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323132",
    transform: "translate(492,527)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333433",
    transform: "translate(487,527)"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323332",
    transform: "translate(561,523)"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3A",
    transform: "translate(0,0)"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333231",
    transform: "translate(0,0)"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313131",
    transform: "translate(0,0)"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303133",
    transform: "translate(0,0)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353436",
    transform: "translate(0,0)"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363636",
    transform: "translate(0,0)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3C3E",
    transform: "translate(0,0)"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343436",
    transform: "translate(385,501)"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333235",
    transform: "translate(0,0)"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323131",
    transform: "translate(0,0)"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#313030",
    transform: "translate(350,487)"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F31",
    transform: "translate(0,0)"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323131",
    transform: "translate(0,0)"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383839",
    transform: "translate(0,0)"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333534",
    transform: "translate(0,0)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3C3C",
    transform: "translate(0,0)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323032",
    transform: "translate(406,456)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323233",
    transform: "translate(363,456)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333234",
    transform: "translate(0,0)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383838",
    transform: "translate(0,0)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323134",
    transform: "translate(0,0)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323433",
    transform: "translate(432,442)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3B",
    transform: "translate(0,0)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393838",
    transform: "translate(0,0)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2E2E",
    transform: "translate(0,0)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#303132",
    transform: "translate(688,431)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313131",
    transform: "translate(0,0)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2E2D2D",
    transform: "translate(558,426)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343333",
    transform: "translate(283,423)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3C",
    transform: "translate(0,0)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353434",
    transform: "translate(0,0)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363535",
    transform: "translate(251,409)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323231",
    transform: "translate(495,402)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333134",
    transform: "translate(0,0)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333435",
    transform: "translate(269,401)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323232",
    transform: "translate(694,400)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#313031",
    transform: "translate(668,400)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2E2E2F",
    transform: "translate(502,400)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#313232",
    transform: "translate(496,400)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343134",
    transform: "translate(493,400)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323231",
    transform: "translate(451,400)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343434",
    transform: "translate(396,400)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333333",
    transform: "translate(393,400)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323434",
    transform: "translate(0,0)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3939",
    transform: "translate(0,0)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363738",
    transform: "translate(0,0)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3C",
    transform: "translate(0,0)"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#333332",
    transform: "translate(561,380)"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323235",
    transform: "translate(406,372)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B38",
    transform: "translate(0,0)"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373637",
    transform: "translate(0,0)"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#343535",
    transform: "translate(576,352)"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3C3C",
    transform: "translate(0,0)"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A393A",
    transform: "translate(0,0)"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3B3B",
    transform: "translate(0,0)"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313231",
    transform: "translate(0,0)"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F2F",
    transform: "translate(0,0)"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3939",
    transform: "translate(0,0)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343233",
    transform: "translate(0,0)"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383737",
    transform: "translate(0,0)"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363536",
    transform: "translate(642,301)"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3031",
    transform: "translate(0,0)"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323232",
    transform: "translate(634,285)"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F31",
    transform: "translate(0,0)"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3C3A3B",
    transform: "translate(707,278)"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363736",
    transform: "translate(662,274)"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#353738",
    transform: "translate(543,272)"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303030",
    transform: "translate(0,0)"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323231",
    transform: "translate(374,271)"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3C3B3D",
    transform: "translate(697,270)"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#2F2F2E",
    transform: "translate(597,267)"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#323233",
    transform: "translate(544,266)"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3B3B3B",
    transform: "translate(684,263)"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#3C3C3A",
    transform: "translate(310,263)"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333133",
    transform: "translate(0,0)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#303132",
    transform: "translate(606,248)"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#373537",
    transform: "translate(633,231)"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373837",
    transform: "translate(0,0)"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363537",
    transform: "translate(613,223)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363637",
    transform: "translate(611,222)"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#363736",
    transform: "translate(601,219)"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#373837",
    transform: "translate(561,211)"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#38383A",
    transform: "translate(0,0)"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C2 1 2 1 2 1 Z ",
    fill: "#353534",
    transform: "translate(428,177)"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363736",
    transform: "translate(0,0)"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3A",
    transform: "translate(0,0)"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353636",
    transform: "translate(0,0)"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363634",
    transform: "translate(0,0)"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343733",
    transform: "translate(0,0)"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383537",
    transform: "translate(0,0)"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353735",
    transform: "translate(0,0)"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373736",
    transform: "translate(0,0)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363736",
    transform: "translate(0,0)"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363235",
    transform: "translate(0,0)"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363736",
    transform: "translate(0,0)"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373836",
    transform: "translate(0,0)"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373733",
    transform: "translate(0,0)"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353130",
    transform: "translate(0,0)"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373436",
    transform: "translate(0,0)"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383737",
    transform: "translate(0,0)"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373936",
    transform: "translate(0,0)"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363637",
    transform: "translate(0,0)"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373737",
    transform: "translate(0,0)"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383635",
    transform: "translate(0,0)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353434",
    transform: "translate(0,0)"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363436",
    transform: "translate(0,0)"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353536",
    transform: "translate(0,0)"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343232",
    transform: "translate(0,0)"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333432",
    transform: "translate(0,0)"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373637",
    transform: "translate(0,0)"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373637",
    transform: "translate(0,0)"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323131",
    transform: "translate(0,0)"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363535",
    transform: "translate(0,0)"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343535",
    transform: "translate(0,0)"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353536",
    transform: "translate(0,0)"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363838",
    transform: "translate(0,0)"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373839",
    transform: "translate(0,0)"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363836",
    transform: "translate(0,0)"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353436",
    transform: "translate(0,0)"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313434",
    transform: "translate(0,0)"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363639",
    transform: "translate(0,0)"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343234",
    transform: "translate(0,0)"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333033",
    transform: "translate(0,0)"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343235",
    transform: "translate(0,0)"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363736",
    transform: "translate(0,0)"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323435",
    transform: "translate(0,0)"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353737",
    transform: "translate(0,0)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353534",
    transform: "translate(0,0)"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333433",
    transform: "translate(0,0)"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303231",
    transform: "translate(0,0)"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313234",
    transform: "translate(0,0)"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363236",
    transform: "translate(0,0)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333335",
    transform: "translate(0,0)"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3232",
    transform: "translate(0,0)"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353636",
    transform: "translate(0,0)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353634",
    transform: "translate(0,0)"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333536",
    transform: "translate(0,0)"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353534",
    transform: "translate(0,0)"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343534",
    transform: "translate(0,0)"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363337",
    transform: "translate(0,0)"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373835",
    transform: "translate(0,0)"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333335",
    transform: "translate(0,0)"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353638",
    transform: "translate(0,0)"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353634",
    transform: "translate(0,0)"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353735",
    transform: "translate(0,0)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353436",
    transform: "translate(0,0)"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323234",
    transform: "translate(0,0)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353333",
    transform: "translate(0,0)"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353536",
    transform: "translate(0,0)"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353536",
    transform: "translate(0,0)"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3230",
    transform: "translate(0,0)"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333433",
    transform: "translate(0,0)"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313234",
    transform: "translate(0,0)"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313334",
    transform: "translate(0,0)"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343436",
    transform: "translate(0,0)"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#322F31",
    transform: "translate(0,0)"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353735",
    transform: "translate(0,0)"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333533",
    transform: "translate(0,0)"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303232",
    transform: "translate(0,0)"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353635",
    transform: "translate(0,0)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323535",
    transform: "translate(0,0)"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343634",
    transform: "translate(0,0)"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323433",
    transform: "translate(0,0)"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333436",
    transform: "translate(0,0)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333234",
    transform: "translate(0,0)"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353234",
    transform: "translate(0,0)"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393939",
    transform: "translate(0,0)"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333335",
    transform: "translate(0,0)"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313230",
    transform: "translate(0,0)"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333534",
    transform: "translate(0,0)"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353436",
    transform: "translate(0,0)"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333132",
    transform: "translate(0,0)"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323234",
    transform: "translate(0,0)"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333435",
    transform: "translate(0,0)"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313333",
    transform: "translate(0,0)"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343532",
    transform: "translate(0,0)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343432",
    transform: "translate(0,0)"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393A3B",
    transform: "translate(0,0)"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343533",
    transform: "translate(0,0)"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353533",
    transform: "translate(0,0)"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343233",
    transform: "translate(0,0)"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3C",
    transform: "translate(0,0)"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313033",
    transform: "translate(0,0)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353534",
    transform: "translate(0,0)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3E3D",
    transform: "translate(0,0)"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343234",
    transform: "translate(0,0)"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353335",
    transform: "translate(0,0)"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3032",
    transform: "translate(0,0)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373635",
    transform: "translate(0,0)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383839",
    transform: "translate(0,0)"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323331",
    transform: "translate(0,0)"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323435",
    transform: "translate(0,0)"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303232",
    transform: "translate(0,0)"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A39",
    transform: "translate(0,0)"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363538",
    transform: "translate(0,0)"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323335",
    transform: "translate(0,0)"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393937",
    transform: "translate(0,0)"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323433",
    transform: "translate(0,0)"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393A38",
    transform: "translate(0,0)"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3B",
    transform: "translate(0,0)"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#39373A",
    transform: "translate(0,0)"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303130",
    transform: "translate(0,0)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323030",
    transform: "translate(0,0)"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383939",
    transform: "translate(0,0)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343232",
    transform: "translate(0,0)"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3A38",
    transform: "translate(0,0)"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333336",
    transform: "translate(0,0)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383837",
    transform: "translate(0,0)"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363635",
    transform: "translate(0,0)"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353635",
    transform: "translate(0,0)"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353334",
    transform: "translate(0,0)"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323135",
    transform: "translate(0,0)"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343633",
    transform: "translate(0,0)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353535",
    transform: "translate(0,0)"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333132",
    transform: "translate(0,0)"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353535",
    transform: "translate(0,0)"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343535",
    transform: "translate(0,0)"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343533",
    transform: "translate(0,0)"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343234",
    transform: "translate(0,0)"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333135",
    transform: "translate(0,0)"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F2E",
    transform: "translate(0,0)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323032",
    transform: "translate(0,0)"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3031",
    transform: "translate(0,0)"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333436",
    transform: "translate(0,0)"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3C3D",
    transform: "translate(0,0)"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393B3A",
    transform: "translate(0,0)"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3A",
    transform: "translate(0,0)"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353435",
    transform: "translate(0,0)"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3C",
    transform: "translate(0,0)"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3D39",
    transform: "translate(0,0)"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A393C",
    transform: "translate(0,0)"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343534",
    transform: "translate(0,0)"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3A39",
    transform: "translate(0,0)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373737",
    transform: "translate(0,0)"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363836",
    transform: "translate(0,0)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363837",
    transform: "translate(0,0)"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353336",
    transform: "translate(0,0)"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353536",
    transform: "translate(0,0)"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B393B",
    transform: "translate(0,0)"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B393C",
    transform: "translate(0,0)"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3B",
    transform: "translate(0,0)"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313334",
    transform: "translate(0,0)"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3A",
    transform: "translate(0,0)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383436",
    transform: "translate(0,0)"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333533",
    transform: "translate(0,0)"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353533",
    transform: "translate(0,0)"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3D39",
    transform: "translate(0,0)"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3C3C",
    transform: "translate(0,0)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353535",
    transform: "translate(0,0)"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353436",
    transform: "translate(0,0)"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3E3C",
    transform: "translate(0,0)"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3A",
    transform: "translate(0,0)"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B393A",
    transform: "translate(0,0)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323637",
    transform: "translate(0,0)"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3939",
    transform: "translate(0,0)"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3A3A",
    transform: "translate(0,0)"
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3D3C",
    transform: "translate(0,0)"
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373536",
    transform: "translate(0,0)"
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3D3E",
    transform: "translate(0,0)"
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383839",
    transform: "translate(0,0)"
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3133",
    transform: "translate(0,0)"
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333433",
    transform: "translate(0,0)"
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353635",
    transform: "translate(0,0)"
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393837",
    transform: "translate(0,0)"
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373536",
    transform: "translate(0,0)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363336",
    transform: "translate(0,0)"
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373636",
    transform: "translate(0,0)"
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383636",
    transform: "translate(0,0)"
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353638",
    transform: "translate(0,0)"
  })), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393838",
    transform: "translate(0,0)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353534",
    transform: "translate(0,0)"
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363435",
    transform: "translate(0,0)"
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323133",
    transform: "translate(0,0)"
  })), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3939",
    transform: "translate(0,0)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373837",
    transform: "translate(0,0)"
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3E3E",
    transform: "translate(0,0)"
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333535",
    transform: "translate(0,0)"
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353534",
    transform: "translate(0,0)"
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363437",
    transform: "translate(0,0)"
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3A",
    transform: "translate(0,0)"
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3E3F",
    transform: "translate(0,0)"
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363537",
    transform: "translate(0,0)"
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3A",
    transform: "translate(0,0)"
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3D",
    transform: "translate(0,0)"
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3939",
    transform: "translate(0,0)"
  })), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3E3D",
    transform: "translate(0,0)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353435",
    transform: "translate(0,0)"
  })), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323537",
    transform: "translate(0,0)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333534",
    transform: "translate(0,0)"
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343537",
    transform: "translate(0,0)"
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373737",
    transform: "translate(0,0)"
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333134",
    transform: "translate(0,0)"
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3F3F",
    transform: "translate(0,0)"
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333231",
    transform: "translate(0,0)"
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353737",
    transform: "translate(0,0)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313231",
    transform: "translate(0,0)"
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333235",
    transform: "translate(0,0)"
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353434",
    transform: "translate(0,0)"
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3D3D",
    transform: "translate(0,0)"
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3839",
    transform: "translate(0,0)"
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363435",
    transform: "translate(0,0)"
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3E3C",
    transform: "translate(0,0)"
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#403D3E",
    transform: "translate(0,0)"
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313134",
    transform: "translate(0,0)"
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393638",
    transform: "translate(0,0)"
  })), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#39393B",
    transform: "translate(0,0)"
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363537",
    transform: "translate(0,0)"
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333134",
    transform: "translate(0,0)"
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343534",
    transform: "translate(0,0)"
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363837",
    transform: "translate(0,0)"
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3D3A",
    transform: "translate(0,0)"
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323231",
    transform: "translate(0,0)"
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343534",
    transform: "translate(0,0)"
  })), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333133",
    transform: "translate(0,0)"
  })), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303432",
    transform: "translate(0,0)"
  })), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393A39",
    transform: "translate(0,0)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3B",
    transform: "translate(0,0)"
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313135",
    transform: "translate(0,0)"
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333134",
    transform: "translate(0,0)"
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353937",
    transform: "translate(0,0)"
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323331",
    transform: "translate(0,0)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3D3C",
    transform: "translate(0,0)"
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343436",
    transform: "translate(0,0)"
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333534",
    transform: "translate(0,0)"
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333234",
    transform: "translate(0,0)"
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303330",
    transform: "translate(0,0)"
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343634",
    transform: "translate(0,0)"
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#30312F",
    transform: "translate(0,0)"
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3C3C",
    transform: "translate(0,0)"
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2D2F",
    transform: "translate(0,0)"
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303133",
    transform: "translate(0,0)"
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2F30",
    transform: "translate(0,0)"
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3B",
    transform: "translate(0,0)"
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3E3C",
    transform: "translate(0,0)"
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333032",
    transform: "translate(0,0)"
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313331",
    transform: "translate(0,0)"
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333332",
    transform: "translate(0,0)"
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2E2E",
    transform: "translate(0,0)"
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353634",
    transform: "translate(0,0)"
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343232",
    transform: "translate(0,0)"
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303233",
    transform: "translate(0,0)"
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353434",
    transform: "translate(0,0)"
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393738",
    transform: "translate(0,0)"
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383837",
    transform: "translate(0,0)"
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333033",
    transform: "translate(0,0)"
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323032",
    transform: "translate(0,0)"
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383839",
    transform: "translate(0,0)"
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383836",
    transform: "translate(0,0)"
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373536",
    transform: "translate(0,0)"
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3C",
    transform: "translate(0,0)"
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#474748",
    transform: "translate(0,0)"
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333134",
    transform: "translate(0,0)"
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333734",
    transform: "translate(0,0)"
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353235",
    transform: "translate(0,0)"
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3A",
    transform: "translate(0,0)"
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3C3D",
    transform: "translate(0,0)"
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2E2F",
    transform: "translate(0,0)"
  })), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3132",
    transform: "translate(0,0)"
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3133",
    transform: "translate(0,0)"
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3230",
    transform: "translate(0,0)"
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#39393A",
    transform: "translate(0,0)"
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323336",
    transform: "translate(0,0)"
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323130",
    transform: "translate(0,0)"
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2E2F",
    transform: "translate(0,0)"
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323234",
    transform: "translate(0,0)"
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313234",
    transform: "translate(0,0)"
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373938",
    transform: "translate(0,0)"
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343538",
    transform: "translate(0,0)"
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2F2E",
    transform: "translate(0,0)"
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3134",
    transform: "translate(0,0)"
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3C3B",
    transform: "translate(0,0)"
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#31302E",
    transform: "translate(0,0)"
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343533",
    transform: "translate(0,0)"
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303230",
    transform: "translate(0,0)"
  })), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393839",
    transform: "translate(0,0)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2F31",
    transform: "translate(0,0)"
  })), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3C",
    transform: "translate(0,0)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#31302F",
    transform: "translate(0,0)"
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343332",
    transform: "translate(0,0)"
  })), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3E3E",
    transform: "translate(0,0)"
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3A",
    transform: "translate(0,0)"
  })), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323131",
    transform: "translate(0,0)"
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3030",
    transform: "translate(0,0)"
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363636",
    transform: "translate(0,0)"
  })), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3030",
    transform: "translate(0,0)"
  })), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353434",
    transform: "translate(0,0)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363536",
    transform: "translate(0,0)"
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353536",
    transform: "translate(0,0)"
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383737",
    transform: "translate(0,0)"
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373737",
    transform: "translate(0,0)"
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2D2F",
    transform: "translate(0,0)"
  })), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#30302F",
    transform: "translate(0,0)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333533",
    transform: "translate(0,0)"
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303231",
    transform: "translate(0,0)"
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313133",
    transform: "translate(0,0)"
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3B",
    transform: "translate(0,0)"
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313231",
    transform: "translate(0,0)"
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383737",
    transform: "translate(0,0)"
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333231",
    transform: "translate(0,0)"
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323131",
    transform: "translate(0,0)"
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D302E",
    transform: "translate(0,0)"
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3032",
    transform: "translate(0,0)"
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343437",
    transform: "translate(0,0)"
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A383A",
    transform: "translate(0,0)"
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302D2E",
    transform: "translate(0,0)"
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333133",
    transform: "translate(0,0)"
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323231",
    transform: "translate(0,0)"
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343535",
    transform: "translate(0,0)"
  })), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333133",
    transform: "translate(0,0)"
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333332",
    transform: "translate(0,0)"
  })), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323335",
    transform: "translate(0,0)"
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373637",
    transform: "translate(0,0)"
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#40403F",
    transform: "translate(0,0)"
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333031",
    transform: "translate(0,0)"
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313231",
    transform: "translate(0,0)"
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E302F",
    transform: "translate(0,0)"
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353334",
    transform: "translate(0,0)"
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F2D",
    transform: "translate(0,0)"
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#403F3F",
    transform: "translate(0,0)"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323032",
    transform: "translate(0,0)"
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323230",
    transform: "translate(0,0)"
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313334",
    transform: "translate(0,0)"
  })), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303030",
    transform: "translate(0,0)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F302F",
    transform: "translate(0,0)"
  })), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323234",
    transform: "translate(0,0)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3F3E",
    transform: "translate(0,0)"
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3D3C",
    transform: "translate(0,0)"
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383738",
    transform: "translate(0,0)"
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333430",
    transform: "translate(0,0)"
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333133",
    transform: "translate(0,0)"
  })), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353535",
    transform: "translate(0,0)"
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313030",
    transform: "translate(0,0)"
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343336",
    transform: "translate(0,0)"
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363535",
    transform: "translate(0,0)"
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3031",
    transform: "translate(0,0)"
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323535",
    transform: "translate(0,0)"
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313333",
    transform: "translate(0,0)"
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F2F",
    transform: "translate(0,0)"
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3C",
    transform: "translate(0,0)"
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393939",
    transform: "translate(0,0)"
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343332",
    transform: "translate(0,0)"
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313134",
    transform: "translate(0,0)"
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353634",
    transform: "translate(0,0)"
  })), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323031",
    transform: "translate(0,0)"
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313234",
    transform: "translate(0,0)"
  })), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313231",
    transform: "translate(0,0)"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F31",
    transform: "translate(0,0)"
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303133",
    transform: "translate(0,0)"
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353433",
    transform: "translate(0,0)"
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#403E3F",
    transform: "translate(0,0)"
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383637",
    transform: "translate(0,0)"
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363536",
    transform: "translate(0,0)"
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3C3C",
    transform: "translate(0,0)"
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303232",
    transform: "translate(0,0)"
  })), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333133",
    transform: "translate(0,0)"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353435",
    transform: "translate(0,0)"
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343634",
    transform: "translate(0,0)"
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333133",
    transform: "translate(0,0)"
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373637",
    transform: "translate(0,0)"
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323133",
    transform: "translate(0,0)"
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333131",
    transform: "translate(0,0)"
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313133",
    transform: "translate(0,0)"
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323435",
    transform: "translate(0,0)"
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333435",
    transform: "translate(0,0)"
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343433",
    transform: "translate(0,0)"
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343234",
    transform: "translate(0,0)"
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#332F32",
    transform: "translate(0,0)"
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353331",
    transform: "translate(0,0)"
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393C3C",
    transform: "translate(0,0)"
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353533",
    transform: "translate(0,0)"
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333432",
    transform: "translate(0,0)"
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343533",
    transform: "translate(0,0)"
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303230",
    transform: "translate(0,0)"
  })), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383839",
    transform: "translate(0,0)"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323133",
    transform: "translate(0,0)"
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303032",
    transform: "translate(0,0)"
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363535",
    transform: "translate(0,0)"
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343636",
    transform: "translate(0,0)"
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363937",
    transform: "translate(0,0)"
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343435",
    transform: "translate(0,0)"
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F312F",
    transform: "translate(0,0)"
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#322F30",
    transform: "translate(0,0)"
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343232",
    transform: "translate(0,0)"
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303130",
    transform: "translate(0,0)"
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2E2F",
    transform: "translate(0,0)"
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383839",
    transform: "translate(0,0)"
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363436",
    transform: "translate(0,0)"
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353435",
    transform: "translate(0,0)"
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313234",
    transform: "translate(0,0)"
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363737",
    transform: "translate(0,0)"
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353736",
    transform: "translate(0,0)"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343635",
    transform: "translate(0,0)"
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353435",
    transform: "translate(0,0)"
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303134",
    transform: "translate(0,0)"
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F31",
    transform: "translate(0,0)"
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363536",
    transform: "translate(0,0)"
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F30",
    transform: "translate(0,0)"
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323131",
    transform: "translate(0,0)"
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333130",
    transform: "translate(0,0)"
  })), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333432",
    transform: "translate(0,0)"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3D3C",
    transform: "translate(0,0)"
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333331",
    transform: "translate(0,0)"
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#31302F",
    transform: "translate(0,0)"
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3032",
    transform: "translate(0,0)"
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333332",
    transform: "translate(0,0)"
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333136",
    transform: "translate(0,0)"
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303133",
    transform: "translate(0,0)"
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343133",
    transform: "translate(0,0)"
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343535",
    transform: "translate(0,0)"
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353334",
    transform: "translate(0,0)"
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323135",
    transform: "translate(0,0)"
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323234",
    transform: "translate(0,0)"
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333234",
    transform: "translate(0,0)"
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C403F",
    transform: "translate(0,0)"
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353537",
    transform: "translate(0,0)"
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323231",
    transform: "translate(0,0)"
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363433",
    transform: "translate(0,0)"
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313434",
    transform: "translate(0,0)"
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#342F33",
    transform: "translate(0,0)"
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313131",
    transform: "translate(0,0)"
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2F2F",
    transform: "translate(0,0)"
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313231",
    transform: "translate(0,0)"
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333433",
    transform: "translate(0,0)"
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343233",
    transform: "translate(0,0)"
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353334",
    transform: "translate(0,0)"
  })), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3839",
    transform: "translate(0,0)"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3D40",
    transform: "translate(0,0)"
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303231",
    transform: "translate(0,0)"
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E3030",
    transform: "translate(0,0)"
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323134",
    transform: "translate(0,0)"
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343235",
    transform: "translate(0,0)"
  })), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323432",
    transform: "translate(0,0)"
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313133",
    transform: "translate(0,0)"
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323231",
    transform: "translate(0,0)"
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343537",
    transform: "translate(0,0)"
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313134",
    transform: "translate(0,0)"
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373436",
    transform: "translate(0,0)"
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333332",
    transform: "translate(0,0)"
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393638",
    transform: "translate(0,0)"
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393837",
    transform: "translate(0,0)"
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353637",
    transform: "translate(0,0)"
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373637",
    transform: "translate(0,0)"
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#39383A",
    transform: "translate(0,0)"
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343436",
    transform: "translate(0,0)"
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F2F",
    transform: "translate(0,0)"
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353436",
    transform: "translate(0,0)"
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3D3D",
    transform: "translate(0,0)"
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313230",
    transform: "translate(0,0)"
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333032",
    transform: "translate(0,0)"
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303435",
    transform: "translate(0,0)"
  })), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333533",
    transform: "translate(0,0)"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343235",
    transform: "translate(0,0)"
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343336",
    transform: "translate(0,0)"
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353437",
    transform: "translate(0,0)"
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353436",
    transform: "translate(0,0)"
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373737",
    transform: "translate(0,0)"
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#39393B",
    transform: "translate(0,0)"
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2D2E",
    transform: "translate(0,0)"
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323032",
    transform: "translate(0,0)"
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3C3C",
    transform: "translate(0,0)"
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#30302F",
    transform: "translate(0,0)"
  })), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363737",
    transform: "translate(0,0)"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343333",
    transform: "translate(0,0)"
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353334",
    transform: "translate(0,0)"
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353335",
    transform: "translate(0,0)"
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313131",
    transform: "translate(0,0)"
  })), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3A",
    transform: "translate(0,0)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373737",
    transform: "translate(0,0)"
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343332",
    transform: "translate(0,0)"
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333135",
    transform: "translate(0,0)"
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343535",
    transform: "translate(0,0)"
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2E31",
    transform: "translate(0,0)"
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302E2E",
    transform: "translate(0,0)"
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353434",
    transform: "translate(0,0)"
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363636",
    transform: "translate(0,0)"
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323131",
    transform: "translate(0,0)"
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313030",
    transform: "translate(0,0)"
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363636",
    transform: "translate(0,0)"
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#322F32",
    transform: "translate(0,0)"
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3D",
    transform: "translate(0,0)"
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393839",
    transform: "translate(0,0)"
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373636",
    transform: "translate(0,0)"
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F31",
    transform: "translate(0,0)"
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333335",
    transform: "translate(0,0)"
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313134",
    transform: "translate(0,0)"
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323331",
    transform: "translate(0,0)"
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3D3B",
    transform: "translate(0,0)"
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343334",
    transform: "translate(0,0)"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303030",
    transform: "translate(0,0)"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343534",
    transform: "translate(0,0)"
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#292929",
    transform: "translate(0,0)"
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323131",
    transform: "translate(0,0)"
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#312F30",
    transform: "translate(0,0)"
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303234",
    transform: "translate(0,0)"
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#30322F",
    transform: "translate(0,0)"
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F2F",
    transform: "translate(0,0)"
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333231",
    transform: "translate(0,0)"
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353537",
    transform: "translate(0,0)"
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303033",
    transform: "translate(0,0)"
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333133",
    transform: "translate(0,0)"
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#30312F",
    transform: "translate(0,0)"
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363636",
    transform: "translate(0,0)"
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343234",
    transform: "translate(0,0)"
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343433",
    transform: "translate(0,0)"
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323030",
    transform: "translate(0,0)"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363738",
    transform: "translate(0,0)"
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353636",
    transform: "translate(0,0)"
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393A38",
    transform: "translate(0,0)"
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303233",
    transform: "translate(0,0)"
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3838",
    transform: "translate(0,0)"
  })), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393738",
    transform: "translate(0,0)"
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343433",
    transform: "translate(0,0)"
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A373A",
    transform: "translate(0,0)"
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C393B",
    transform: "translate(0,0)"
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F2F",
    transform: "translate(0,0)"
  })), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313332",
    transform: "translate(0,0)"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2E2F",
    transform: "translate(0,0)"
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323332",
    transform: "translate(0,0)"
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3131",
    transform: "translate(0,0)"
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373736",
    transform: "translate(0,0)"
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353838",
    transform: "translate(0,0)"
  })), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383838",
    transform: "translate(0,0)"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323333",
    transform: "translate(0,0)"
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353535",
    transform: "translate(0,0)"
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353533",
    transform: "translate(0,0)"
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323534",
    transform: "translate(0,0)"
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2E2D",
    transform: "translate(0,0)"
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363736",
    transform: "translate(0,0)"
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363737",
    transform: "translate(0,0)"
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333435",
    transform: "translate(0,0)"
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323232",
    transform: "translate(0,0)"
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373738",
    transform: "translate(0,0)"
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333434",
    transform: "translate(0,0)"
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333436",
    transform: "translate(0,0)"
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363737",
    transform: "translate(0,0)"
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333031",
    transform: "translate(0,0)"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#312F30",
    transform: "translate(0,0)"
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313331",
    transform: "translate(0,0)"
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303031",
    transform: "translate(0,0)"
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303132",
    transform: "translate(0,0)"
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343031",
    transform: "translate(0,0)"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333234",
    transform: "translate(0,0)"
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353435",
    transform: "translate(0,0)"
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313233",
    transform: "translate(0,0)"
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343434",
    transform: "translate(0,0)"
  })), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333535",
    transform: "translate(0,0)"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343636",
    transform: "translate(0,0)"
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B38",
    transform: "translate(0,0)"
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373937",
    transform: "translate(0,0)"
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3A",
    transform: "translate(0,0)"
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383838",
    transform: "translate(0,0)"
  })), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3C3C",
    transform: "translate(0,0)"
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353536",
    transform: "translate(0,0)"
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383434",
    transform: "translate(0,0)"
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3A",
    transform: "translate(0,0)"
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333435",
    transform: "translate(0,0)"
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3F3F",
    transform: "translate(0,0)"
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3B",
    transform: "translate(0,0)"
  })), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#39383B",
    transform: "translate(0,0)"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373637",
    transform: "translate(0,0)"
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353535",
    transform: "translate(0,0)"
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323234",
    transform: "translate(0,0)"
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3837",
    transform: "translate(0,0)"
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3B",
    transform: "translate(0,0)"
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#39393A",
    transform: "translate(0,0)"
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F33",
    transform: "translate(0,0)"
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3B",
    transform: "translate(0,0)"
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383937",
    transform: "translate(0,0)"
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3A3C",
    transform: "translate(0,0)"
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3B3C",
    transform: "translate(0,0)"
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353537",
    transform: "translate(0,0)"
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3A",
    transform: "translate(0,0)"
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343634",
    transform: "translate(0,0)"
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323334",
    transform: "translate(0,0)"
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3A",
    transform: "translate(0,0)"
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343535",
    transform: "translate(0,0)"
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333132",
    transform: "translate(0,0)"
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363534",
    transform: "translate(0,0)"
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353435",
    transform: "translate(0,0)"
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3F",
    transform: "translate(0,0)"
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323330",
    transform: "translate(0,0)"
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404141",
    transform: "translate(0,0)"
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#454546",
    transform: "translate(0,0)"
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3B",
    transform: "translate(0,0)"
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333233",
    transform: "translate(0,0)"
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3B",
    transform: "translate(0,0)"
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2E2F",
    transform: "translate(0,0)"
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A393C",
    transform: "translate(0,0)"
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3D3C",
    transform: "translate(0,0)"
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353637",
    transform: "translate(0,0)"
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#414242",
    transform: "translate(0,0)"
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B38",
    transform: "translate(0,0)"
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393B3C",
    transform: "translate(0,0)"
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393636",
    transform: "translate(0,0)"
  })), _path1522 || (_path1522 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3D3C",
    transform: "translate(0,0)"
  })), _path1523 || (_path1523 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323433",
    transform: "translate(0,0)"
  })), _path1524 || (_path1524 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3D3D",
    transform: "translate(0,0)"
  })), _path1525 || (_path1525 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333131",
    transform: "translate(0,0)"
  })), _path1526 || (_path1526 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3B3C",
    transform: "translate(0,0)"
  })), _path1527 || (_path1527 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3D3B",
    transform: "translate(0,0)"
  })), _path1528 || (_path1528 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323032",
    transform: "translate(0,0)"
  })), _path1529 || (_path1529 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333132",
    transform: "translate(0,0)"
  })), _path1530 || (_path1530 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313232",
    transform: "translate(0,0)"
  })), _path1531 || (_path1531 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343134",
    transform: "translate(0,0)"
  })), _path1532 || (_path1532 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3D3D",
    transform: "translate(0,0)"
  })), _path1533 || (_path1533 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323435",
    transform: "translate(0,0)"
  })), _path1534 || (_path1534 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323233",
    transform: "translate(0,0)"
  })), _path1535 || (_path1535 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1536 || (_path1536 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1537 || (_path1537 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353434",
    transform: "translate(0,0)"
  })), _path1538 || (_path1538 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323235",
    transform: "translate(0,0)"
  })), _path1539 || (_path1539 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3D3B",
    transform: "translate(0,0)"
  })), _path1540 || (_path1540 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3C3D",
    transform: "translate(0,0)"
  })), _path1541 || (_path1541 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3938",
    transform: "translate(0,0)"
  })), _path1542 || (_path1542 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343433",
    transform: "translate(0,0)"
  })), _path1543 || (_path1543 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#302F30",
    transform: "translate(0,0)"
  })), _path1544 || (_path1544 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333033",
    transform: "translate(0,0)"
  })), _path1545 || (_path1545 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333433",
    transform: "translate(0,0)"
  })), _path1546 || (_path1546 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path1547 || (_path1547 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393939",
    transform: "translate(0,0)"
  })), _path1548 || (_path1548 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3B",
    transform: "translate(0,0)"
  })), _path1549 || (_path1549 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3D3A",
    transform: "translate(0,0)"
  })), _path1550 || (_path1550 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323031",
    transform: "translate(0,0)"
  })), _path1551 || (_path1551 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383A3B",
    transform: "translate(0,0)"
  })), _path1552 || (_path1552 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313230",
    transform: "translate(0,0)"
  })), _path1553 || (_path1553 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F33",
    transform: "translate(0,0)"
  })), _path1554 || (_path1554 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3939",
    transform: "translate(0,0)"
  })), _path1555 || (_path1555 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path1556 || (_path1556 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1557 || (_path1557 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383939",
    transform: "translate(0,0)"
  })), _path1558 || (_path1558 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1559 || (_path1559 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F2F",
    transform: "translate(0,0)"
  })), _path1560 || (_path1560 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2F2F",
    transform: "translate(0,0)"
  })), _path1561 || (_path1561 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3C3F",
    transform: "translate(0,0)"
  })), _path1562 || (_path1562 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393A39",
    transform: "translate(0,0)"
  })), _path1563 || (_path1563 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#332F31",
    transform: "translate(0,0)"
  })), _path1564 || (_path1564 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393939",
    transform: "translate(0,0)"
  })), _path1565 || (_path1565 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333334",
    transform: "translate(0,0)"
  })), _path1566 || (_path1566 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313231",
    transform: "translate(0,0)"
  })), _path1567 || (_path1567 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3D",
    transform: "translate(0,0)"
  })), _path1568 || (_path1568 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393838",
    transform: "translate(0,0)"
  })), _path1569 || (_path1569 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333234",
    transform: "translate(0,0)"
  })), _path1570 || (_path1570 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F2F",
    transform: "translate(0,0)"
  })), _path1571 || (_path1571 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2D2E2E",
    transform: "translate(0,0)"
  })), _path1572 || (_path1572 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3A",
    transform: "translate(0,0)"
  })), _path1573 || (_path1573 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3B3A",
    transform: "translate(0,0)"
  })), _path1574 || (_path1574 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383938",
    transform: "translate(0,0)"
  })), _path1575 || (_path1575 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3F40",
    transform: "translate(0,0)"
  })), _path1576 || (_path1576 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#322F31",
    transform: "translate(0,0)"
  })), _path1577 || (_path1577 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333134",
    transform: "translate(0,0)"
  })), _path1578 || (_path1578 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363535",
    transform: "translate(0,0)"
  })), _path1579 || (_path1579 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353337",
    transform: "translate(0,0)"
  })), _path1580 || (_path1580 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3B3D",
    transform: "translate(0,0)"
  })), _path1581 || (_path1581 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3C3B",
    transform: "translate(0,0)"
  })), _path1582 || (_path1582 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3B3A",
    transform: "translate(0,0)"
  })), _path1583 || (_path1583 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333132",
    transform: "translate(0,0)"
  })), _path1584 || (_path1584 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3B3D",
    transform: "translate(0,0)"
  })), _path1585 || (_path1585 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path1586 || (_path1586 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B393C",
    transform: "translate(0,0)"
  })), _path1587 || (_path1587 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3E",
    transform: "translate(0,0)"
  })), _path1588 || (_path1588 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313132",
    transform: "translate(0,0)"
  })), _path1589 || (_path1589 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323432",
    transform: "translate(0,0)"
  })), _path1590 || (_path1590 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3F3E",
    transform: "translate(0,0)"
  })), _path1591 || (_path1591 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3030",
    transform: "translate(0,0)"
  })), _path1592 || (_path1592 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303032",
    transform: "translate(0,0)"
  })), _path1593 || (_path1593 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343534",
    transform: "translate(0,0)"
  })), _path1594 || (_path1594 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path1595 || (_path1595 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363635",
    transform: "translate(0,0)"
  })), _path1596 || (_path1596 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303131",
    transform: "translate(0,0)"
  })), _path1597 || (_path1597 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333235",
    transform: "translate(0,0)"
  })), _path1598 || (_path1598 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383738",
    transform: "translate(0,0)"
  })), _path1599 || (_path1599 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#30302F",
    transform: "translate(0,0)"
  })), _path1600 || (_path1600 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323234",
    transform: "translate(0,0)"
  })), _path1601 || (_path1601 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313031",
    transform: "translate(0,0)"
  })), _path1602 || (_path1602 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313135",
    transform: "translate(0,0)"
  })), _path1603 || (_path1603 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F2F30",
    transform: "translate(0,0)"
  })), _path1604 || (_path1604 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3D3B",
    transform: "translate(0,0)"
  })), _path1605 || (_path1605 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path1606 || (_path1606 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323134",
    transform: "translate(0,0)"
  })), _path1607 || (_path1607 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3C",
    transform: "translate(0,0)"
  })), _path1608 || (_path1608 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343232",
    transform: "translate(0,0)"
  })), _path1609 || (_path1609 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343235",
    transform: "translate(0,0)"
  })), _path1610 || (_path1610 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#303231",
    transform: "translate(0,0)"
  })), _path1611 || (_path1611 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3A3C",
    transform: "translate(0,0)"
  })), _path1612 || (_path1612 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393A3A",
    transform: "translate(0,0)"
  })), _path1613 || (_path1613 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#38373C",
    transform: "translate(0,0)"
  })), _path1614 || (_path1614 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2C2F",
    transform: "translate(0,0)"
  })), _path1615 || (_path1615 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383A39",
    transform: "translate(0,0)"
  })), _path1616 || (_path1616 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393A38",
    transform: "translate(0,0)"
  })), _path1617 || (_path1617 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3A3A",
    transform: "translate(0,0)"
  })), _path1618 || (_path1618 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353435",
    transform: "translate(0,0)"
  })), _path1619 || (_path1619 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3A3B",
    transform: "translate(0,0)"
  })), _path1620 || (_path1620 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3A",
    transform: "translate(0,0)"
  })), _path1621 || (_path1621 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#38373B",
    transform: "translate(0,0)"
  })), _path1622 || (_path1622 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333331",
    transform: "translate(0,0)"
  })), _path1623 || (_path1623 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3B3D",
    transform: "translate(0,0)"
  })), _path1624 || (_path1624 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313133",
    transform: "translate(0,0)"
  })), _path1625 || (_path1625 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323434",
    transform: "translate(0,0)"
  })), _path1626 || (_path1626 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353636",
    transform: "translate(0,0)"
  })), _path1627 || (_path1627 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363637",
    transform: "translate(0,0)"
  })), _path1628 || (_path1628 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313032",
    transform: "translate(0,0)"
  })), _path1629 || (_path1629 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B393B",
    transform: "translate(0,0)"
  })), _path1630 || (_path1630 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333536",
    transform: "translate(0,0)"
  })), _path1631 || (_path1631 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333132",
    transform: "translate(0,0)"
  })), _path1632 || (_path1632 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2E2D2D",
    transform: "translate(0,0)"
  })), _path1633 || (_path1633 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3C3C",
    transform: "translate(0,0)"
  })), _path1634 || (_path1634 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C3B3C",
    transform: "translate(0,0)"
  })), _path1635 || (_path1635 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3C383A",
    transform: "translate(0,0)"
  })), _path1636 || (_path1636 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A383A",
    transform: "translate(0,0)"
  })), _path1637 || (_path1637 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393838",
    transform: "translate(0,0)"
  })), _path1638 || (_path1638 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#38363A",
    transform: "translate(0,0)"
  })), _path1639 || (_path1639 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A39",
    transform: "translate(0,0)"
  })), _path1640 || (_path1640 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393939",
    transform: "translate(0,0)"
  })), _path1641 || (_path1641 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3C3A",
    transform: "translate(0,0)"
  })), _path1642 || (_path1642 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A3E",
    transform: "translate(0,0)"
  })), _path1643 || (_path1643 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3A39",
    transform: "translate(0,0)"
  })), _path1644 || (_path1644 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3C3B",
    transform: "translate(0,0)"
  })), _path1645 || (_path1645 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3B3B",
    transform: "translate(0,0)"
  })), _path1646 || (_path1646 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393836",
    transform: "translate(0,0)"
  })), _path1647 || (_path1647 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323132",
    transform: "translate(0,0)"
  })), _path1648 || (_path1648 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3D3D",
    transform: "translate(0,0)"
  })), _path1649 || (_path1649 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3D3C3C",
    transform: "translate(0,0)"
  })), _path1650 || (_path1650 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3E3C3D",
    transform: "translate(0,0)"
  })), _path1651 || (_path1651 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A39",
    transform: "translate(0,0)"
  })), _path1652 || (_path1652 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343335",
    transform: "translate(0,0)"
  })), _path1653 || (_path1653 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3B3A",
    transform: "translate(0,0)"
  })), _path1654 || (_path1654 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373736",
    transform: "translate(0,0)"
  })), _path1655 || (_path1655 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333433",
    transform: "translate(0,0)"
  })), _path1656 || (_path1656 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393838",
    transform: "translate(0,0)"
  })), _path1657 || (_path1657 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343233",
    transform: "translate(0,0)"
  })), _path1658 || (_path1658 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#39383A",
    transform: "translate(0,0)"
  })), _path1659 || (_path1659 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3F3E3E",
    transform: "translate(0,0)"
  })), _path1660 || (_path1660 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3B3A38",
    transform: "translate(0,0)"
  })), _path1661 || (_path1661 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313333",
    transform: "translate(0,0)"
  })), _path1662 || (_path1662 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393839",
    transform: "translate(0,0)"
  })), _path1663 || (_path1663 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333232",
    transform: "translate(0,0)"
  })), _path1664 || (_path1664 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363537",
    transform: "translate(0,0)"
  })), _path1665 || (_path1665 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393A3B",
    transform: "translate(0,0)"
  })), _path1666 || (_path1666 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393736",
    transform: "translate(0,0)"
  })), _path1667 || (_path1667 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393938",
    transform: "translate(0,0)"
  })), _path1668 || (_path1668 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393736",
    transform: "translate(0,0)"
  })), _path1669 || (_path1669 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363734",
    transform: "translate(0,0)"
  })), _path1670 || (_path1670 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#31302F",
    transform: "translate(0,0)"
  })), _path1671 || (_path1671 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393837",
    transform: "translate(0,0)"
  })), _path1672 || (_path1672 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393738",
    transform: "translate(0,0)"
  })), _path1673 || (_path1673 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313133",
    transform: "translate(0,0)"
  })), _path1674 || (_path1674 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363537",
    transform: "translate(0,0)"
  })), _path1675 || (_path1675 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373936",
    transform: "translate(0,0)"
  })), _path1676 || (_path1676 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#2F3130",
    transform: "translate(0,0)"
  })), _path1677 || (_path1677 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#323330",
    transform: "translate(0,0)"
  })), _path1678 || (_path1678 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343232",
    transform: "translate(0,0)"
  })), _path1679 || (_path1679 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#313334",
    transform: "translate(0,0)"
  })), _path1680 || (_path1680 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373435",
    transform: "translate(0,0)"
  })), _path1681 || (_path1681 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363535",
    transform: "translate(0,0)"
  })), _path1682 || (_path1682 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353434",
    transform: "translate(0,0)"
  })), _path1683 || (_path1683 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#333333",
    transform: "translate(0,0)"
  })), _path1684 || (_path1684 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383937",
    transform: "translate(0,0)"
  })), _path1685 || (_path1685 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353535",
    transform: "translate(0,0)"
  })), _path1686 || (_path1686 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353635",
    transform: "translate(0,0)"
  })), _path1687 || (_path1687 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383639",
    transform: "translate(0,0)"
  })), _path1688 || (_path1688 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383739",
    transform: "translate(0,0)"
  })), _path1689 || (_path1689 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#36383A",
    transform: "translate(0,0)"
  })), _path1690 || (_path1690 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#393939",
    transform: "translate(0,0)"
  })), _path1691 || (_path1691 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#38393B",
    transform: "translate(0,0)"
  })), _path1692 || (_path1692 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#353738",
    transform: "translate(0,0)"
  })), _path1693 || (_path1693 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373537",
    transform: "translate(0,0)"
  })), _path1694 || (_path1694 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383737",
    transform: "translate(0,0)"
  })), _path1695 || (_path1695 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363738",
    transform: "translate(0,0)"
  })), _path1696 || (_path1696 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373736",
    transform: "translate(0,0)"
  })), _path1697 || (_path1697 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#343535",
    transform: "translate(0,0)"
  })), _path1698 || (_path1698 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#383838",
    transform: "translate(0,0)"
  })), _path1699 || (_path1699 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#3A3C39",
    transform: "translate(0,0)"
  })), _path1700 || (_path1700 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#373836",
    transform: "translate(0,0)"
  })), _path1701 || (_path1701 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#363837",
    transform: "translate(0,0)"
  })), _path1702 || (_path1702 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#464748",
    transform: "translate(0,0)"
  })), _path1703 || (_path1703 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#404140",
    transform: "translate(0,0)"
  })), _path1704 || (_path1704 = /*#__PURE__*/React.createElement("path", {
    d: "",
    fill: "#494848",
    transform: "translate(0,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNdgLogoOfficialSvg);
export default __webpack_public_path__ + "static/media/ndg_logo_official_svg.25937a9669cc334c64db4bf27bf5c09d.svg";
export { ForwardRef as ReactComponent };